webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__http__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);




__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1__http__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  Login: function Login(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.post('/client/login', params);
  },
  Logout: function Logout(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.delete('/client/logout/' + id);
  },
  FetchDashboardBox: function FetchDashboardBox(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/dashboard/type/1/index/1', {
      params: params
    });
  },
  FetchDashboardChart1: function FetchDashboardChart1() {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/analytics/customer/tab/6/type/chart');
  },
  FetchDashboardChart2: function FetchDashboardChart2() {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/analytics/customer/tab/4/type/chart');
  },
  FetchDashboardChart3: function FetchDashboardChart3() {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/analytics/trx/tab/1/type/chart');
  },
  FetchDashboardChart4: function FetchDashboardChart4() {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/analytics/trx/tab/4/type/chart');
  },
  FetchAnalyticsTransactionsTabABox: function FetchAnalyticsTransactionsTabABox() {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/analytics/trx/tab/1/type/number');
  },
  FetchAnalyticsTransactionsTabAChart: function FetchAnalyticsTransactionsTabAChart() {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/analytics/trx/tab/1/type/chart');
  },
  FetchAnalyticsTransactionsTabBChart: function FetchAnalyticsTransactionsTabBChart() {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/analytics/trx/tab/2/type/chart');
  },
  FetchAnalyticsTransactionsTabCChart: function FetchAnalyticsTransactionsTabCChart() {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/analytics/trx/tab/3/type/chart');
  },
  FetchAnalyticsOutletsTabAChart: function FetchAnalyticsOutletsTabAChart() {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/analytics/outlet/tab/1');
  },
  FetchAnalyticsOutletsTabBChart: function FetchAnalyticsOutletsTabBChart() {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/analytics/outlet/tab/2');
  },
  FetchAnalyticsCustomersTabABox: function FetchAnalyticsCustomersTabABox() {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/analytics/customer/tab/1/type/number');
  },
  FetchAnalyticsCustomersTabAChart: function FetchAnalyticsCustomersTabAChart() {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/analytics/customer/tab/1/type/chart');
  },
  FetchAnalyticsCustomersTabBChart: function FetchAnalyticsCustomersTabBChart() {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/analytics/customer/tab/3/type/chart');
  },
  FetchAnalyticsCustomersTabDChart: function FetchAnalyticsCustomersTabDChart() {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/analytics/customer/tab/4/type/chart');
  },
  FetchOutletsTable: function FetchOutletsTable(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/outlets', {
      params: params
    });
  },
  FetchOutletById: function FetchOutletById(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/outlets/' + id);
  },
  SaveNewOutlet: function SaveNewOutlet(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.post('/client/outlets', params);
  },
  UpdateOutlet: function UpdateOutlet(id, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.put('/client/outlets/' + id, params);
  },
  DeleteOutlet: function DeleteOutlet(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.delete('/client/outlets/' + id);
  },
  FetchAccountsTable: function FetchAccountsTable(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/account', {
      params: params
    });
  },
  FetchAccountById: function FetchAccountById(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/account/' + id);
  },
  SaveNewAccount: function SaveNewAccount(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.post('/client/account', params);
  },
  DeleteAccount: function DeleteAccount(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.delete('/client/account/' + id);
  },
  UpdateAccount: function UpdateAccount(id, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.put('/client/account/' + id, params);
  },
  FetchTrxTable: function FetchTrxTable(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/trx', {
      params: params
    });
  },
  FetchTrxCondition: function FetchTrxCondition() {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/trx/condition');
  },
  DownloadTrxTable: function DownloadTrxTable(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios({
      method: 'get',
      url: '/client/trx',
      responseType: 'arraybuffer',
      params: params
    });
  },
  FetchTrxById: function FetchTrxById(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/trx/' + id);
  },
  FetchCustomerTable: function FetchCustomerTable(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/customer', {
      params: params
    });
  },
  RefundTrxAmount: function RefundTrxAmount(id, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.post('/client/refund/' + id, params);
  },
  FetchRefundTable: function FetchRefundTable(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/refund', {
      params: params
    });
  },
  DownloadRefundTable: function DownloadRefundTable(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios({
      method: 'get',
      url: '/client/refund',
      responseType: 'arraybuffer',
      params: params
    });
  },
  FetchRefundById: function FetchRefundById(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/refund/' + id);
  },
  FetchQrCode: function FetchQrCode() {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/settings/qrcode');
  },
  CheckDownloadQrcodeZip: function CheckDownloadQrcodeZip(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios({
      method: 'get',
      url: '/client/settings/qrcode?download=zip',
      params: params
    });
  },
  DownloadQrcodeZip: function DownloadQrcodeZip(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios({
      method: 'get',
      url: '/client/settings/qrcode?download=zip',
      responseType: 'arraybuffer',
      params: params
    });
  },
  DowndloadQrcodePDF: function DowndloadQrcodePDF(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios({
      method: 'get',
      url: '/client/settings/qrcode',
      responseType: 'arraybuffer',
      params: params
    });
  },
  DownLoadQrcode: function DownLoadQrcode(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios({
      method: 'get',
      url: '/client/getImage',
      params: params
    });
  },
  FetchSettleTable: function FetchSettleTable(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/settlement', {
      params: params
    });
  },
  DownloadSettleTable: function DownloadSettleTable(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios({
      method: 'get',
      url: '/client/settlement',
      responseType: 'arraybuffer',
      params: params
    });
  },
  DownloadStatement: function DownloadStatement(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios({
      method: 'get',
      url: '/client/settlement/' + id,
      responseType: 'arraybuffer'
    });
  },
  FetchInvoiceTable: function FetchInvoiceTable(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/invoice', {
      params: params
    });
  },
  FetchChannel: function FetchChannel() {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/channel');
  },
  UpdateChannel: function UpdateChannel(id, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.put('/client/channel/' + id, params);
  },
  DeleteChannel: function DeleteChannel(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.delete('/client/channel/' + id);
  },
  ActiveChannel: function ActiveChannel(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.post('/client/channel/' + id);
  },
  ShowChannel: function ShowChannel() {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/showchannel');
  },
  UpdatePassword: function UpdatePassword(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.post('/client/settings/password', params);
  },
  UpdateRefundPassword: function UpdateRefundPassword(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.post('/client/settings/refundPassword', params);
  },
  ResetPassword: function ResetPassword(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.post('/client/settings/password/action/resetpassword', params);
  },
  FetchAgreementList: function FetchAgreementList() {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/initchannel');
  },
  PostAgreement: function PostAgreement(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.post('/client/initchannel/' + id);
  },
  PostSign: function PostSign() {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.put('/client/user/action/sign');
  },
  showRefundDetail: function showRefundDetail() {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/refundDetail');
  },
  FetchContract: function FetchContract(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/contract', {
      params: params
    });
  },
  FetchContractFile: function FetchContractFile(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios({
      method: 'get',
      url: '/client/getFile',
      responseType: 'arraybuffer',
      params: params
    });
  },
  FinishOnboarding: function FinishOnboarding() {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.put('/client/user/action/finishonboarding');
  },
  FetchCouponList: function FetchCouponList(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/coupon', {
      params: params
    });
  },
  FetchCouponType: function FetchCouponType() {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/coupontype');
  },
  FetchCouponById: function FetchCouponById(id) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/coupontype/' + id);
  },
  FetchCouponNameById: function FetchCouponNameById(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/couponname', {
      params: params
    });
  },
  PublishCoupon: function PublishCoupon(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.post('/client/coupon', params);
  },
  agreeCoupon: function agreeCoupon(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.put('/client/agreecoupon', params);
  },
  changeLanguage: function changeLanguage(params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.post('/client/settings/language', params);
  },
  getMenu: function getMenu() {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/menu');
  },
  ckeckCouponStatus: function ckeckCouponStatus() {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.get('/client/couponstatus');
  },
  changeRemark: function changeRemark(trxId, params) {
    return __WEBPACK_IMPORTED_MODULE_0_vue___default.a.axios.put('/client/trx/' + trxId, params);
  }
});

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LOGIN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SIGNIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return SIGNOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return RESIGN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return SLIDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return NAVINFO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ACTIVETIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return ISSIGN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SETFEE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CHANGETHEME; });
/* unused harmony export SETCONDITION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AGENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return AGREECOUPON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return CHANGELANG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SetTrxListTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return InitTrxListTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SetRefundTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return InitRefundTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SetSettleTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return InitSettleTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SetAccountTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return InitAccountTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SetStoreTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return InitStoreTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SetInvoiceTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return InitInvoiceTable; });


var LOGIN = 'USER_LOGIN';

var SIGNIN = 'SIGN_IN';
var SIGNOUT = 'SIGN_OUT';

var RESIGN = 'SIGN_REPLACE';

var SLIDER = 'SET_SLIDER';

var NAVINFO = 'FETCH_NAV_INFO';

var ACTIVETIME = 'FETCH_ACTIVE_TIME';

var ISSIGN = 'USER_SIGN';
var SETFEE = 'SET_SERVICE_FEE';

var CHANGETHEME = 'CHANGE_WEB_THEME';

var SETCONDITION = 'SET_TABLE_CONDITION';

var AGENT = "USER_AGENT";

var AGREECOUPON = "AGREE_COUPON";

var CHANGELANG = "CHANGE_LANG";

var SetTrxListTable = "SET_TRXLIST_TABLE";
var InitTrxListTable = "INIT_TRXLIST_TABLE";

var SetRefundTable = "SET_REFUNDS_TABLE";
var InitRefundTable = "INIT_REFUNDS_TABLE";

var SetSettleTable = "SET_SETTLE_TABLE";
var InitSettleTable = "INIT_SETTLE_TABLE";

var SetAccountTable = "SET_ACCOUNTS_TABLE";
var InitAccountTable = "INIT_ACCOUNTS_TABLE";

var SetStoreTable = "SET_STORES_TABLE";
var InitStoreTable = "INIT_STORES_TABLE";

var SetInvoiceTable = "SET_INVOICES_TABLE";
var InitInvoiceTable = "INIT_INVOICES_TABLE";

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_user__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_nav__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_switcher__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_theme__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_userAgent__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_trx_list__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_accounts__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_stores__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_invoices__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_refunds__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_settlements__ = __webpack_require__(495);















var debug = "production" !== 'production';
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    user: __WEBPACK_IMPORTED_MODULE_2__modules_user__["a" /* default */],
    nav: __WEBPACK_IMPORTED_MODULE_3__modules_nav__["a" /* default */],
    switcher: __WEBPACK_IMPORTED_MODULE_4__modules_switcher__["a" /* default */],
    theme: __WEBPACK_IMPORTED_MODULE_5__modules_theme__["a" /* default */],
    userAgent: __WEBPACK_IMPORTED_MODULE_6__modules_userAgent__["a" /* default */],
    trxList: __WEBPACK_IMPORTED_MODULE_7__modules_trx_list__["a" /* default */],
    accounts: __WEBPACK_IMPORTED_MODULE_8__modules_accounts__["a" /* default */],
    stores: __WEBPACK_IMPORTED_MODULE_9__modules_stores__["a" /* default */],
    invoices: __WEBPACK_IMPORTED_MODULE_10__modules_invoices__["a" /* default */],
    refunds: __WEBPACK_IMPORTED_MODULE_11__modules_refunds__["a" /* default */],
    settlements: __WEBPACK_IMPORTED_MODULE_12__modules_settlements__["a" /* default */]
  },
  strict: debug
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_moment_timezone_with_data_2010_2020_min_js__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_moment_timezone_with_data_2010_2020_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__static_moment_timezone_with_data_2010_2020_min_js__);



__WEBPACK_IMPORTED_MODULE_0_moment___default.a.updateLocale('zh-cn', {
  longDateFormat: {
    L: 'YYYY-MM-DD'
  }
});

__WEBPACK_IMPORTED_MODULE_0_moment___default.a.updateLocale('zh-cn', {
  longDateFormat: {
    LT: 'YYYY-MM-DD HH:mm:ss'
  }
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_moment___default.a);

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "singleBar", function() { return singleBar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bar", function() { return bar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "area", function() { return area; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "line", function() { return line; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pie", function() { return pie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NoLegendPie", function() { return NoLegendPie; });
/* harmony export (immutable) */ __webpack_exports__["getPieOption"] = getPieOption;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "doublePie", function() { return doublePie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "doubleLine", function() { return doubleLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "multipleArea", function() { return multipleArea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "multipleLine", function() { return multipleLine; });
/* harmony export (immutable) */ __webpack_exports__["getMultipleLineOption"] = getMultipleLineOption;
/* harmony export (immutable) */ __webpack_exports__["getMultipleAreaOption"] = getMultipleAreaOption;
/* harmony export (immutable) */ __webpack_exports__["getSinglePieOption"] = getSinglePieOption;
/* harmony export (immutable) */ __webpack_exports__["getDoublePieOption"] = getDoublePieOption;
/* harmony export (immutable) */ __webpack_exports__["getSingleBarOption"] = getSingleBarOption;
/* harmony export (immutable) */ __webpack_exports__["getBarOption"] = getBarOption;
/* harmony export (immutable) */ __webpack_exports__["getDoubleLineOption"] = getDoubleLineOption;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var singleBar = {
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'shadow'
    }
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true
  },
  legend: {
    orient: 'vertical',
    x: 'left',
    data: []
  },
  xAxis: [{
    type: 'category',
    data: [],
    axisTick: {
      alignWithLabel: true
    }
  }],
  yAxis: [{
    type: 'value'
  }],
  series: [{
    name: '',
    type: 'bar',
    barWidth: '30%',
    data: []
  }]
};

var bar = {
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      label: {
        backgroundColor: '#6a7985'
      }
    }
  },
  legend: {
    orient: 'vertical',
    x: 'left',
    data: []
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true
  },
  xAxis: {
    type: 'category',
    axisPointer: {
      type: 'shadow'
    },
    data: []
  },
  yAxis: {
    type: 'value'
  },
  series: [{
    name: '',
    type: 'bar',
    data: []
  }]
};

var area = {
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      label: {
        backgroundColor: '#6a7985'
      }
    }
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true
  },
  xAxis: [{
    type: 'category',
    boundaryGap: false,
    data: []
  }],
  yAxis: [{
    type: 'value'
  }],
  series: [{
    type: 'line',
    name: '',
    areaStyle: {
      normal: {}
    },
    data: []
  }]
};

var line = {
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      label: {
        backgroundColor: '#6a7985'
      }
    }
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true
  },
  xAxis: {
    type: 'category',
    boundaryGap: false,
    data: []
  },
  yAxis: [{
    type: 'value'
  }],
  series: [{
    name: '',
    type: 'line',
    data: []
  }]
};

var pie = {
  tooltip: {
    trigger: 'item',
    formatter: '{a} <br/>{b} : {c} ({d}%)'
  },
  legend: {
    orient: 'vertical',
    left: 'left',
    data: []
  },
  series: [{
    name: '',
    type: 'pie',
    radius: '55%',
    center: ['50%', '60%'],
    data: [],
    itemStyle: {
      emphasis: {
        shadowBlur: 10,
        shadowOffsetX: 0,
        shadowColor: 'rgba(0, 0, 0, 0.5)'
      }
    }
  }]
};

var NoLegendPie = {
  tooltip: {
    trigger: 'item',
    formatter: '{a} <br/>{b} : {c} ({d}%)'
  },
  series: {
    name: '',
    type: 'pie',
    radius: '65%',
    center: ['50%', '40%'],
    label: {
      normal: {
        show: false,
        position: 'right'
      }
    },
    data: []
  }
};

function getPieOption(data, config, name) {
  var defaultOp = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(config.NoLegendPie));
  defaultOp.series.name = name;
  defaultOp.series.data = data.map(function (item) {
    return {
      name: item.name,
      value: item.value
    };
  });
  return defaultOp;
}

var doublePie = {
  tooltip: {
    trigger: 'item',
    formatter: '{a} <br/>{b}: {c} ({d}%)'
  },
  legend: {
    orient: 'vertical',
    x: 'left',
    data: []
  },
  series: [{
    name: '',
    type: 'pie',
    selectedMode: 'single',
    radius: [0, '30%'],

    label: {
      normal: {
        position: 'inner'
      }
    },
    labelLine: {
      normal: {
        show: false
      }
    },
    data: []
  }, {
    name: '',
    type: 'pie',
    radius: ['40%', '55%'],
    data: []
  }]
};

var doubleLine = {
  tooltip: {
    trigger: 'axis'
  },
  xAxis: {
    type: 'category',
    boundaryGap: false,
    data: []
  },
  yAxis: [{
    type: 'value'
  }],
  series: [{
    name: '',
    type: 'line',
    data: []
  }, {
    name: '',
    type: 'line',
    data: []
  }]
};

var multipleArea = {
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      label: {
        backgroundColor: '#6a7985'
      }
    }
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true
  },
  xAxis: [{
    type: 'category',
    boundaryGap: false,
    data: []
  }],
  yAxis: [{
    type: 'value'
  }],
  series: []
};

var multipleLine = {
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      type: 'cross',
      label: {
        backgroundColor: '#6a7985'
      }
    }
  },
  grid: {
    left: '3%',
    right: '4%',
    bottom: '3%',
    containLabel: true
  },
  xAxis: [{
    type: 'category',
    boundaryGap: false,
    data: []
  }],
  yAxis: {
    type: 'value'
  },
  series: []
};

function getMultipleLineOption(data, config) {
  var defaultOp = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(config.multipleLine));
  defaultOp.xAxis[0].data = data.xAxis;
  defaultOp.series = data.yAxis.map(function (item) {
    return {
      name: item.name,
      data: item.value,
      type: 'line'
    };
  });
  return defaultOp;
}

function getMultipleAreaOption(data, config) {
  var defaultOp = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(config.multipleArea));
  defaultOp.xAxis[0].data = data.xAxis;
  defaultOp.series = data.yAxis.map(function (item) {
    return {
      name: item.name,
      data: item.value,
      type: 'line',
      areaStyle: {
        normal: {}
      }
    };
  });
  return defaultOp;
}

function getSinglePieOption(data, config) {
  var defaultOp = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(config.pie));
  defaultOp.legend.data = data.map(function (item) {
    return item.name;
  });
  defaultOp.series[0].data = data.map(function (item) {
    return {
      name: item.name,
      value: item.value
    };
  });
  return defaultOp;
}

function getDoublePieOption(data, config) {
  var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['', ''];

  var defaultOp = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(config.doublePie));
  defaultOp.legend.data = data.outer.map(function (item) {
    return item.name;
  });
  defaultOp.series[0].data = data.inner.map(function (item) {
    return {
      name: item.name,
      value: item.value
    };
  });
  defaultOp.series[0].name = name[0];

  defaultOp.series[1].data = data.outer.map(function (item) {
    return {
      name: item.name,
      value: item.value
    };
  });
  defaultOp.series[1].name = name[1];

  return defaultOp;
}

function getSingleBarOption(data, config) {
  var defaultOp = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(config.bar));
  defaultOp.legend.data = data.yAxis.map(function (item) {
    return item.name;
  });
  defaultOp.xAxis.data = data.xAxis;
  defaultOp.series = data.yAxis.map(function (item) {
    return {
      name: item.name,
      data: item.value,
      stack: item.stack,
      type: 'bar'
    };
  });
  return defaultOp;
}

function getBarOption(data, config, name) {
  var defaultOp = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(config.bar));
  defaultOp.xAxis.data = data.xAxis;
  defaultOp.series[0].data = data.yAxis;
  defaultOp.series[0].name = name;
  return defaultOp;
}

function getDoubleLineOption(data, config) {
  var defaultOp = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(config.doubleLine));
  defaultOp.xAxis[0].data = data.xAxis;
  defaultOp.series = data.yAxis.map(function (item) {
    return {
      name: item.name,
      data: item.value,
      type: 'line'
    };
  });
  return defaultOp;
}

/***/ }),
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAGCAYAAADUtS5UAAAAAXNSR0IArs4c6QAAAFBJREFUKBVjZKAxmD59+n9sVjBhE6SHGMuMGTO2/v//3wtkGSMj47aMjAxvZIsplYeZBTQXzASaB6bRfYw1WGCagTSl8nCjGOEsGjEGXRwDABRRI5LiJIHcAAAAAElFTkSuQmCC"

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/qrcode.2d28d2c.png";

/***/ }),
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_types__ = __webpack_require__(10);







__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.timeout = 30000;
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.withCredentials = true;
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.defaults.headers = {
  'lang': __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.user.userinfo === null ? 'en' : __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.user.userinfo.lang
};

if (window.performance) {
  __WEBPACK_IMPORTED_MODULE_2_axios___default.a.interceptors.request.use(function (config) {
    config.apiStart = Math.round(performance.now());
    return config;
  }, function (error) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  });
}

__WEBPACK_IMPORTED_MODULE_2_axios___default.a.interceptors.response.use(function (response) {
  if (response.config.url.indexOf('login') === -1 && JSON.parse(window.store.get('userInfo')).id !== __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].state.user.userinfo.id) {
    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_5__store_types__["r" /* RESIGN */]);
  }
  if (window.performance) {
    __WEBPACK_IMPORTED_MODULE_1_vue___default.a.$ga.time('API', response.config.url, Math.round(performance.now()) - response.config.apiStart, window.location.host);
  }
  return response;
}, function (error) {
  if (error.response) {
    switch (error.response.status) {
      case 401:
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_5__store_types__["t" /* SIGNOUT */]);
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].replace({
          name: 'Login'
        });
        break;
      case 403:
        __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].replace({
          name: 'Dashboard'
        });
    }
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error.response.data);
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_2_axios___default.a);

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_i18n__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_zh_CN__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_zh_CN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_zh_CN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_th__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_th___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_th__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__(120);


var _this = this,
    _arguments = arguments;











var kv = [{
  id: 'en',
  value: __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en___default.a
}, {
  id: 'zh-CN',
  value: __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_zh_CN___default.a
}, {
  id: 'th',
  value: __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_th___default.a
}];

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]);

var lang = __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].state.user.userinfo === null ? 'en' : __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].state.user.userinfo.lang;

var _i18n = new __WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]({
  locale: lang,
  messages: {
    'en': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__webpack_require__(1184), __WEBPACK_IMPORTED_MODULE_4_element_ui_lib_locale_lang_en___default.a),
    'zh-CN': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__webpack_require__(1186), __WEBPACK_IMPORTED_MODULE_5_element_ui_lib_locale_lang_zh_CN___default.a),
    'th': __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(__webpack_require__(1185), __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_locale_lang_th___default.a)
  }
});

__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.find(kv, {
  'id': lang
}).value);

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_element_ui___default.a, {
  i18n: function i18n(key) {
    return _i18n.vm._t(key);
  }
});

if (false) {
  module.hot.accept(['./en/index.json', './zh-CN/index.json', './th/index.json'], function () {
    _i18n.setLocaleMessage('en', _Object$assign(require('./en/index.json'), enLocale));
    _i18n.setLocaleMessage('zh-CN', _Object$assign(require('./zh-CN/index.json'), zhLocale));
    _i18n.setLocaleMessage('th', _Object$assign(require('./th/index.json'), thLocale));
    console.log('hot reload', _this, _arguments);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (_i18n);

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_lang__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Dash__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Dash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Dash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_login__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pages_login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pages_login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_on_boarding_reset_password__ = __webpack_require__(1057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pages_on_boarding_reset_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_pages_on_boarding_reset_password__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_on_boarding_agreement__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_pages_on_boarding_agreement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_pages_on_boarding_agreement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_on_boarding_contract__ = __webpack_require__(1056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_pages_on_boarding_contract___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_pages_on_boarding_contract__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_on_boarding_service_fee__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_pages_on_boarding_service_fee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_pages_on_boarding_service_fee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_pages_dashboard__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_pages_dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_pages_dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_pages_transactions_transactions__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_pages_transactions_transactions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_pages_transactions_transactions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_pages_transactions_view_detail__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_pages_transactions_view_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_pages_transactions_view_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_pages_refunds_refunds__ = __webpack_require__(1059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_pages_refunds_refunds___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_pages_refunds_refunds__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_pages_refunds_view_detail__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_pages_refunds_view_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_pages_refunds_view_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_pages_customers_customers__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_pages_customers_customers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_pages_customers_customers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_pages_analytics_transactions__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_pages_analytics_transactions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_pages_analytics_transactions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_pages_analytics_customers__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_pages_analytics_customers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_pages_analytics_customers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_pages_analytics_outlets__ = __webpack_require__(1036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_pages_analytics_outlets___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_pages_analytics_outlets__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_pages_management_accounts_accounts__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_pages_management_accounts_accounts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_pages_management_accounts_accounts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_pages_management_accounts_add_new_account__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_pages_management_accounts_add_new_account___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_pages_management_accounts_add_new_account__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_pages_management_accounts_update_account__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_pages_management_accounts_update_account___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_pages_management_accounts_update_account__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_pages_management_outlets_outlets__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_pages_management_outlets_outlets___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_pages_management_outlets_outlets__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_pages_management_outlets_add_new_outlet__ = __webpack_require__(1051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_pages_management_outlets_add_new_outlet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_pages_management_outlets_add_new_outlet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_pages_management_outlets_view_detail__ = __webpack_require__(1054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_pages_management_outlets_view_detail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_pages_management_outlets_view_detail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_pages_management_outlets_update_outlet__ = __webpack_require__(1053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_pages_management_outlets_update_outlet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_pages_management_outlets_update_outlet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_pages_management_invoices_invoices__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_pages_management_invoices_invoices___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_pages_management_invoices_invoices__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_pages_management_contract_contract__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_pages_management_contract_contract___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_pages_management_contract_contract__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_pages_settlements_settlements__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_pages_settlements_settlements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_pages_settlements_settlements__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_pages_coupons_coupon_list__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_pages_coupons_coupon_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_pages_coupons_coupon_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_pages_coupons_choose_coupon__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_pages_coupons_choose_coupon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_pages_coupons_choose_coupon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_pages_coupons_add_coupon__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_pages_coupons_add_coupon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_pages_coupons_add_coupon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_pages_coupons_agreement__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_pages_coupons_agreement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_pages_coupons_agreement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_pages_coupons_coupon_tips__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_pages_coupons_coupon_tips___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_pages_coupons_coupon_tips__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_pages_settings_payment_channels__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_pages_settings_payment_channels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_pages_settings_payment_channels__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_pages_settings_bank__ = __webpack_require__(1061);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_pages_settings_bank___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_pages_settings_bank__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_pages_settings_passwords__ = __webpack_require__(1062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_pages_settings_passwords___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_pages_settings_passwords__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_pages_settings_qrcodes__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_pages_settings_qrcodes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_pages_settings_qrcodes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_pages_settings_refund_password__ = __webpack_require__(1065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_pages_settings_refund_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_pages_settings_refund_password__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_pages_404__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_pages_404___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_pages_404__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_pages_401__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_pages_401___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_pages_401__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_pages_500__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_pages_500___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_pages_500__);


























































__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_7_pages_login___default.a,
    meta: {
      title: 'login'
    },
    beforeEnter: function beforeEnter(to, from, next) {
      if (window.store.get('version-m') === '1.0' && window.store.get('MERCHANTLOGINED')) {
        if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.user.userinfo !== null && __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.user.userinfo.onBoarding === '1') {
          next({
            path: '/on-boarding/resetPassword'
          });
        } else if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.user.userinfo !== null && __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.user.userinfo.onBoarding === '2') {
          next({
            path: '/on-boarding/agreement'
          });
        } else if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.user.userinfo !== null && __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.user.userinfo.onBoarding === '3') {
          next({
            path: '/on-boarding/service-fee'
          });
        } else {
          next({
            path: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.user.userinfo.pageIndex
          });
        }
      } else {
        next();
      }
    }
  }, {
    path: '/',
    redirect: '/login'
  }, {
    path: '/on-boarding/resetPassword',
    component: __WEBPACK_IMPORTED_MODULE_8_pages_on_boarding_reset_password___default.a,
    name: 'OB-ResetPwd',
    meta: {
      title: 'onBoarding.reset'
    },
    beforeEnter: function beforeEnter(to, from, next) {
      if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.user.userinfo.onBoarding === '1') {
        next();
      } else {
        next({
          name: 'No-Right'
        });
      }
    }
  }, {
    path: '/on-boarding/agreement',
    component: __WEBPACK_IMPORTED_MODULE_9_pages_on_boarding_agreement___default.a,
    name: 'OB-Agreement',
    meta: {
      title: 'onBoarding.agreement'
    },
    beforeEnter: function beforeEnter(to, from, next) {
      if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.user.userinfo.onBoarding === '2') {
        next();
      } else {
        next({
          name: 'No-Right'
        });
      }
    }
  }, {
    path: '/on-boarding/contract',
    component: __WEBPACK_IMPORTED_MODULE_10_pages_on_boarding_contract___default.a,
    name: 'OB-Contract',
    meta: {
      title: 'onBoarding.contract'
    },
    beforeEnter: function beforeEnter(to, from, next) {
      if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.user.userinfo.onBoarding === '2') {
        next();
      } else {
        next({
          name: 'No-Right'
        });
      }
    }
  }, {
    path: '/on-boarding/service-fee',
    component: __WEBPACK_IMPORTED_MODULE_11_pages_on_boarding_service_fee___default.a,
    name: 'OB-ServiceFee',
    meta: {
      title: 'onBoarding.serviceFee'
    },
    beforeEnter: function beforeEnter(to, from, next) {
      if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.user.userinfo.onBoarding === '3') {
        next();
      } else {
        next({
          name: 'No-Right'
        });
      }
    }
  }, {
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_6__Dash___default.a,
    beforeEnter: function beforeEnter(to, from, next) {
      if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.user.userinfo !== null && __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.user.userinfo.onBoarding === '4') {
        next();
      } else if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.user.userinfo === null) {
        next({
          name: 'Login'
        });
      } else {
        next({
          name: 'Login'
        });
      }
    },
    children: [{
      path: '/dashboard',
      name: 'Dashboard',
      component: __WEBPACK_IMPORTED_MODULE_12_pages_dashboard___default.a,
      meta: {
        title: 'dashboard'
      }
    }, {
      path: '/trx',
      name: 'Transactions',
      component: __WEBPACK_IMPORTED_MODULE_13_pages_transactions_transactions___default.a,
      meta: {
        title: 'transactions.self'
      }
    }, {
      path: '/trx/view/:id',
      name: 'Transaction-Detail',
      component: __WEBPACK_IMPORTED_MODULE_14_pages_transactions_view_detail___default.a,
      meta: {
        title: 'transactions.view'
      }
    }, {
      path: '/refund',
      name: 'Refund',
      component: __WEBPACK_IMPORTED_MODULE_15_pages_refunds_refunds___default.a,
      meta: {
        title: 'refunds.self'
      }
    }, {
      path: '/refund/view/:id',
      name: 'Refund-Detail',
      component: __WEBPACK_IMPORTED_MODULE_16_pages_refunds_view_detail___default.a,
      meta: {
        title: 'refunds.view'
      }
    }, {
      path: '/customers',
      name: 'Customers',
      component: __WEBPACK_IMPORTED_MODULE_17_pages_customers_customers___default.a,
      meta: {
        title: 'customers'
      }
    }, {
      path: '/coupons',
      name: 'Coupon-List',
      component: __WEBPACK_IMPORTED_MODULE_31_pages_coupons_coupon_list___default.a,
      meta: {
        title: 'coupons.self'
      },
      beforeEnter: function beforeEnter(to, from, next) {
        checkCoupon(next, from);
      }
    }, {
      path: '/choose-coupon',
      name: 'Choose-Coupon',
      component: __WEBPACK_IMPORTED_MODULE_32_pages_coupons_choose_coupon___default.a,
      meta: {
        title: 'coupons.choose'
      },
      beforeEnter: function beforeEnter(to, from, next) {
        checkCoupon(next, from);
      }
    }, {
      path: '/add-coupon',
      name: 'Add-Coupon',
      component: __WEBPACK_IMPORTED_MODULE_33_pages_coupons_add_coupon___default.a,
      meta: {
        title: 'coupons.add'
      },
      beforeEnter: function beforeEnter(to, from, next) {
        checkCoupon(next, from);
      }
    }, {
      path: '/coupon-agreement',
      name: 'Coupon-Agreement',
      component: __WEBPACK_IMPORTED_MODULE_34_pages_coupons_agreement___default.a,
      meta: {
        title: 'coupons.agreement'
      }
    }, {
      path: '/coupon-tips',
      name: 'Coupon-Tips',
      component: __WEBPACK_IMPORTED_MODULE_35_pages_coupons_coupon_tips___default.a,
      meta: {
        title: 'coupons.tips'
      },
      beforeEnter: function beforeEnter(to, from, next) {
        if (from.name === null) {
          __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].ckeckCouponStatus().then(function (res) {
            var result = res.data.data;
            if (res.data.code === 200) {
              if (result.allowCoupon && result.agreeCoupon) {
                next({
                  name: 'Coupon-List'
                });
              } else if (!result.allowCoupon) {
                next();
              }
            }
          });
        } else {
          next();
        }
      }
    }, {
      path: '/management/account',
      name: 'Accounts',
      component: __WEBPACK_IMPORTED_MODULE_21_pages_management_accounts_accounts___default.a,
      meta: {
        title: 'accounts.self'
      }
    }, {
      path: '/management/account/add-new-account',
      name: 'Add-New-Account',
      component: __WEBPACK_IMPORTED_MODULE_22_pages_management_accounts_add_new_account___default.a,
      meta: {
        title: 'accounts.add'
      }
    }, {
      path: '/management/account/update-account/:id',
      name: 'Update-Account',
      component: __WEBPACK_IMPORTED_MODULE_23_pages_management_accounts_update_account___default.a,
      meta: {
        title: 'accounts.update'
      }
    }, {
      path: '/management/outlets',
      name: 'Outlets',
      component: __WEBPACK_IMPORTED_MODULE_24_pages_management_outlets_outlets___default.a,
      meta: {
        title: 'outlets.self'
      }
    }, {
      path: '/management/outlets/add-new-outlet',
      name: 'Add-New-Outlet',
      component: __WEBPACK_IMPORTED_MODULE_25_pages_management_outlets_add_new_outlet___default.a,
      meta: {
        title: 'outlets.add'
      }
    }, {
      path: '/management/outlets/view/:id',
      name: 'View-Outlet-Detail',
      component: __WEBPACK_IMPORTED_MODULE_26_pages_management_outlets_view_detail___default.a,
      meta: {
        title: 'outlets.view'
      }
    }, {
      path: '/management/outlets/update/:id',
      name: 'Update-Outlet',
      component: __WEBPACK_IMPORTED_MODULE_27_pages_management_outlets_update_outlet___default.a,
      meta: {
        title: 'outlets.update'
      }
    }, {
      path: '/management/invoices',
      name: 'Invoices',
      component: __WEBPACK_IMPORTED_MODULE_28_pages_management_invoices_invoices___default.a,
      meta: {
        title: 'invoices'
      }
    }, {
      path: '/settlements',
      name: 'Settlements',
      component: __WEBPACK_IMPORTED_MODULE_30_pages_settlements_settlements___default.a,
      meta: {
        title: 'settlements'
      }
    }, {
      path: '/management/contract',
      name: 'DownloadContract',
      component: __WEBPACK_IMPORTED_MODULE_29_pages_management_contract_contract___default.a,
      meta: {
        title: 'contract'
      }
    }, {
      path: '/analytics/trx',
      name: 'Analytics-Transactions',
      component: __WEBPACK_IMPORTED_MODULE_18_pages_analytics_transactions___default.a,
      meta: {
        title: 'analytics.trx'
      }
    }, {
      path: '/analytics/customer',
      name: 'Analytics-Customers',
      component: __WEBPACK_IMPORTED_MODULE_19_pages_analytics_customers___default.a,
      meta: {
        title: 'analytics.customers'
      }
    }, {
      path: '/analytics/outlet',
      name: 'Analytics-Outlets',
      component: __WEBPACK_IMPORTED_MODULE_20_pages_analytics_outlets___default.a,
      meta: {
        title: 'analytics.outlets'
      }
    }, {
      path: '/settings/payment-channels',
      name: 'Settings-PaymentChannels',
      component: __WEBPACK_IMPORTED_MODULE_36_pages_settings_payment_channels___default.a,
      meta: {
        title: 'settings.payment'
      }
    }, {
      path: '/settings/bank',
      component: __WEBPACK_IMPORTED_MODULE_37_pages_settings_bank___default.a,
      meta: {
        title: 'settings.bank'
      }
    }, {
      path: '/settings/qrcode',
      component: __WEBPACK_IMPORTED_MODULE_39_pages_settings_qrcodes___default.a,
      meta: {
        title: 'settings.qrcode'
      }
    }, {
      path: '/settings/password',
      component: __WEBPACK_IMPORTED_MODULE_38_pages_settings_passwords___default.a,
      meta: {
        title: 'settings.pwd'
      }
    }, {
      path: '/settings/refund-password',
      component: __WEBPACK_IMPORTED_MODULE_40_pages_settings_refund_password___default.a,
      name: 'SettingsRefundPassword',
      meta: {
        title: 'settings.refundPwd'
      }
    }]
  }, {
    path: '/404',
    component: __WEBPACK_IMPORTED_MODULE_41_pages_404___default.a,
    meta: {
      title: '404'
    }
  }, {
    path: '/401',
    component: __WEBPACK_IMPORTED_MODULE_42_pages_401___default.a,
    name: 'No-Right',
    meta: {
      title: '401'
    }
  }, {
    path: '/500',
    component: __WEBPACK_IMPORTED_MODULE_43_pages_500___default.a,
    name: 'No-Service',
    meta: {
      title: '500'
    }
  }, {
    path: '*',
    redirect: '/404'
  }],
  linkActiveClass: 'active',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  }
});

router.beforeEach(function (to, from, next) {
  var pt = __WEBPACK_IMPORTED_MODULE_3__assets_lang__["a" /* default */].t('pageTitle.' + to.meta.title);
  document.title = pt + __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.theme.companyInfo.baseTitle;
  if (__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.user.userinfo !== null) {
    __WEBPACK_IMPORTED_MODULE_0_vue___default.a.$ga.set({
      userId: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.user.userinfo.id
    });
  }

  __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].commit(__WEBPACK_IMPORTED_MODULE_4__store_types__["p" /* NAVINFO */], {
    navtitle: pt
  });
  next();
});

function checkCoupon(cb, from) {
  __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].ckeckCouponStatus().then(function (res) {
    var result = res.data.data;
    if (res.data.code === 200) {
      if (result.allowCoupon && result.agreeCoupon) {
        cb();
      } else if (!result.allowCoupon) {
        cb({
          name: 'Coupon-Tips',
          query: {
            email: result.email,
            number: result.contactNumber
          }
        });
      } else if (!result.agreeCoupon) {
        cb({
          name: 'Coupon-Agreement'
        });
      }
    }
  });
}

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var compute = {};

compute.getM = function (na, nb) {

  try {
    var pa = na.toString().split(".")[1].length;
  } catch (err) {
    pa = 0;
  }

  try {
    var pb = nb.toString().split(".")[1].length;
  } catch (err) {
    pb = 0;
  }

  return pa > pb ? pa : pb;
};

compute.add = function (na, nb) {

  var m = this.getM(na, nb);
  var mid = (na * Math.pow(10, m) + nb * Math.pow(10, m)).toFixed(0).toString();
  return m === 0 ? parseInt(mid) : parseFloat(mid.slice(0, -m) + "." + mid.slice(-m));
};

compute.mul = function (na, nb) {

  var m = this.getM(na, nb);
  var mid = (na * Math.pow(10, m) * (nb * Math.pow(10, m))).toFixed(0).toString();
  return m === 0 ? parseInt(mid) : parseFloat(mid.slice(0, -2 * m) + "." + mid.slice(-2 * m));
};

compute.sub = function (na, nb) {

  return this.add(na, -nb);
};

compute.div = function (na, nb) {

  var m = this.getM(na, nb);
  var mid = (na * Math.pow(10, m) / (nb * Math.pow(10, m))).toString();
  return +mid;
};

compute.mulSum = function () {
  var res = 1;
  var that = this;
  if (arguments && arguments.length > 0) {
    [].slice.call(arguments).map(function (item) {
      res = that.mul(item, res);
    });
    return res;
  }

  throw new Error("you have to input an parameters at least");
};

/* harmony default export */ __webpack_exports__["a"] = (compute);

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var FileSaver = __webpack_require__(1001);
function download(data, filename) {
  FileSaver.saveAs(data, filename);
}

/* harmony default export */ __webpack_exports__["a"] = (download);

/***/ }),
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(954)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(512),
  /* template */
  __webpack_require__(1085),
  /* scopeId */
  "data-v-1a13cf94",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_css__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_script__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_script___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__lib_script__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_global__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_analytics__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_nprogress__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue2_google_maps__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api_http__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_axios__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_echarts_components_ECharts_vue__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_echarts_components_ECharts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_echarts_components_ECharts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_echarts_lib_chart_bar__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_echarts_lib_chart_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_echarts_lib_chart_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_echarts_lib_chart_line__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_echarts_lib_chart_line___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_echarts_lib_chart_line__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_echarts_lib_chart_pie__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_echarts_lib_chart_pie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_echarts_lib_chart_pie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_echarts_lib_chart_map__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_echarts_lib_chart_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_echarts_lib_chart_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_echarts_lib_chart_radar__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_echarts_lib_chart_radar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_echarts_lib_chart_radar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_echarts_lib_chart_scatter__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_echarts_lib_chart_scatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_echarts_lib_chart_scatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_echarts_lib_chart_effectScatter__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_echarts_lib_chart_effectScatter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_echarts_lib_chart_effectScatter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_echarts_lib_component_tooltip__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_echarts_lib_component_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_echarts_lib_component_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_echarts_lib_component_polar__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_echarts_lib_component_polar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_echarts_lib_component_polar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_echarts_lib_component_geo__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_echarts_lib_component_geo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_echarts_lib_component_geo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_echarts_lib_component_legend__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_echarts_lib_component_legend___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_echarts_lib_component_legend__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_echarts_lib_component_title__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_echarts_lib_component_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_echarts_lib_component_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_echarts_lib_component_visualMap__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_echarts_lib_component_visualMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_echarts_lib_component_visualMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__assets_theme_json__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__assets_theme_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__assets_theme_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__assets_lang__ = __webpack_require__(224);











__WEBPACK_IMPORTED_MODULE_4_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8_element_ui___default.a);


__WEBPACK_IMPORTED_MODULE_4_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_9_vue_analytics___default.a, {
  id: 'UA-104601609-1',
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: route.path,
        title: document.title,
        location: window.location.href
      };
    }
  }
});


var options = {
  showSpinner: false,
  latencyThreshold: 200,
  router: true,
  http: false };

__WEBPACK_IMPORTED_MODULE_4_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_vue_nprogress___default.a, options);
var nprogress = new __WEBPACK_IMPORTED_MODULE_10_vue_nprogress___default.a({
  parent: '.nprogress-container'
});


__WEBPACK_IMPORTED_MODULE_4_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_11_vue2_google_maps__, {
  installComponents: true,
  load: {
    key: 'AIzaSyCT4wHCRqtHYuwbm8tNZXb6LYcIe0c9dIY',
    v: '3.29',
    libraries: 'places',
    language: 'en'
  }
});
__WEBPACK_IMPORTED_MODULE_4_vue___default.a.filter('json', function (x) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(x);
});



__WEBPACK_IMPORTED_MODULE_4_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_13_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_12__api_http__["a" /* default */]);

















__WEBPACK_IMPORTED_MODULE_14_vue_echarts_components_ECharts_vue___default.a.registerTheme('default', __WEBPACK_IMPORTED_MODULE_28__assets_theme_json___default.a);
__WEBPACK_IMPORTED_MODULE_4_vue___default.a.component('chart', __WEBPACK_IMPORTED_MODULE_14_vue_echarts_components_ECharts_vue___default.a);



new __WEBPACK_IMPORTED_MODULE_4_vue___default.a({
  el: '#app',
  nprogress: nprogress,
  i18n: __WEBPACK_IMPORTED_MODULE_29__assets_lang__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */],
  axios: __WEBPACK_IMPORTED_MODULE_12__api_http__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_5__App___default.a
  }
});

/***/ }),
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_font_awesome_css_font_awesome_min_css__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_index_css__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_theme_default_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_styles_basic_css__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_styles_basic_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_styles_basic_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_styles_hack_css__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_styles_hack_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_styles_hack_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_styles_main_css__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_styles_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_styles_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_iconfont_iconfont_css__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_iconfont_iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_iconfont_iconfont_css__);














/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__includes_sl_row__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__includes_sl_row___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__includes_sl_row__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__includes_sl_column__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__includes_sl_column___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__includes_sl_column__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__includes_sl_show_box__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__includes_sl_show_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__includes_sl_show_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__includes_sl_box__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__includes_sl_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__includes_sl_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__includes_sl_switcher__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__includes_sl_switcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__includes_sl_switcher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__includes_sl_sp_page__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__includes_sl_sp_page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__includes_sl_sp_page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__includes_sl_btn__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__includes_sl_btn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__includes_sl_btn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__includes_sl_a__ = __webpack_require__(1025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__includes_sl_a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__includes_sl_a__);











__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('row', __WEBPACK_IMPORTED_MODULE_1__includes_sl_row___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('column', __WEBPACK_IMPORTED_MODULE_2__includes_sl_column___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('sl-box', __WEBPACK_IMPORTED_MODULE_4__includes_sl_box___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('sl-show-box', __WEBPACK_IMPORTED_MODULE_3__includes_sl_show_box___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('sl-switcher', __WEBPACK_IMPORTED_MODULE_5__includes_sl_switcher___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('sl-sp-page', __WEBPACK_IMPORTED_MODULE_6__includes_sl_sp_page___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('sl-btn', __WEBPACK_IMPORTED_MODULE_7__includes_sl_btn___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.component('sl-a', __WEBPACK_IMPORTED_MODULE_8__includes_sl_a___default.a);

/***/ }),
/* 490 */
/***/ (function(module, exports) {


var isiPhoneSafari = window.navigator.userAgent.toLowerCase().indexOf('safari') !== -1 && window.navigator.userAgent.toLowerCase().indexOf('iphone') !== -1 ? true : !true;

if (isiPhoneSafari) {
  var storeLink = document.createElement('script');
  storeLink.src = '/static/store.everything.min.js';
  document.getElementsByTagName('head')[0].appendChild(storeLink);
}

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(10);




var _mutations;



var defaultState = {
  condition: {
    search: '',
    status: ''
  },
  table: {
    page: 1,
    per: 10,
    order: 'DESC',
    orderBy: 'createTime'
  }
};

var state = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(defaultState));

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["j" /* SetAccountTable */], function (state, _ref) {
  var table = _ref.table,
      condition = _ref.condition;

  state.condition = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, condition);
  state.table = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, table);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["k" /* InitAccountTable */], function (state) {
  state.condition = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, defaultState.condition);
  state.table = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, defaultState.table);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(10);




var _mutations;



var defaultState = {
  condition: {
    search: ''
  },
  table: {
    page: 1,
    per: 10,
    order: '',
    orderBy: ''
  }
};

var state = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(defaultState));

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["f" /* SetInvoiceTable */], function (state, _ref) {
  var table = _ref.table,
      condition = _ref.condition;

  state.condition = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, condition);
  state.table = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, table);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["g" /* InitInvoiceTable */], function (state) {
  state.condition = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, defaultState.condition);
  state.table = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, defaultState.table);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(10);



var state = {
  navtitle: '',
  navpath: [],
  lang: 'en'
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__types__["p" /* NAVINFO */], function (state, result) {
  state.navtitle = result.navtitle;
  state.navpath = result.navpath;
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(10);




var _mutations;



var defaultState = {
  condition: {
    trxId: '',
    customer: '',
    begin: '',
    end: ''
  },
  table: {
    page: 1,
    per: 10,
    order: '',
    orderBy: ''
  },
  datePicker: []
};

var state = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(defaultState));

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["d" /* SetRefundTable */], function (state, _ref) {
  var table = _ref.table,
      condition = _ref.condition,
      datePicker = _ref.datePicker;

  state.condition = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, condition);
  state.table = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, table);
  state.datePicker = datePicker;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["e" /* InitRefundTable */], function (state) {
  state.condition = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, defaultState.condition);
  state.table = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, defaultState.table);
  state.datePicker = defaultState.datePicker;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(10);




var _mutations;



var defaultState = {
  condition: {
    trxId: '',
    customer: '',
    begin: '',
    end: ''
  },
  table: {
    page: 1,
    per: 10,
    order: '',
    orderBy: ''
  },
  datePicker: []
};

var state = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(defaultState));

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["b" /* SetSettleTable */], function (state, _ref) {
  var table = _ref.table,
      condition = _ref.condition,
      datePicker = _ref.datePicker;

  state.condition = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, condition);
  state.table = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, table);
  state.datePicker = datePicker;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["c" /* InitSettleTable */], function (state) {
  state.condition = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, defaultState.condition);
  state.table = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, defaultState.table);
  state.datePicker = defaultState.datePicker;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(10);




var _mutations;



var defaultState = {
  condition: {
    search: ''
  },
  table: {
    page: 1,
    per: 10,
    order: '',
    orderBy: ''
  }
};

var state = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(defaultState));

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["h" /* SetStoreTable */], function (state, _ref) {
  var table = _ref.table,
      condition = _ref.condition;

  state.condition = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, condition);
  state.table = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, table);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["i" /* InitStoreTable */], function (state) {
  state.condition = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, defaultState.condition);
  state.table = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, defaultState.table);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(10);



var state = {
  activeTime: 'hour'
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__types__["o" /* ACTIVETIME */], function (state, activeTime) {
  state.activeTime = activeTime;
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var company_info = {

  supay: {
    companyName: 'Simpay.',
    url: '',
    copyRight: '',
    baseTitle: ' | Simpay Merchant Console',
    phone: '',
    email: '',
    welcome: 'Welcome to use Simpay!',
    currency: 'F$',
    international: false,
    utcOffset: '+10:00',
    timeZone: 'Australia/Sydney'

  }
};

var state = {
  name: "supay",
  companyInfo: __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.pick(company_info, "supay")["supay"]
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__types__["n" /* CHANGETHEME */], function (state, themeName) {
  state.name = themeName;
  state.companyInfo = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.pick(company_info, themeName)[themeName];
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(10);




var _mutations;



var defaultState = {
  condition: {
    outletId: 9999,
    status: 9999,
    begin: '',
    end: '',
    search: ''
  },
  table: {
    page: 1,
    per: 10,
    order: '',
    orderBy: ''
  },
  datePicker: []
};

var state = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(defaultState));

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["l" /* SetTrxListTable */], function (state, _ref) {
  var table = _ref.table,
      condition = _ref.condition,
      datePicker = _ref.datePicker;

  state.condition = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, condition);
  state.table = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, table);
  state.datePicker = datePicker;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["m" /* InitTrxListTable */], function (state) {
  state.condition = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, defaultState.condition);
  state.table = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, defaultState.table);
  state.datePicker = defaultState.datePicker;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(10);



var _mutations;



var version = '1.0';
if (window.store.get('version-m') !== version) {
  window.store.clearAll();
}

var state = {
  userinfo: window.store.get('version-m') === version && window.store.get('userInfo') !== undefined ? JSON.parse(window.store.get('userInfo')) : null,
  slider: window.store.get('version-m') === version && window.store.get('slider') !== undefined ? JSON.parse(window.store.get('slider')) : null,
  setting: window.store.get('version-m') === version && window.store.get('setting') !== undefined ? JSON.parse(window.store.get('setting')) : null
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["q" /* SIGNIN */], function (state, _ref) {
  var result = _ref.result,
      index = _ref.index;

  state.userinfo = result.userInfo;
  state.userinfo.pageIndex = index;
  __WEBPACK_IMPORTED_MODULE_2_vue___default.a.$ga.set({
    userId: state.userinfo.id
  });
  window.store.set('userInfo', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.userinfo));
  window.store.set('MERCHANTLOGINED', true, new Date().getTime() + 86400000);
  window.store.set('version-m', version);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["r" /* RESIGN */], function (state) {
  state.userinfo = window.store.get('version-m') === version && window.store.get('userInfo') !== undefined ? JSON.parse(window.store.get('userInfo')) : null;
  state.slider = window.store.get('version-m') === version && window.store.get('slider') !== undefined ? JSON.parse(window.store.get('slider')) : null;
  state.setting = window.store.get('version-m') === version && window.store.get('setting') !== undefined ? JSON.parse(window.store.get('setting')) : null;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["s" /* SLIDER */], function (state, result) {
  state.slider = result.menu;
  state.setting = result.settings;
  window.store.set('slider', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.slider));
  window.store.set('setting', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.setting));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["t" /* SIGNOUT */], function (state) {
  state.userinfo = null;
  state.slider = null;
  state.setting = null;
  window.store.clearAll();
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["u" /* ISSIGN */], function (state) {
  state.userinfo.onBoarding = '3';
  window.store.set('userInfo', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.userinfo));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["v" /* SETFEE */], function (state) {
  state.userinfo.onBoarding = '4';
  window.store.set('userInfo', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.userinfo));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["w" /* AGREECOUPON */], function (state) {
  state.userinfo.agreeCoupon = '1';
  window.store.set('userInfo', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.userinfo));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__types__["x" /* CHANGELANG */], function (state, lang) {
  state.userinfo.lang = lang;
  window.store.set('userInfo', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(state.userinfo));
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(10);



var Sys = {};
var ua = navigator.userAgent.toLowerCase();
var s;
(s = ua.match(/rv:([\d.]+)\) like gecko/)) ? Sys.browser = 'ie' : (s = ua.match(/msie ([\d.]+)/)) ? Sys.browser = 'ie' : (s = ua.match(/firefox\/([\d.]+)/)) ? Sys.browser = 'firefox' : (s = ua.match(/chrome\/([\d.]+)/)) ? Sys.browser = 'chrome' : (s = ua.match(/opera.([\d.]+)/)) ? Sys.browser = 'opera' : (s = ua.match(/version\/([\d.]+).*safari/)) ? Sys.browser = 'safari' : 0;

var state = {
  isPhone: false,
  browser: Sys.browser
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* AGENT */], function (state, status) {
  state.isPhone = status;
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_echarts_lib_echarts__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_echarts_lib_echarts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_echarts_lib_echarts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue__);






var ACTION_EVENTS = ['legendselectchanged', 'legendselected', 'legendunselected', 'datazoom', 'datarangeselected', 'timelinechanged', 'timelineplaychanged', 'restore', 'dataviewchanged', 'magictypechanged', 'geoselectchanged', 'geoselected', 'geounselected', 'pieselectchanged', 'pieselected', 'pieunselected', 'mapselectchanged', 'mapselected', 'mapunselected', 'axisareaselected', 'brush', 'brushselected'];

var MOUSE_EVENTS = ['click', 'dblclick', 'mouseover', 'mouseout', 'mousedown', 'mouseup', 'globalout'];

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    options: Object,
    theme: String,
    initOptions: Object,
    group: String,
    autoResize: Boolean
  },
  data: function data() {
    return {
      chart: null
    };
  },

  computed: {
    width: {
      cache: false,
      get: function get() {
        return this.chart.getWidth();
      }
    },
    height: {
      cache: false,
      get: function get() {
        return this.chart.getHeight();
      }
    },
    isDisposed: {
      cache: false,
      get: function get() {
        return this.chart.isDisposed();
      }
    }
  },
  watch: {
    options: {
      handler: function handler(options) {
        if (!this.chart && options) {
          this._init();
        } else {
          this.chart.setOption(this.options, true);
        }
      },

      deep: true
    },
    group: {
      handler: function handler(group) {
        this.chart.group = group;
      }
    }
  },
  methods: {
    mergeOptions: function mergeOptions(options) {
      this._delegateMethod('setOption', options);
    },
    resize: function resize(options) {
      this._delegateMethod('resize', options);
    },
    dispatchAction: function dispatchAction(payload) {
      this._delegateMethod('dispatchAction', payload);
    },
    convertToPixel: function convertToPixel(finder, value) {
      return this._delegateMethod('convertToPixel', finder, value);
    },
    convertFromPixel: function convertFromPixel(finder, value) {
      return this._delegateMethod('convertFromPixel', finder, value);
    },
    containPixel: function containPixel(finder, value) {
      return this._delegateMethod('containPixel', finder, value);
    },
    showLoading: function showLoading(type, options) {
      this._delegateMethod('showLoading', type, options);
    },
    hideLoading: function hideLoading() {
      this._delegateMethod('hideLoading');
    },
    getDataURL: function getDataURL(options) {
      return this._delegateMethod('getDataURL', options);
    },
    getConnectedDataURL: function getConnectedDataURL(options) {
      return this._delegateMethod('getConnectedDataURL', options);
    },
    clear: function clear() {
      this._delegateMethod('clear');
    },
    dispose: function dispose() {
      this._delegateMethod('dispose');
    },
    _delegateMethod: function _delegateMethod(name) {
      var _chart;

      if (!this.chart) {
        __WEBPACK_IMPORTED_MODULE_2_vue___default.a.util.warn('Cannot call [' + name + '] before the chart is initialized. Set prop [options] first.', this);
        return;
      }

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return (_chart = this.chart)[name].apply(_chart, args);
    },
    _init: function _init() {
      var _this = this;

      if (this.chart) {
        return;
      }

      var chart = __WEBPACK_IMPORTED_MODULE_0_echarts_lib_echarts___default.a.init(this.$el, this.theme, this.initOptions);

      if (this.group) {
        chart.group = this.group;
      }

      chart.setOption(this.options, true);

      ACTION_EVENTS.forEach(function (event) {
        chart.on(event, function (params) {
          _this.$emit(event, params);
        });
      });
      MOUSE_EVENTS.forEach(function (event) {
        chart.on(event, function (params) {
          _this.$emit(event, params);

          _this.$emit('chart' + event, params);
        });
      });

      if (this.autoResize) {
        this.__resizeHanlder = __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default()(function () {
          chart.resize();
        }, 100, { leading: true });
        window.addEventListener('resize', this.__resizeHanlder);
      }

      this.chart = chart;
    }
  },
  mounted: function mounted() {
    if (this.options) {
      this._init();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }
    if (this.autoResize) {
      window.removeEventListener('resize', this.__resizeHanlder);
    }
    this.dispose();
  },
  connect: function connect(group) {
    if (typeof group !== 'string') {
      group = group.map(function (chart) {
        return chart.chart;
      });
    }
    __WEBPACK_IMPORTED_MODULE_0_echarts_lib_echarts___default.a.connect(group);
  },
  disconnect: function disconnect(group) {
    __WEBPACK_IMPORTED_MODULE_0_echarts_lib_echarts___default.a.disConnect(group);
  },
  registerMap: function registerMap() {
    __WEBPACK_IMPORTED_MODULE_0_echarts_lib_echarts___default.a.registerMap.apply(__WEBPACK_IMPORTED_MODULE_0_echarts_lib_echarts___default.a, arguments);
  },
  registerTheme: function registerTheme() {
    __WEBPACK_IMPORTED_MODULE_0_echarts_lib_echarts___default.a.registerTheme.apply(__WEBPACK_IMPORTED_MODULE_0_echarts_lib_echarts___default.a, arguments);
  }
});

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(19);

exports.default = {
  mounted: function mounted() {
    if ((0, _lodash.isUndefined)(window.PDFObject)) {
      console.error('VuePDFViewer Error: PDFObject not found. ' + 'Get it here: https://pdfobject.com, please include js file.');
      return;
    }
    if ((0, _lodash.isUndefined)(this.url)) {
      console.error('VuePDFViewer Error: no file url provided');
      return;
    }
    PDFObject.embed(this.url, this.$el);
  },
  props: ['height', 'url'],
  data: function data() {
    var vm = this;
    var h = '400px';
    if (!vm.height) {
      console.warn('Please specify viewer height, e.g. height="500px"');
    } else {
      h = vm.height;
    }
    return {
      styleObject: {
        height: h
      }
    };
  },
  watch: {
    url: function url(val) {
      var vm = this;
      PDFObject.embed(val, vm.$el);
    }
  }
};

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'nprogress-container'
});

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_nprogress_src_NprogressContainer__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_nprogress_src_NprogressContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_nprogress_src_NprogressContainer__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      themeClass: this.$store.state.theme.name,
      popWindow: true,
      versions: ''
    };
  },

  components: {
    NprogressContainer: __WEBPACK_IMPORTED_MODULE_1_vue_nprogress_src_NprogressContainer___default.a
  },
  beforeCreate: function beforeCreate() {
    var favLink = document.createElement('link');
    favLink.href = '/static/' + this.$store.state.theme.name + '/128_favicon.ico';
    favLink.rel = 'shortcut icon';
    favLink.sizes = '48x48';
    document.getElementsByTagName('head')[0].appendChild(favLink);
    var themeLink = document.createElement('link');
    themeLink.href = '/static/' + this.$store.state.theme.name + '/theme-item.css';
    themeLink.rel = 'stylesheet';
    document.getElementsByTagName('head')[0].appendChild(themeLink);
  },
  created: function created() {
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_types__["a" /* AGENT */], this.isPhone());
  },

  methods: {
    isPhone: function isPhone() {
      var u = navigator.userAgent;
      var versions = {
        mobile: !!u.match(/AppleWebKit.*Mobile.*/),
        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
        ios: u.indexOf('iPhone') > -1
      };
      this.versions = versions.ios ? 'ios' : 'android';
      if (versions.mobile || versions.android || versions.ios) {
        return true;
      }
      return false;
    }
  }
});

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'content-wrap'
});

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NaviBar_vue__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NaviBar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__NaviBar_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ContentWrap_vue__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ContentWrap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_ContentWrap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Slider__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_Slider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_Slider__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dash',
  components: {
    NaviBar: __WEBPACK_IMPORTED_MODULE_0__NaviBar_vue___default.a,
    Slider: __WEBPACK_IMPORTED_MODULE_2_Slider___default.a,
    ContentWrap: __WEBPACK_IMPORTED_MODULE_1_ContentWrap_vue___default.a
  }
});

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Slider_mini__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Slider_mini___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Slider_mini__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_styles_navibar_css__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_styles_navibar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_styles_navibar_css__);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'NaviBar',
  components: {
    SliderMini: __WEBPACK_IMPORTED_MODULE_2__Slider_mini___default.a
  },
  data: function data() {
    return {
      showMiniMenu: false,
      dialogVisible: false,
      changeLoading: false,
      settingPopoverVisible: false
    };
  },

  computed: {
    settingActive: function settingActive() {
      var index = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(this.$store.state.user.setting.children, {
        'url': this.$route.path
      });
      return index !== -1 ? true : !true;
    }
  },
  methods: {
    onChange: function onChange(val) {
      var _this = this;

      this.$ga.event('Button', 'Change Language:' + val, 'Navigator');
      var vm = this;
      this.changeLoading = true;
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].changeLanguage({
        lang: val
      }).then(function (res) {
        if (res.data.code === 200 && res.data.data.lang) {
          vm.$i18n.locale = val;
          vm.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_types__["x" /* CHANGELANG */], res.data.data.lang);
          __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].getMenu().then(function (res) {
            if (res.data.code === 200) {
              vm.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_types__["s" /* SLIDER */], res.data.data);
              location.reload();
            }
          });
        } else {
          alert(_this.$t('Notify.errorMsg'));
        }
      });
    },
    onSignOut: function onSignOut() {
      var _this2 = this;

      this.$ga.event('Button', 'Sign out', 'Navigator');
      var message = {
        info: this.$t('Navigator.signOutTips'),
        tip: this.$t('Navigator.tip'),
        confirm: this.$t('Navigator.confirm'),
        cancel: this.$t('Navigator.cancel')
      };
      this.$confirm(message.info, message.tip, {
        confirmButtonText: message.confirm,
        cancelButtonText: message.cancel,
        type: 'warning'
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].Logout(_this2.$store.state.user.userinfo.id).then(function (res) {
          if (res.data.code === 200) {
            _this2.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_types__["t" /* SIGNOUT */]);
            _this2.$router.push({
              path: '/login'
            });
          }
        });
      }).catch(function () {
        console.log('推出失败，请稍后再试！');
      });
    }
  }
});

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_styles_slider_mini_css__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_styles_slider_mini_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_styles_slider_mini_css__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'slider',
  computed: {
    slider: function slider() {
      return this.$store.state.user.slider;
    },
    currentPage: function currentPage() {
      return this.$route.path === '' ? this.$store.state.user.userinfo.pageIndex : this.$route.path;
    }
  },
  props: {
    showMiniMenu: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    hideMenu: function hideMenu() {
      this.$emit('update:showMiniMenu', false);
    }
  }
});

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_styles_slider_css__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_styles_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_styles_slider_css__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'slider',
  computed: {
    slider: function slider() {
      return this.$store.state.user.slider;
    },
    currentPage: function currentPage() {
      return this.$route.path === '' ? this.$store.state.user.userinfo.pageIndex : this.$route.path;
    },
    level1: function level1() {
      return this.hasLevel('/dashboard');
    }
  },
  methods: {
    hasLevel: function hasLevel(name) {
      var bl = false;
      this.$store.state.user.slider.map(function (item) {
        if (item.menu === name) {
          bl = true;
        }
      });
      return bl;
    }
  }
});

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sl-btn',
  props: {
    text: {
      type: String,
      default: ''
    },
    href: {
      type: String,
      default: ''
    }
  }
});

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sl-box',
  props: {
    title: {
      type: String,
      default: ''
    },
    cnt: {
      default: ''
    },
    index: {
      default: 0
    }
  },
  computed: {
    value: function value() {
      var cnt = this.cnt.toString();
      return cnt;
    },

    classObject: function classObject() {
      return {
        aclass: this.index === 0,
        bclass: this.index === 1,
        cclass: this.index === 2,
        dclass: this.index === 3,
        eclass: this.index === 4,
        fclass: this.index === 5,
        gclass: this.index === 6
      };
    }
  }
});

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sl-btn',
  props: {
    icon: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'column',
  props: {
    'class': {
      type: String,
      default: ''
    }
  },
  created: function created() {}
});

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sl_box__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sl_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__sl_box__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sl-show-box',
  components: {
    SlBox: __WEBPACK_IMPORTED_MODULE_0__sl_box___default.a
  },
  data: function data() {
    return {
      loading: true
    };
  },

  props: {
    data: {
      type: Array,
      default: []
    }
  },
  watch: {
    data: function data(item) {
      this.loading = item.length === 0 ? true : !true;
    }
  }
});

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    top: function top() {
      return (document.documentElement.clientHeight - 300) / 2 + 'px';
    }
  },
  props: {
    data: {
      title: '',
      cnt1: '',
      cnt2: '',
      btn1: '',
      btn2: '',
      showBtn1: true
    }
  }
});

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_types__ = __webpack_require__(10);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sl-switcher',
  data: function data() {
    return {
      switchArray: [{
        label: this.$t('Date.today'),
        value: 'hour'
      }, {
        label: this.$tc('Date.dateRange', 0),
        value: 'week'
      }, {
        label: this.$tc('Date.dateRange', 1),
        value: 'month'
      }, {
        label: this.$tc('Date.dateRange', 2),
        value: 'year'
      }],
      switchActive: 0
    };
  },

  methods: {
    handleSwitcher: function handleSwitcher(index) {
      this.$ga.event('Button', 'DateSwitcher:' + this.switchArray[index].value, 'Dashboard');
      this.switchActive = index;
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_types__["o" /* ACTIVETIME */], this.switchArray[index].value);
    }
  }
});

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      info: {
        title: this.$t('Views.401.title'),
        cnt1: this.$t('Views.401.cnt1'),
        cnt2: this.$t('Views.401.cnt2'),
        btn1: this.$t('Views.401.btn1'),
        btn2: this.$t('Views.401.btn2'),
        showBtn1: false
      }
    };
  }
});

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      info: {
        title: this.$t('Views.404.title'),
        cnt1: this.$t('Views.404.cnt1'),
        cnt2: this.$t('Views.404.cnt2'),
        btn1: this.$t('Views.404.btn1'),
        btn2: this.$t('Views.404.btn2'),
        showBtn1: true
      }
    };
  }
});

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      info: {
        title: this.$t('Views.500.title'),
        cnt1: this.$t('Views.500.cnt1'),
        cnt2: this.$t('Views.500.cnt2'),
        btn1: this.$t('Views.500.btn1'),
        btn2: this.$t('Views.500.btn2'),
        showBtn1: true
      }
    };
  }
});

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_echart_config__ = __webpack_require__(122);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'analytics-customers',
  data: function data() {
    return {
      tab: 'first',
      first: {
        box: [],
        customersRadio: 'op1',
        customersOption: {
          default: null,
          week: {},
          month: {},
          year: {}
        }
      },

      third: {
        customerStatusOption: null,
        customerFrequencyOption: null,
        customerContributionOption: null,
        customerStatusTable: [],
        customerFrequencyTable: [],
        customerContributionTable: [],
        categoryRadio: 'all',
        categoryRadioArr: [],
        categoryTableAllData: [],
        categoryTableData: []
      },
      fourth: {
        outletOption: null
      }
    };
  },

  methods: {
    tabClick: function tabClick() {
      var vm = this;
      if (this.tab === 'first') {
        __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].FetchAnalyticsCustomersTabAChart().then(function (res) {
          var result = res.data.data;
          vm.first.customersOption.default = __WEBPACK_IMPORTED_MODULE_2__util_echart_config__["getMultipleLineOption"](result.week, __WEBPACK_IMPORTED_MODULE_2__util_echart_config__);
          vm.first.customersOption.week = createOption(result.week);
          vm.first.customersOption.month = createOption(result.month);
          vm.first.customersOption.year = createOption(result.year);
          vm.$nextTick(function () {
            vm.$refs.firstCustomers.resize();
          });
        });
      } else if (this.tab === 'second') {
        __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].FetchAnalyticsTransactionsTabBChart().then(function (res) {
          var result = res.data.data;
          vm.second.channelOption.default = __WEBPACK_IMPORTED_MODULE_2__util_echart_config__["getSingleBarOption"](result.week, __WEBPACK_IMPORTED_MODULE_2__util_echart_config__, result.legend);
          vm.second.channelOption.week = result.week;
          vm.second.channelOption.month = result.month;
          vm.second.channelOption.year = result.year;
          vm.$nextTick(vm.$refs.byChannel.resize());
        });
      } else if (this.tab === 'third') {
        __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].FetchAnalyticsCustomersTabBChart().then(function (res) {
          var result = res.data.data;
          var color = ['#c23531', '#61a0a8', '#2f4554'];
          var Ylabel = ['Low contribution customers', 'Mid contribution customers', 'High contribution customers'];
          vm.third.customerStatusTable = result.category['customerStatus'].map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item, {
              color: color[index]
            });
          });
          vm.third.customerFrequencyTable = result.category['customerFrequency'].map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item, {
              color: color[index]
            });
          });
          vm.third.customerContributionTable = result.category['customerContribution'].map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item, {
              color: color[index]
            });
          });
          vm.third.customerStatusOption = __WEBPACK_IMPORTED_MODULE_2__util_echart_config__["getPieOption"](result.category['customerStatus'], __WEBPACK_IMPORTED_MODULE_2__util_echart_config__, 'Customer status');
          vm.third.customerFrequencyOption = __WEBPACK_IMPORTED_MODULE_2__util_echart_config__["getPieOption"](result.category['customerFrequency'], __WEBPACK_IMPORTED_MODULE_2__util_echart_config__, 'Customer frequency');
          vm.third.customerContributionOption = __WEBPACK_IMPORTED_MODULE_2__util_echart_config__["getPieOption"](result.category['customerContribution'], __WEBPACK_IMPORTED_MODULE_2__util_echart_config__, 'Customer contribution');
          vm.$nextTick(function () {
            vm.$refs.fourthOutlet.resize();
          });

          vm.third.categoryRadioArr = result.detail.map(function (item) {
            return item.total;
          });
          vm.third.categoryTableAllData = result.detail.map(function (item, index) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item, {
              name: Ylabel[index]
            });
          });
          vm.third.categoryTableData = vm.third.categoryTableAllData[0];
          vm.third.categoryRadio = 'all';
        });
      } else if (this.tab === 'fourth') {
        __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].FetchAnalyticsCustomersTabDChart().then(function (res) {
          var result = res.data.data;
          vm.fourth.outletOption = __WEBPACK_IMPORTED_MODULE_2__util_echart_config__["getBarOption"](result.outlet, __WEBPACK_IMPORTED_MODULE_2__util_echart_config__, 'ARPC by store');
          vm.$nextTick(function () {
            vm.$refs.fourthOutlet.resize();
          });
        });
      }
    },
    resetFirstCustomersOp: function resetFirstCustomersOp(params, name) {
      this.$refs.firstCustomers.mergeOptions({
        xAxis: [{
          data: this.first.customersOption[params].xAxis
        }],
        series: this.first.customersOption[params].yAxis
      });
    },
    swithThirdTableData: function swithThirdTableData(index) {
      this.third.categoryTableData = this.third.categoryTableAllData[index];
    }
  },
  created: function created() {
    var vm = this;
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].FetchAnalyticsCustomersTabABox().then(function (res) {
      vm.first.box = res.data.data;
    });
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].FetchAnalyticsCustomersTabAChart().then(function (res) {
      var result = res.data.data;
      vm.first.customersOption.default = __WEBPACK_IMPORTED_MODULE_2__util_echart_config__["getMultipleLineOption"](result.week, __WEBPACK_IMPORTED_MODULE_2__util_echart_config__);
      vm.first.customersOption.week = createOption(result.week);
      vm.first.customersOption.month = createOption(result.month);
      vm.first.customersOption.year = createOption(result.year);
      vm.$nextTick(function () {
        vm.$refs.firstCustomers.resize();
      });
    });
  }
});

function createOption(op) {
  op.yAxis = op.yAxis.map(function (item) {
    return {
      name: item.name,
      data: item.value,
      type: 'line'
    };
  });
  return op;
}

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_echart_config__ = __webpack_require__(122);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'analytics-outlets',
  data: function data() {
    return {
      tab: 'first',
      first: {
        channelOption: {
          default: null,
          today: {},
          week: {},
          month: {},
          year: {}
        },
        channelRadio: 'op0'
      },
      second: {
        transactionsOption: null,
        refundOption: null
      }
    };
  },

  methods: {
    tabClick: function tabClick() {
      var vm = this;
      if (this.tab === 'first') {
        this.first.channelRadio = 'op0';
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].FetchAnalyticsOutletsTabAChart().then(function (res) {
          var result = res.data.data;
          vm.first.channelOption.default = __WEBPACK_IMPORTED_MODULE_1__util_echart_config__["getMultipleAreaOption"](result.hour, __WEBPACK_IMPORTED_MODULE_1__util_echart_config__);
          vm.first.channelOption.today = createOption(result.hour);
          vm.first.channelOption.week = createOption(result.week);
          vm.first.channelOption.month = createOption(result.month);
          vm.first.channelOption.year = createOption(result.year);
          vm.$nextTick(function () {
            vm.$refs.perChannel.resize();
          });
        });
      } else if (this.tab === 'second') {
        __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].FetchAnalyticsOutletsTabBChart().then(function (res) {
          var result = res.data.data;
          vm.second.transactionsOption = __WEBPACK_IMPORTED_MODULE_1__util_echart_config__["getSinglePieOption"](result.transaction, __WEBPACK_IMPORTED_MODULE_1__util_echart_config__);

          vm.second.refundOption = __WEBPACK_IMPORTED_MODULE_1__util_echart_config__["getSinglePieOption"](result.refund, __WEBPACK_IMPORTED_MODULE_1__util_echart_config__);
          vm.$nextTick(function () {
            vm.$refs.percentageTransactions.resize();
            vm.$refs.percentageRefund.resize();
          });
        });
      }
    },
    resetPerChannelOption: function resetPerChannelOption(params, name) {
      this.$refs.perChannel.mergeOptions({
        xAxis: [{
          data: this.first.channelOption[params].xAxis
        }],
        series: this.first.channelOption[params].yAxis
      });
    }
  },
  created: function created() {
    var vm = this;
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].FetchAnalyticsOutletsTabAChart().then(function (res) {
      var result = res.data.data;
      vm.first.channelOption.default = __WEBPACK_IMPORTED_MODULE_1__util_echart_config__["getMultipleAreaOption"](result.hour, __WEBPACK_IMPORTED_MODULE_1__util_echart_config__);
      vm.first.channelOption.today = createOption(result.hour);
      vm.first.channelOption.week = createOption(result.week);
      vm.first.channelOption.month = createOption(result.month);
      vm.first.channelOption.year = createOption(result.year);
      vm.$nextTick(function () {
        vm.$refs.perChannel.resize();
      });
    });
  }
});

function createOption(op) {
  op.yAxis = op.yAxis.map(function (item) {
    return {
      name: item.name,
      data: item.value,
      type: 'line',
      areaStyle: {
        normal: {}
      }
    };
  });
  return op;
}

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_echart_config__ = __webpack_require__(122);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'analytics-transactions',
  data: function data() {
    return {
      tab: 'first',
      first: {
        box: [],
        statusOption: {
          default: __WEBPACK_IMPORTED_MODULE_2__util_echart_config__["line"],
          week: {},
          month: {},
          year: {}
        },
        statusRadio: 'op1'
      },
      second: {
        channelOption: {
          default: null,
          week: {},
          month: {},
          year: {}
        },
        channelRadio: 'op1'
      },
      third: {
        channelOption: null,
        outletOption: null,
        statusOption: null
      }
    };
  },

  methods: {
    tabClick: function tabClick() {
      var _this = this;

      var vm = this;
      if (this.tab === 'second') {
        __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].FetchAnalyticsTransactionsTabBChart().then(function (res) {
          _this.second.channelRadio = 'op1';
          var result = res.data.data;
          vm.second.channelOption.default = __WEBPACK_IMPORTED_MODULE_2__util_echart_config__["getSingleBarOption"](result.week, __WEBPACK_IMPORTED_MODULE_2__util_echart_config__);
          vm.second.channelOption.week = result.week;
          vm.second.channelOption.month = result.month;
          vm.second.channelOption.year = result.year;
          vm.$nextTick(function () {
            vm.$refs.byChannel.resize();
          });
        });
      } else if (this.tab === 'third') {
        __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].FetchAnalyticsTransactionsTabCChart().then(function (res) {
          var result = res.data.data;
          vm.third.channelOption = __WEBPACK_IMPORTED_MODULE_2__util_echart_config__["getDoublePieOption"](result.channel, __WEBPACK_IMPORTED_MODULE_2__util_echart_config__, ['', '']);
          vm.third.outletOption = __WEBPACK_IMPORTED_MODULE_2__util_echart_config__["getSinglePieOption"](result.outlet, __WEBPACK_IMPORTED_MODULE_2__util_echart_config__);
          vm.third.statusOption = __WEBPACK_IMPORTED_MODULE_2__util_echart_config__["getSinglePieOption"](result.status, __WEBPACK_IMPORTED_MODULE_2__util_echart_config__);
          vm.$nextTick(function () {
            vm.$refs.percentageChannel.resize();

            vm.$refs.percentageStatus.resize();
          });
        });
      } else if (this.tab === 'first') {
        this.first.statusRadio = 'op1';
        __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].FetchAnalyticsTransactionsTabAChart().then(function (res) {
          var result = res.data.data;
          vm.first.statusOption.week = result.week;
          vm.first.statusOption.month = result.month;
          vm.first.statusOption.year = result.year;
          vm.resetStatusOp('week', 'Recent 7 days');
          vm.$nextTick(vm.$refs.status.resize());
        });
      }
    },
    resetStatusOp: function resetStatusOp(params, name) {
      this.$refs.status.mergeOptions({
        tooltip: {
          formatter: '{b}<br/>Per Channel : ' + this.$store.state.theme.companyInfo.currency + '{c}'
        },
        xAxis: [{
          data: this.first.statusOption[params].xAxis
        }],
        yAxis: [{
          min: Math.min.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.first.statusOption[params].yAxis))
        }],
        series: [{
          data: this.first.statusOption[params].yAxis
        }]
      });
    },
    resetChannelOp: function resetChannelOp(params, name) {
      this.$refs.byChannel.mergeOptions({
        legend: {
          data: this.second.channelOption[params].yAxis.map(function (item) {
            return item.name;
          })
        },
        xAxis: [{
          data: this.second.channelOption[params].xAxis
        }],
        series: convertData(this.second.channelOption[params].yAxis)
      });
    }
  },
  created: function created() {
    var vm = this;

    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].FetchAnalyticsTransactionsTabAChart().then(function (res) {
      var result = res.data.data;
      vm.first.statusOption.week = result.week;
      vm.first.statusOption.month = result.month;
      vm.first.statusOption.year = result.year;
      vm.resetStatusOp('week', 'Recent 7 days');
    });
  }
});

function convertData(yAxis) {
  return yAxis.map(function (item) {
    return {
      name: item.name,
      stack: item.stack,
      data: item.value,
      type: 'bar'
    };
  });
}

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);







/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    var vm = this;
    __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].FetchCouponNameById({
      typeId: this.$route.query.id,
      lang: this.$store.state.user.userinfo.lang !== '' ? this.$store.state.user.userinfo.lang : 'en'
    }).then(function (res) {
      if (res.data.code === 200) {
        vm.defaultOP = vm.createArr(res.data.data);
        vm.CouponOP = vm.formatCoupon(vm.$route.query.id, res.data.data);
        vm.form.nameId = vm.CouponOP[0].id;
      }
    });
  },

  computed: {
    r1: function r1() {
      if (this.$route.query.id === '1') {
        this.form.minSpending = '';
        this.form.discountPrice = '';
        return 'Storewide ' + this.form.discount + '% Off';
      } else if (this.$route.query.id === '2') {
        this.form.discount = '';
        return this.$store.state.theme.companyInfo.currency + ' ' + this.form.discountPrice + ' Off with ' + this.$store.state.theme.companyInfo.currency + ' ' + this.form.minSpending + ' Spend';
      } else if (this.$route.query.id === '3') {
        this.form.discountPrice = '';
        return this.form.discount + '% Off with ' + this.$store.state.theme.companyInfo.currency + ' ' + this.form.minSpending + ' Spend';
      }
    },
    time: function time() {
      var month = this.form.month === '1' ? 1 : 3;
      return __WEBPACK_IMPORTED_MODULE_4_moment___default()(new Date()).format('YYYY.MM.DD') + ' - ' + __WEBPACK_IMPORTED_MODULE_4_moment___default()(new Date()).add(month, 'months').format('YYYY.MM.DD');
    },
    rules: function rules() {
      return [this.$t('Views.AddCoupon.r1') + ' ' + this.r1, this.$t('Views.AddCoupon.r2') + this.time, this.$t('Views.AddCoupon.r3'), this.$t('Views.AddCoupon.r4'), this.$t('Views.AddCoupon.r5'), this.$t('Views.AddCoupon.r6')];
    }
  },
  data: function data() {
    return {
      btnDisabled: false,
      maxlength: 2,
      loading: false,
      couponDialog: false,
      form: {
        month: '1',
        discount: 10,
        nameId: '',
        typeId: this.$route.query.id,
        minSpending: 100,
        discountPrice: 10
      },
      type: {},
      CouponOP: [],
      defaultOP: [],
      showErr: false,
      errorMsg: ''
    };
  },

  methods: {
    publish: function publish() {
      this.$ga.event('Button', 'Publish', 'Add coupon');
      var vm = this;
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].PublishCoupon(this.form).then(function (res) {
        if (res.data.code === 200) {
          vm.$router.push({
            name: 'Coupon-List',
            query: {
              new: 1
            }
          });
        } else {
          vm.$notify.error({
            title: 'fail',
            message: res.data.msg
          });
        }
      });
    },
    goBack: function goBack() {
      this.$ga.event('Link', 'Back', 'Add coupon');
      this.$router.back();
    },
    createArr: function createArr(arr) {
      return JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(arr));
    },
    handleChange: function handleChange(val) {
      if (this.$route.query.id === '1') {
        if (this.form.discount === '') {
          this.btnDisabled = true;
        } else {
          this.btnDisabled = false;
          this.showErr = false;
        }
      } else if (this.$route.query.id === '2') {
        if (this.form.minSpending === '' || this.form.discountPrice === '') {
          this.btnDisabled = true;
        } else {
          this.btnDisabled = false;
          this.showErr = false;
        }
      } else if (this.$route.query.id === '3') {
        if (this.form.minSpending === '' || this.form.discount === '') {
          this.btnDisabled = true;
        } else {
          this.btnDisabled = false;
          this.showErr = false;
        }
      }
      this.CouponOP = this.formatCoupon(this.$route.query.id, this.createArr(this.defaultOP));
    },
    handlePublish: function handlePublish() {
      if (this.$route.query.id === '1') {
        if (this.form.discount === '') {
          this.btnDisabled = true;
        } else if (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(this.form.discount)) {
          this.errorMsg = this.$t('Views.AddCoupon.msg1');
          this.showErr = true;
          this.btnDisabled = false;
          return false;
        } else if (this.form.discount > 99 || this.form.discount < 1) {
          this.errorMsg = this.$t('Views.AddCoupon.msg2');
          this.showErr = true;
          this.btnDisabled = false;
          return false;
        } else if (/^(1|99|\d{1,2})$/.test(this.form.discount)) {
          this.showErr = false;
          this.btnDisabled = false;
        }
      } else if (this.$route.query.id === '2') {
        if (this.form.minSpending === '' || this.form.discountPrice === '') {
          this.btnDisabled = true;
        } else if (this.form.minSpending > 10000) {
          this.errorMsg = this.$t('Views.AddCoupon.msg3');
          this.showErr = true;
          this.btnDisabled = false;
          return false;
        } else if (this.form.minSpending <= 0) {
          this.errorMsg = this.$t('Views.AddCoupon.msg4');
          this.showErr = true;
          this.btnDisabled = false;
          return false;
        } else if (this.form.discountPrice <= 0) {
          this.errorMsg = this.$t('Views.AddCoupon.msg5');
          this.showErr = true;
          this.btnDisabled = false;
          return false;
        } else if (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(this.form.minSpending)) {
          this.errorMsg = this.$t('Views.AddCoupon.msg6');
          this.showErr = true;
          this.btnDisabled = false;
          return false;
        } else if (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(this.form.discountPrice)) {
          this.errorMsg = this.$t('Views.AddCoupon.msg7');
          this.showErr = true;
          this.btnDisabled = false;
          return false;
        } else if (this.form.discountPrice >= this.form.minSpending) {
          this.errorMsg = this.$t('Views.AddCoupon.msg8');
          this.showErr = true;
          this.btnDisabled = false;
          return false;
        } else {
          this.showErr = false;
          this.btnDisabled = false;
        }
      } else if (this.$route.query.id === '3') {
        if (this.form.minSpending === '' || this.form.discount === '') {
          this.btnDisabled = true;
        } else if (this.form.minSpending > 10000) {
          this.errorMsg = this.$t('Views.AddCoupon.msg3');
          this.showErr = true;
          this.btnDisabled = false;
          return false;
        } else if (this.form.minSpending <= 0) {
          this.errorMsg = this.$t('Views.AddCoupon.msg4');
          this.showErr = true;
          this.btnDisabled = false;
          return false;
        } else if (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(this.form.minSpending)) {
          this.errorMsg = this.$t('Views.AddCoupon.msg6');
          this.showErr = true;
          this.btnDisabled = false;
          return false;
        } else if (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(this.form.discount)) {
          this.errorMsg = this.$t('Views.AddCoupon.msg1');
          this.showErr = true;
          this.btnDisabled = false;
          return false;
        } else if (this.form.discount > 99 || this.form.discount < 1) {
          this.errorMsg = this.$t('Views.AddCoupon.msg2');
          this.showErr = true;
          this.btnDisabled = false;
          return false;
        } else {
          this.showErr = false;
          this.btnDisabled = false;
        }
      }
      this.couponDialog = true;
    },
    formatCoupon: function formatCoupon(id, arr) {
      var vm = this;
      if (id === '1') {
        arr.map(function (item) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(item, {
            name: item.name.replace('_X', vm.form.discount).replace('&Merchant Name', vm.$store.state.user.userinfo.merchantName)
          });
        });
      } else if (id === '2') {
        arr.map(function (item) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(item, {
            name: item.name.replace('_A', vm.form.minSpending).replace('_S', vm.form.discountPrice).replace('&Merchant Name', vm.$store.state.user.userinfo.merchantName)
          });
        });
      } else if (id === '3') {
        arr.map(function (item) {
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(item, {
            name: item.name.replace('_A', vm.form.minSpending).replace('_X', vm.form.discount).replace('&Merchant Name', vm.$store.state.user.userinfo.merchantName)
          });
        });
      }
      return arr;
    }
  }
});

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_types__ = __webpack_require__(10);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      btnLoading: false,
      agree: false,
      cnt: ['The discount applies to all products in entire store.Example:  The discount: 10% offThe total sales amount before discount: $110. The total amount payable after discount (collect from consumer): $110 * (1-0.1) = $99', 'The discount applies to all products in entire store.Example:  The discount: 10% offThe total sales amount before discount: $110. The total amount payable after discount (collect from consumer): $110 * (1-0.1) = $99。The discount applies to all products in entire store.Example:  The discount: 10% offThe total sales amount before discount: $110. The total amount payable after discount (collect from consumer): $110 * (1-0.1) = $99', 'The discount applies to all products in entire store.Example:  The discount: 10% offThe total sales amount before discount: $110. The total amount payable after discount (collect from consumer): $110 * (1-0.1) = $99', 'The discount applies to all products in entire store.Example:  The discount: 10% offThe total sales amount before discount: $110. The total amount payable after discount (collect from consumer): $110 * (1-0.1) = $99。The discount applies to all products in entire store.Example:  The discount: 10% offThe total sales amount before discount: $110. The total amount payable after discount (collect from consumer): $110 * (1-0.1) = $99']
    };
  },

  methods: {
    handleAgree: function handleAgree() {
      var _this = this;

      this.$ga.event('Button', 'Confirm', 'Agreement');
      this.btnLoading = true;
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].agreeCoupon({
        agreeCoupon: '1'
      }).then(function (res) {
        if (res.data.code === 200) {
          vm.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_types__["w" /* AGREECOUPON */]);
          _this.btnLoading = false;
          vm.$router.push({
            name: 'Choose-Coupon'
          });
        } else {
          vm.$message.error(res.data.msg);
        }
      });
    }
  }
});

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(6);



/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    var vm = this;
    this.fullLoading = true;
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].FetchCouponType().then(function (res) {
      vm.types = res.data.data;
      vm.fullLoading = false;
    });
  },

  methods: {
    goBack: function goBack() {
      this.$ga.event('Link', 'Back', 'Choose coupon');
      this.$router.back();
    }
  },
  data: function data() {
    return {
      fullLoading: false,
      types: []
    };
  }
});

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["default"] = ({
  created: function created() {
    var params = {
      per: 100,
      page: 1
    };
    var vm = this;
    this.validLoading = true;
    this.invalidLoading = true;
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].FetchCouponList(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
      status: 1
    }, params)).then(function (res) {
      vm.valid = res.data.list.map(function (item) {
        return vm.formatCoupon(item.typeId, item);
      });
      vm.validLoading = false;
    });
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].FetchCouponList(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({
      status: 99
    }, params)).then(function (res) {
      vm.invalid = res.data.list.map(function (item) {
        return vm.formatCoupon(item.typeId, item);
      });
      vm.invalidLoading = false;
    });
  },
  data: function data() {
    return {
      invalid: [],
      valid: [],
      validLoading: false,
      invalidLoading: false
    };
  },

  methods: {
    formatCoupon: function formatCoupon(id, item) {
      if (id === '1') {
        item.name = item.name.replace('_X', item.discount).replace('&Merchant Name', this.$store.state.user.userinfo.merchantName);
      } else if (id === '2') {
        item.name = item.name.replace('_A', item.minSpending).replace('_S', item.discountPrice).replace('&Merchant Name', this.$store.state.user.userinfo.merchantName);
      } else if (id === '3') {
        item.name = item.name.replace('_A', item.minSpending).replace('_X', item.discount).replace('&Merchant Name', this.$store.state.user.userinfo.merchantName);
      }
      return item;
    }
  }
});

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      fullLoading: false
    };
  },

  computed: {
    email: function email() {
      return this.$route.query.email && this.$route.query.email !== '' ? this.$route.query.email : this.$store.state.theme.companyInfo.email;
    },
    number: function number() {
      return this.$route.query.number && this.$route.query.number !== '' ? this.$route.query.number : this.$store.state.theme.companyInfo.phone;
    }
  }
});

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(6);





var defaultOp = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Customers',
  data: function data() {
    return {
      loading: false,
      checkList: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
      checkAll: true,
      options: defaultOp,
      isIndeterminate: false,
      tableData: [],
      table: {
        total: 0,
        page: 1,
        per: 10,
        order: '',
        orderBy: ''
      },
      condition: {
        type: ''
      }
    };
  },
  created: function created() {
    updateTable(this);
  },

  methods: {
    handleSizeChange: function handleSizeChange(per) {
      var param = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, initParams(this.table, this.condition, this));
      param.per = per;
      updateTable(this, param);
    },
    handleCurrentChange: function handleCurrentChange(page) {
      var param = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, initParams(this.table, this.condition, this));
      param.page = page;
      updateTable(this, param);
    },
    handleSortChange: function handleSortChange(_ref) {
      var column = _ref.column,
          prop = _ref.prop,
          order = _ref.order;

      var param = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, initParams(this.table, this.condition, this));
      param.order = order === null ? '' : order === 'descending' ? 'DESC' : 'ASC';
      param.orderBy = prop === null ? '' : prop;
      updateTable(this, param);
    },
    handleCheckAllChange: function handleCheckAllChange(event) {
      this.checkList = event.target.checked ? defaultOp : [];
      this.isIndeterminate = false;
    },
    handleCheckedChange: function handleCheckedChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.options.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.options.length;
    },
    searchByCondition: function searchByCondition() {
      this.$ga.event('Button', 'TableSearch', 'Customers');
      updateTable(this, initParams(this.table, this.condition, this));
    },
    clearSelectors: function clearSelectors() {
      this.$ga.event('Button', 'ClearAll', 'Customers');
      this.isIndeterminate = false;
      this.checkList = [];
      this.checkAll = false;
    }
  }
});

function updateTable(vm) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    per: 10,
    page: 1,
    type: defaultOp.join(',')
  };

  vm.loading = true;
  __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].FetchCustomerTable(params).then(function (res) {
    var result = res.data.data;
    vm.table = {
      total: result.total,
      page: ~~result.page,
      per: ~~result.per,
      order: result.order,
      orderBy: result.orderBy
    };
    vm.tableData = result.list;
    vm.loading = false;
  });
}

function initParams(table, condition, vm) {
  var tb = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(table));
  var cd = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(condition));
  delete tb.total;
  cd.type = vm.checkList.join(',');
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, tb, cd);
}

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_echart_config__ = __webpack_require__(122);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'dashboard',
  data: function data() {
    return {
      rLoading: false,
      nooLoading: false,
      arpcConfig: __WEBPACK_IMPORTED_MODULE_1__util_echart_config__["bar"],
      revenueRadio: 'op1',
      revenueConfig: {
        default: __WEBPACK_IMPORTED_MODULE_1__util_echart_config__["line"],
        hour: {},
        week: {},
        month: {},
        year: {}
      },
      orderRadio: 'op1',
      orderConfig: {
        default: __WEBPACK_IMPORTED_MODULE_1__util_echart_config__["line"],
        hour: {},
        week: {},
        month: {},
        year: {}
      },
      box: []
    };
  },

  computed: {
    switcher: function switcher() {
      return this.$store.state.switcher.activeTime;
    },
    newUser: function newUser() {
      return this.$route.query.new === '1' ? true : !true;
    }
  },
  created: function created() {
    var vm = this;
    this.rLoading = true;
    this.nooLoading = true;
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].FetchDashboardBox().then(function (res) {
      vm.box = res.data.data;
    });
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].FetchDashboardChart3().then(function (res) {
      var result = res.data.data;
      vm.revenueConfig.hour = result.hour;
      vm.revenueConfig.week = result.week;
      vm.revenueConfig.month = result.month;
      vm.revenueConfig.year = result.year;
      vm.resetRevenueOp('hour');
      vm.rLoading = false;
    });
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].FetchDashboardChart4().then(function (res) {
      var result = res.data.data;
      vm.orderConfig.hour = result.hour;
      vm.orderConfig.week = result.week;
      vm.orderConfig.month = result.month;
      vm.orderConfig.year = result.year;
      vm.resetOrderOp('hour');
      vm.nooLoading = false;
    });
  },

  watch: {
    switcher: function switcher(params) {
      this.resetRevenueOp(params, this.$t('Chart.revenue'));
      this.resetOrderOp(params, this.$t('Chart.revenue'));
      this.reRenderBox(params);
    }
  },
  methods: {
    reRenderBox: function reRenderBox(params) {
      var vm = this;
      this.box = [];
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].FetchDashboardBox({
        dateRange: params
      }).then(function (res) {
        vm.box = res.data.data;
      });
    },
    goDashboard: function goDashboard() {
      this.$router.replace({
        name: 'Dashboard'
      });
    },
    resetRevenueOp: function resetRevenueOp(params, name) {
      this.$refs.revenue.mergeOptions({
        tooltip: {
          formatter: '{b}<br/>Revenue : ' + this.$store.state.theme.companyInfo.currency + '{c}'
        },
        xAxis: [{
          data: this.revenueConfig[params].xAxis
        }],
        series: [{
          name: name,
          data: this.revenueConfig[params].yAxis
        }]
      });
    },
    resetOrderOp: function resetOrderOp(params, name) {
      this.$refs.order.mergeOptions({
        tooltip: {
          formatter: '{b}<br/>Number of orders : {c}'
        },
        xAxis: [{
          data: this.orderConfig[params].xAxis
        }],
        series: [{
          name: name,
          data: this.orderConfig[params].yAxis
        }]
      });
    }
  }
});

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_types__ = __webpack_require__(10);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',
  created: function created() {
    this.form.id = this.$route.query.id !== undefined ? this.$route.query.id : '';
  },
  data: function data() {
    return {
      loginLoading: false,

      form: {
        id: '',
        password: ''
      }
    };
  },

  computed: {
    captchaUrl: function captchaUrl() {
      return '/client/securimage?' + this.captchaTime;
    },
    loginName: function loginName() {
      return this.loginLoading ? this.$t('Views.Login.loading') : this.$t('Views.Login.login');
    },
    contentHeight: function contentHeight() {
      return document.documentElement.clientHeight + 'px';
    },
    isPhone: function isPhone() {
      var u = navigator.userAgent;
      var versions = {
        mobile: !!u.match(/AppleWebKit.*Mobile.*/),
        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
        iPhone: u.indexOf('iPhone') > -1
      };
      if (versions.mobile || versions.android || versions.iPhone) {
        return true;
      }
      return false;
    }
  },
  methods: {
    changeImg: function changeImg() {
      this.captchaTime += 1;
    },
    onLogin: function onLogin() {
      this.$ga.event('Link', 'Login', 'Login');
      var vm = this;
      this.loginLoading = true;
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].Login({
        username: this.form.id,
        password: this.form.password
      }).then(function (res) {
        vm.loginLoading = false;
        if (res.data.code === 200) {
          var path = getPath(res.data.data.menu[0]);
          vm.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_types__["q" /* SIGNIN */], {
            result: res.data.data,
            index: path
          });
          vm.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_types__["s" /* SLIDER */], res.data.data);
          if (vm.$store.state.user.userinfo.onBoarding === '1') {
            vm.$router.push({
              name: 'OB-ResetPwd'
            });
          } else if (vm.$store.state.user.userinfo.onBoarding === '2') {
            vm.$router.push({
              name: 'OB-Agreement'
            });
          } else if (vm.$store.state.user.userinfo.onBoarding === '3') {
            vm.$router.push({
              name: 'OB-ServiceFee'
            });
          } else {
            vm.$router.push({
              path: path
            });
          }
        } else {
          vm.$notify.error({
            title: res.data.msg,
            message: vm.$t('Views.Login.msg')
          });
        }
        vm.loginLoading = false;
      }).catch(function (error) {
        vm.loginLoading = false;

        vm.$notify.error({
          title: vm.$t('Notify.err'),
          message: error.msg
        });
      });
    }
  }
});

function getPath(arr) {
  var url = arr.url;
  if (url === '#') {
    return arr.children[0].url;
  }
  return url;
}

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_types__ = __webpack_require__(10);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Accounts',
  data: function data() {
    return {
      loading: false,
      tableData: [],
      table: this.$store.state.accounts.table,
      condition: this.$store.state.accounts.condition,
      statusOp: [{
        label: 'On',
        value: '1'
      }, {
        label: 'Off',
        value: '2'
      }],
      reloadBtn: false
    };
  },

  methods: {
    formatterAdmin: function formatterAdmin(row, column) {
      return row.admin === '1' ? this.$tc('Functional.yes', 2) : this.$tc('Functional.no', 2);
    },
    formatterStatus: function formatterStatus(row) {
      return row.status === '1' ? 'ON' : 'OFF';
    },
    edit: function edit(id) {
      this.$ga.event('Link', 'Edit', 'Create new account');
      this.$router.push({
        name: 'Update-Account',
        params: {
          id: id
        }
      });
    },
    handleSizeChange: function handleSizeChange(per) {
      this.table.per = per;
      updateTable(this, initParams(this));
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.table.page = page;
      updateTable(this, initParams(this));
    },
    handleSortChange: function handleSortChange(_ref) {
      var column = _ref.column,
          prop = _ref.prop,
          order = _ref.order;

      this.table = {
        page: this.table.page,
        per: this.table.per,
        order: order === null ? '' : order === 'descending' ? 'DESC' : 'ASC',
        orderBy: prop === null ? '' : prop
      };
      updateTable(this, initParams(this));
    },
    searchByCondition: function searchByCondition() {
      this.$ga.event('Button', 'TableSearch', 'Accounts');
      updateTable(this, initParams(this));
    },
    reloadTable: function reloadTable() {
      this.$ga.event('Button', 'Reload', 'Accounts');
      updateTable(this, initParams(this));
    }
  },
  created: function created() {
    updateTable(this, initParams(this));
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name !== 'Update-Account') {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_types__["k" /* InitAccountTable */]);
    }
    next();
  }
});

function updateTable(vm, params) {
  vm.loading = true;
  __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].FetchAccountsTable(params).then(function (res) {
    var result = res.data.data;
    vm.table = {
      total: result.total,
      page: ~~result.page,
      per: ~~result.per,
      order: result.order,
      orderBy: result.orderBy
    };
    vm.tableData = result.list;
    vm.reloadBtn = vm.loading = false;
  }).catch(function (error) {
    console.log(error);
    vm.tableData = [];
    vm.loading = false;
    vm.reloadBtn = true;
  });
}

function initParams(vm) {
  vm.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_types__["j" /* SetAccountTable */], {
    table: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, vm.table),
    condition: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, vm.condition)
  });
  var ts = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, vm.$store.state.accounts);
  var tb = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(ts.table));
  var cd = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(ts.condition));
  delete tb.total;
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, tb, cd);
}

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(6);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'add-new-account',
  created: function created() {
    this.label = {
      name: this.$t('Views.AddNewAccount.form.name'),
      username: this.$t('Views.AddNewAccount.form.username'),
      phone: this.$t('Views.AddNewAccount.form.phone'),
      email: this.$t('Views.AddNewAccount.form.email'),
      admin: this.$t('Views.AddNewAccount.form.admin'),
      password: this.$t('Views.AddNewAccount.form.password')
    };
  },
  data: function data() {
    return {
      loading: false,
      label: {},
      form: {
        name: '',
        username: '',
        password: '',
        phone: '',
        email: '',
        admin: '1'
      }
    };
  },

  methods: {
    errorMsg: function errorMsg(res) {
      this.$notify.error({
        title: 'failed',
        message: res.data.msg
      });
    },
    successMsg: function successMsg(res) {
      this.$notify.success({
        title: 'success',
        message: res.data.msg
      });
    },
    onSubmit: function onSubmit() {
      this.$ga.event('Button', 'Save', 'Add new account');
      var vm = this;
      vm.loading = true;
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].SaveNewAccount(this.form).then(function (res) {
        if (res.data.code === 200) {
          vm.successMsg(res);
          vm.$router.push({
            name: 'Accounts'
          });
        } else {
          vm.errorMsg(res);
        }
        vm.loading = false;
      }).catch(function (error) {
        alert(error);
      });
    }
  }
});

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'update-account',
  created: function created() {
    var vm = this;
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].FetchAccountById(this.$route.params.id).then(function (res) {
      if (res.data.code === 200) {
        var form = res.data.data;
        vm.form = form;
      } else {
        vm.errorMsg(res);
      }
      vm.loading = false;
    }).catch(function (error) {
      vm.loading = false;
      vm.$message.error(error + '');
    });
  },

  computed: {
    label: function label() {
      return {
        name: this.$t('Views.AddNewAccount.form.name'),
        username: this.$t('Views.AddNewAccount.form.username'),
        phone: this.$t('Views.AddNewAccount.form.phone'),
        email: this.$t('Views.AddNewAccount.form.email'),
        admin: this.$t('Views.AddNewAccount.form.admin'),
        password: this.$t('Views.AddNewAccount.form.password'),
        status: this.$t('Views.AddNewAccount.form.status')
      };
    }
  },
  data: function data() {
    return {
      loading: true,
      form: {
        name: '',
        username: '',
        password: '',
        phone: '',
        email: '',
        admin: NaN,
        status: NaN
      }
    };
  },

  methods: {
    errorMsg: function errorMsg(res) {
      this.$notify.error({
        title: 'failed',
        message: res.data.msg
      });
    },
    successMsg: function successMsg(res) {
      this.$notify.success({
        title: 'success',
        message: res.data.msg
      });
    },
    onSubmit: function onSubmit() {
      this.$ga.event('Button', 'Save', 'Update account');
      var vm = this;
      var form = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.form));
      if (form.password === '') {
        delete form.password;
      }
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].UpdateAccount(this.$route.params.id, form).then(function (res) {
        if (res.data.code === 200) {
          vm.successMsg(res);
          vm.$router.go(-1);
        } else {
          vm.errorMsg(res);
        }
        vm.loading = false;
      }).catch(function (error) {
        vm.loading = false;
        vm.$message.error(error + '');
      });
    },
    onDelete: function onDelete() {
      this.$ga.event('Button', 'Delete', 'Update account');
      var vm = this;
      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].DeleteAccount(this.$route.params.id).then(function (res) {
        if (res.data.code === 200) {
          vm.successMsg(res);
          vm.$router.go(-1);
        } else {
          vm.errorMsg(res);
        }
        vm.loading = false;
      }).catch(function (error) {
        vm.loading = false;
        vm.$message.error(error + '');
      });
    }
  }
});

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_instant_pdf_viewer__ = __webpack_require__(426);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'DownloadContract',
  components: {
    'vue-pdf-viewer': __WEBPACK_IMPORTED_MODULE_1_vue_instant_pdf_viewer__["a" /* default */]
  },
  data: function data() {
    return {
      src: '',
      loading: false
    };
  },

  computed: {
    height: function height() {
      return document.documentElement.clientHeight - 100 + 'px';
    }
  },
  created: function created() {
    var _this = this;

    var vm = this;
    this.loading = true;
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].FetchContract({
      merchantId: this.$store.state.user.userinfo.merchantId,
      name: this.$store.state.theme.name
    }).then(function (res) {
      if (res.data.code === 200) {
        vm.src = res.data.data.contractUrl + '&type=agreement';
      }
      _this.loading = false;
    });
  }
});

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_date__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_types__ = __webpack_require__(10);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Accounts',
  data: function data() {
    return {
      loading: false,
      tableData: [],
      table: this.$store.state.invoices.table,
      condition: this.$store.state.invoices.condition,
      datePicker: '',
      reloadBtn: false
    };
  },

  methods: {
    formatterAdmin: function formatterAdmin(row, column) {
      return row.admin === '1' ? this.$tc('Functional.yes', 2) : this.$tc('Functional.no', 2);
    },
    filterStatus: function filterStatus(value, row) {
      return row.status === value;
    },
    handleSizeChange: function handleSizeChange(per) {
      this.table.per = per;
      updateTable(this, initParams(this));
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.table.page = page;
      updateTable(this, initParams(this));
    },
    handleSortChange: function handleSortChange(_ref) {
      var column = _ref.column,
          prop = _ref.prop,
          order = _ref.order;

      this.table = {
        page: this.table.page,
        per: this.table.per,
        order: order === null ? '' : order === 'descending' ? 'DESC' : 'ASC',
        orderBy: prop === null ? '' : prop
      };
      updateTable(this, initParams(this));
    },
    searchByCondition: function searchByCondition() {
      this.$ga.event('Button', 'TableSearch', 'Invoices');
      updateTable(this, initParams(this));
    },
    reloadTable: function reloadTable() {
      this.$ga.event('Button', 'Reload', 'Invoices');
      updateTable(this, initParams(this));
    }
  },
  created: function created() {
    updateTable(this, initParams(this));
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    next();
  }
});

function updateTable(vm, params) {
  vm.loading = true;
  __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].FetchInvoiceTable(params).then(function (res) {
    var result = res.data.data;
    vm.table = {
      total: result.total,
      page: ~~result.page,
      per: ~~result.per
    };
    vm.tableData = result.list;
    vm.reloadBtn = vm.loading = false;
  }).catch(function (error) {
    console.log(error);
    vm.tableData = [];
    vm.loading = false;
    vm.reloadBtn = true;
  });
}

function initParams(vm) {
  vm.$store.commit(__WEBPACK_IMPORTED_MODULE_4__store_types__["f" /* SetInvoiceTable */], {
    table: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, vm.table),
    condition: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, vm.condition)
  });
  var ts = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, vm.$store.state.invoices);
  var tb = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(ts.table));
  var cd = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(ts.condition));
  delete tb.total;
  cd.month = vm.datePicker === '' ? '' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_date__["a" /* default */])(vm.datePicker).format('MM/YYYY');
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, tb, cd);
}

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(6);




var weeks = [{
  name: 'Monday',
  value: '9:00 - 18:00'
}, {
  name: 'Tuesday',
  value: '9:00 - 18:00'
}, {
  name: 'Wednesday',
  value: '9:00 - 18:00'
}, {
  name: 'Thursday',
  value: '9:00 - 18:00'
}, {
  name: 'Friday',
  value: '9:00 - 18:00'
}, {
  name: 'Saturday',
  value: '9:00 - 18:00'
}, {
  name: 'Sunday',
  value: '9:00 - 18:00'
}];
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'add-new-outlet',
  created: function created() {
    var _this = this;

    var days = [this.$t('Week.sunday'), this.$t('Week.monday'), this.$t('Week.tuesday'), this.$t('Week.wednesday'), this.$t('Week.thursday'), this.$t('Week.friday'), this.$t('Week.saturday')];
    this.days = days.map(function (item) {
      return {
        name: item,
        open: _this.$t('Date.openTime'),
        close: _this.$t('Date.closeTime')
      };
    });
  },

  computed: {
    label: function label() {
      return {
        name: this.$t('Views.AddNewOutlet.form.name'),
        place: this.$t('Views.AddNewOutlet.form.place'),
        address1: this.$t('Views.AddNewOutlet.form.address1'),
        address2: this.$t('Views.AddNewOutlet.form.address2'),
        contact: this.$t('Views.AddNewOutlet.form.contact'),
        phone: this.$t('Views.AddNewOutlet.form.phone'),
        activeTime: this.$t('Views.AddNewOutlet.form.activeTime'),
        country: this.$t('Views.AddNewOutlet.form.country'),
        state: this.$t('Views.AddNewOutlet.form.state'),
        city: this.$t('Views.AddNewOutlet.form.city'),
        lng: this.$t('Views.AddNewOutlet.form.lng'),
        lat: this.$t('Views.AddNewOutlet.form.lat')
      };
    }
  },
  data: function data() {
    return {
      btnLoading: false,
      insideLoading: false,
      insidePhotoUrl: '',
      outsideLoading: false,
      outsidePhotoUrl: '',
      googlePlace: '',
      weeks: weeks,
      days: [],
      form: {
        name: '',
        phone: '',
        address1: '',
        city: '',
        state: '',
        country: '',
        contact: '',
        lng: '',
        lat: '',
        maplink: '',
        description: '',
        outsidePics: '',
        insidePics: ''
      }
    };
  },

  methods: {
    beforePhotoUpload: function beforePhotoUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2;

      var isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
      if (!isJPG) {
        this.$message.error('The uploaded image should be with the file format specified to".jpg, .jpeg, .png" extension');
      }
      if (!isLt2M) {
        this.$message.error('The uploaded image should not exceed 2MB!');
      }

      return isLt2M && isJPG;
    },
    uploadInsideProcess: function uploadInsideProcess(event, file, fileList) {
      this.insideLoading = true;
    },
    uploadInsidePhotoSuccess: function uploadInsidePhotoSuccess(res, file) {
      this.insidePhotoUrl = URL.createObjectURL(file.raw);
      this.form.insidePics = res.data.url;
      this.insideLoading = false;
    },
    uploadInsidePhotoError: function uploadInsidePhotoError(res, file) {
      this.$message.error('Upload failed.');
      this.insideLoading = false;
    },
    uploadOutsideProcess: function uploadOutsideProcess(event, file, fileList) {
      this.outsideLoading = true;
    },
    uploadOutsidePhotoSuccess: function uploadOutsidePhotoSuccess(res, file) {
      this.outsidePhotoUrl = URL.createObjectURL(file.raw);
      this.form.outsidePics = res.data.url;
      this.outsideLoading = false;
    },
    uploadOutsidePhotoError: function uploadOutsidePhotoError(res, file) {
      this.$message.error('Upload failed.');
      this.outsideLoading = false;
    },
    updatePlace: function updatePlace(place) {
      var componentForm = {
        street_number: 'short_name',
        route: 'long_name',
        locality: 'long_name',
        administrative_area_level_1: 'short_name',
        country: 'long_name',
        postal_code: 'short_name',
        sublocality_level_1: 'long_name'
      };
      this.form.lat = place.geometry.location.lat();
      this.form.lng = place.geometry.location.lng();
      this.form.city = '';
      this.form.state = '';
      this.form.country = '';
      this.form.address1 = place.formatted_address;
      for (var i = 0; i < place.address_components.length; i++) {
        var addressType = place.address_components[i].types[0];
        if (componentForm[addressType]) {
          switch (addressType) {
            case 'country':
              this.form.country = place.address_components[i][componentForm[addressType]];
              break;
            case 'administrative_area_level_1':
              this.form.state = place.address_components[i][componentForm[addressType]];
              break;
            case 'locality':
              this.form.city = place.address_components[i][componentForm[addressType]];
              break;
          }
        }
      }
    },
    onSubmit: function onSubmit() {
      this.$ga.event('Button', 'Save', 'Add new store');
      var vm = this;
      this.btnLoading = true;
      var form = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.form));
      form.activeTime = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(vm.weeks);
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].SaveNewOutlet(form).then(function (res) {
        if (res.data.code === 200) {
          vm.successMsg(res);
          vm.$router.push({
            name: 'Outlets'
          });
        } else {
          vm.errorMsg(res);
        }
        vm.btnLoading = false;
      }).catch(function (error) {
        alert(error);
        vm.btnLoading = false;
      });
    },
    errorMsg: function errorMsg(res) {
      this.$notify.error({
        title: 'failed',
        message: res.data.msg
      });
    },
    successMsg: function successMsg(res) {
      this.$notify.success({
        title: 'success',
        message: res.data.msg
      });
    }
  }
});

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);







var status = [{
  id: '0',
  value: 'Processing'
}, {
  id: '1',
  value: 'Approved'
}, {
  id: '2',
  value: 'Rejected'
}, {
  id: '3',
  value: 'Disabled'
}];
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Outlets',
  data: function data() {
    return {
      loading: false,
      tableData: [],
      table: this.$store.state.stores.table,
      condition: this.$store.state.stores.condition,
      reloadBtn: false
    };
  },

  methods: {
    reloadTable: function reloadTable() {
      this.$ga.event('Button', 'Reload', 'Stores');
      updateTable(this, initParams(this.table, this.condition, this.datePicker));
    },
    gotoPage: function gotoPage(id) {
      this.$ga.event('Link', 'Detail', 'Stores');
      this.$router.push({
        name: 'View-Outlet-Detail',
        params: {
          id: id
        }
      });
    },
    edit: function edit(id) {
      this.$ga.event('Link', 'Edit', 'Stores');
      this.$router.push({
        name: 'Update-Outlet',
        params: {
          id: id
        }
      });
    },
    formatterAddress: function formatterAddress(row, column) {
      return [row.country, row.state, row.city, row.address1, row.address2].join(' ');
    },
    formatterStatus: function formatterStatus(row, column) {
      var index = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.findIndex(status, {
        'id': row.status
      });
      return status[index].value;
    },
    handleSizeChange: function handleSizeChange(per) {
      this.table.per = per;
      updateTable(this, initParams(this));
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.table.page = page;
      updateTable(this, initParams(this));
    },
    searchByCondition: function searchByCondition() {
      this.$ga.event('Button', 'TableSearch', 'Stores');
      updateTable(this, initParams(this));
    },
    handleSortChange: function handleSortChange(_ref) {
      var column = _ref.column,
          prop = _ref.prop,
          order = _ref.order;

      this.table = {
        page: this.table.page,
        per: this.table.per,
        order: order === null ? '' : order === 'descending' ? 'DESC' : 'ASC',
        orderBy: prop === null ? '' : prop
      };
      updateTable(this, initParams(this));
    }
  },
  created: function created() {
    updateTable(this, initParams(this));
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name !== 'Update-Outlet' && to.name !== 'View-Outlet-Detail') {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_types__["i" /* InitStoreTable */]);
    }
    next();
  }
});

function updateTable(vm, params) {
  vm.loading = true;
  __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].FetchOutletsTable(params).then(function (res) {
    var result = res.data.data;
    vm.table = {
      total: result.total,
      page: ~~result.page,
      per: ~~result.per,
      order: result.order,
      orderBy: result.orderBy
    };
    vm.tableData = result.list;
    vm.reloadBtn = vm.loading = false;
  }).catch(function (error) {
    console.log(error);
    vm.tableData = [];
    vm.loading = false;
    vm.reloadBtn = true;
  });
}

function initParams(vm) {
  vm.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_types__["h" /* SetStoreTable */], {
    table: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, vm.table),
    condition: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, vm.condition)
  });
  var ts = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, vm.$store.state.stores);
  var tb = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(ts.table));
  var cd = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(ts.condition));
  delete tb.total;
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, tb, cd);
}

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(6);




var defaultWeeks = [{
  name: 'Monday',
  value: ''
}, {
  name: 'Tuesday',
  value: ''
}, {
  name: 'Wednesday',
  value: ''
}, {
  name: 'Thursday',
  value: ''
}, {
  name: 'Friday',
  value: ''
}, {
  name: 'Saturday',
  value: ''
}, {
  name: 'Sunday',
  value: ''
}];
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'update-outlet',
  created: function created() {
    var vm = this;
    this.fullLoading = true;
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].FetchOutletById(this.$route.params.id).then(function (res) {
      if (res.data.code === 200) {
        var form = res.data.data;
        vm.insidePhotoUrl = form.insidePics;
        vm.outsidePhotoUrl = form.outsidePics;
        vm.weeks = JSON.parse(form.activeTime);
        vm.form = form;
      }
      vm.fullLoading = false;
    });
  },

  computed: {
    checkbox: function checkbox() {
      return [this.$t('Week.sunday'), this.$t('Week.monday'), this.$t('Week.tuesday'), this.$t('Week.wednesday'), this.$t('Week.thursday'), this.$t('Week.friday'), this.$t('Week.saturday')];
    },
    days: function days() {
      var _this = this;

      return this.checkbox.map(function (item) {
        return {
          name: item,
          open: _this.$t('Date.openTime'),
          close: _this.$t('Date.closeTime')
        };
      });
    },
    label: function label() {
      return {
        name: this.$t('Views.AddNewOutlet.form.name'),
        place: this.$t('Views.AddNewOutlet.form.place'),
        address1: this.$t('Views.AddNewOutlet.form.address1'),
        address2: this.$t('Views.AddNewOutlet.form.address2'),
        contact: this.$t('Views.AddNewOutlet.form.contact'),
        phone: this.$t('Views.AddNewOutlet.form.phone'),
        activeTime: this.$t('Views.AddNewOutlet.form.activeTime'),
        country: this.$t('Views.AddNewOutlet.form.country'),
        state: this.$t('Views.AddNewOutlet.form.state'),
        city: this.$t('Views.AddNewOutlet.form.city'),
        lng: this.$t('Views.AddNewOutlet.form.lng'),
        lat: this.$t('Views.AddNewOutlet.form.lat')
      };
    }
  },
  data: function data() {
    return {
      btnLoading: false,
      insideLoading: false,
      insidePhotoUrl: '',
      outsideLoading: false,
      outsidePhotoUrl: '',
      deleteDialog: false,
      fullLoading: false,
      googlePlace: '',
      weeks: defaultWeeks,
      form: {
        name: '',
        phone: '',
        address1: '',
        city: '',
        state: '',
        country: '',
        contact: '',
        lng: '',
        lat: '',
        maplink: '',
        description: '',
        outsidePics: '',
        insidePics: ''
      }
    };
  },

  methods: {
    beforePhotoUpload: function beforePhotoUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2;

      var isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
      if (!isJPG) {
        this.$message.error('The uploaded image should be with the file format specified to".jpg, .jpeg, .png" extension');
      }
      if (!isLt2M) {
        this.$message.error('The uploaded image should not exceed 2MB!');
      }

      return isLt2M && isJPG;
    },
    uploadInsideProcess: function uploadInsideProcess(event, file, fileList) {
      this.insideLoading = true;
    },
    uploadInsidePhotoSuccess: function uploadInsidePhotoSuccess(res, file) {
      this.insidePhotoUrl = URL.createObjectURL(file.raw);
      this.form.insidePics = res.data.url;
      this.insideLoading = false;
    },
    uploadInsidePhotoError: function uploadInsidePhotoError(res, file) {
      this.$message.error('Upload failed.');
      this.insideLoading = false;
    },
    uploadOutsideProcess: function uploadOutsideProcess(event, file, fileList) {
      this.outsideLoading = true;
    },
    uploadOutsidePhotoSuccess: function uploadOutsidePhotoSuccess(res, file) {
      this.outsidePhotoUrl = URL.createObjectURL(file.raw);
      this.form.outsidePics = res.data.url;
      this.outsideLoading = false;
    },
    uploadOutsidePhotoError: function uploadOutsidePhotoError(res, file) {
      this.$message.error('Upload failed.');
      this.outsideLoading = false;
    },
    updatePlace: function updatePlace(place) {
      var componentForm = {
        street_number: 'short_name',
        route: 'long_name',
        locality: 'long_name',
        administrative_area_level_1: 'short_name',
        country: 'long_name',
        postal_code: 'short_name',
        sublocality_level_1: 'long_name'
      };
      this.form.lat = place.geometry.location.lat();
      this.form.lng = place.geometry.location.lng();
      this.form.city = '';
      this.form.state = '';
      this.form.country = '';
      this.form.address1 = place.formatted_address;
      for (var i = 0; i < place.address_components.length; i++) {
        var addressType = place.address_components[i].types[0];
        if (componentForm[addressType]) {
          switch (addressType) {
            case 'country':
              this.form.country = place.address_components[i][componentForm[addressType]];
              break;
            case 'administrative_area_level_1':
              this.form.state = place.address_components[i][componentForm[addressType]];
              break;
            case 'locality':
              this.form.city = place.address_components[i][componentForm[addressType]];
              break;
          }
        }
      }
    },
    onSubmit: function onSubmit() {
      this.$ga.event('Button', 'Save', 'Edit store');
      var vm = this;
      this.btnLoading = true;
      var form = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.form));
      form.activeTime = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.weeks);
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].UpdateOutlet(this.$route.params.id, form).then(function (res) {
        if (res.data.code === 200) {
          vm.successMsg(res);
          vm.$router.go(-1);
        } else {
          vm.errorMsg(res);
        }
        vm.btnLoading = false;
      }).catch(function (error) {
        alert(error);
        vm.btnLoading = false;
      });
    },
    deleteOutlet: function deleteOutlet() {
      var vm = this;
      this.fullLoading = true;
      this.deleteDialog = false;
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].DeleteOutlet(this.$route.params.id).then(function (res) {
        if (res.data.code === 200) {
          vm.successMsg(res);
          vm.$router.go(-1);
        } else {
          vm.errorMsg(res);
        }
        vm.fullLoading = false;
      }).catch(function (error) {
        alert(error);
      });
    },
    errorMsg: function errorMsg(res) {
      this.$notify.error({
        title: 'failed',
        message: res.data.msg
      });
    },
    successMsg: function successMsg(res) {
      this.$notify.success({
        title: 'success',
        message: res.data.msg
      });
    }
  }
});

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(6);



var defaultWeeks = [{
  name: 'Monday',
  value: ''
}, {
  name: 'Tuesday',
  value: ''
}, {
  name: 'Wednesday',
  value: ''
}, {
  name: 'Thursday',
  value: ''
}, {
  name: 'Friday',
  value: ''
}, {
  name: 'Saturday',
  value: ''
}, {
  name: 'Sunday',
  value: ''
}];
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'view-outlet',
  created: function created() {
    var vm = this;
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].FetchOutletById(this.$route.params.id).then(function (res) {
      if (res.data.code === 200) {
        vm.form = res.data.data;
        vm.weeks = JSON.parse(vm.form.activeTime);
      }
      vm.fullLoading = false;
    });
  },

  computed: {
    label: function label() {
      return {
        name: this.$t('Views.ViewOutletDetail.table.name'),
        place: this.$t('Views.ViewOutletDetail.table.address'),
        country: this.$t('Views.ViewOutletDetail.table.country'),
        state: this.$t('Views.ViewOutletDetail.table.state'),
        city: this.$t('Views.ViewOutletDetail.table.city'),
        lat: this.$t('Views.ViewOutletDetail.table.lat'),
        lng: this.$t('Views.ViewOutletDetail.table.lng'),
        contact: this.$t('Views.ViewOutletDetail.table.contact'),
        phone: this.$t('Views.ViewOutletDetail.table.phone')
      };
    }
  },
  data: function data() {
    return {
      fullLoading: true,
      weeks: defaultWeeks,
      form: {
        name: '',
        phone: '',
        address1: '',
        city: '',
        state: '',
        country: '',
        contact: '',
        lng: '',
        lat: '',
        maplink: '',
        description: '',
        outsidePics: '',
        insidePics: ''
      }
    };
  }
});

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(6);



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      fullLoading: false,
      list: [],
      errorMsg: ''
    };
  },
  created: function created() {
    var vm = this;
    this.fullLoading = true;
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].ShowChannel().then(function (res) {
      if (res.data.code === 200) {
        vm.list = res.data.data.list;
      } else {
        vm.errorMsg = res.data.msg;
      }
      vm.fullLoading = false;
    });
  },

  methods: {
    confirm: function confirm() {
      this.$ga.event('Link', 'Confirm', 'Agreement');
      this.$router.push({
        name: 'OB-Contract'
      });
    },
    errorMsg: function errorMsg(res) {
      this.$notify.error({
        title: 'failed',
        message: res.data.msg
      });
    },
    successMsg: function successMsg(res) {
      this.$notify.success({
        title: 'success',
        message: res.data.msg
      });
    }
  }
});

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_instant_pdf_viewer__ = __webpack_require__(426);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      ConfirmBlock: false,
      ContactBlock: false,
      src: '',
      loading: false,
      btnDisable: true
    };
  },

  components: {
    'vue-pdf-viewer': __WEBPACK_IMPORTED_MODULE_2_vue_instant_pdf_viewer__["a" /* default */]
  },
  computed: {
    height: function height() {
      return document.documentElement.clientHeight - 200 + 'px';
    }
  },
  created: function created() {
    var _this = this;

    var vm = this;
    this.loading = true;
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].FetchContract({
      merchantId: this.$store.state.user.userinfo.merchantId,
      name: this.$store.state.theme.name
    }).then(function (res) {
      if (res.data.code === 200) {
        vm.src = res.data.data.contractUrl + '&type=agreement';
        _this.btnDisable = false;
      }
      _this.loading = false;
    });
  },

  methods: {
    errorMsg: function errorMsg(res) {
      this.$notify.error({
        title: 'failed',
        message: res.data.msg
      });
    },
    successMsg: function successMsg(res) {
      this.$notify.success({
        title: 'success',
        message: res.data.msg
      });
    },
    confirmContract: function confirmContract() {
      this.$ga.event('Link', 'Confirm Contract', 'Contract');
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].PostSign().then(function (res) {
        if (res.data.code === 200) {
          vm.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_types__["u" /* ISSIGN */]);
          vm.successMsg(res);
          vm.$router.push({
            name: 'OB-ServiceFee'
          });
        } else {
          vm.errorMsg(res);
        }
      });
    }
  }
});

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'reset-password',
  data: function data() {
    return {
      nPwd1: '',
      nPwd2: '',
      rPwd1: '',
      rPwd2: '',
      error: false,
      rError: false
    };
  },

  computed: {
    disableBtn: function disableBtn() {
      if (this.nPwd1 === '' || this.nPwd2 === '' || this.rPwd1 === '' || this.rPwd2 === '') {
        return true;
      } else if (this.error || this.rError) {
        return true;
      }
      return false;
    }
  },
  watch: {
    nPwd1: function nPwd1() {
      this.error = this.nPwd1 !== this.nPwd2 ? true : !true;
    },
    nPwd2: function nPwd2() {
      this.error = this.nPwd1 !== this.nPwd2 ? true : !true;
    },
    rPwd1: function rPwd1() {
      this.rError = this.rPwd1 !== this.rPwd2 ? true : !true;
    },
    rPwd2: function rPwd2() {
      this.rError = this.rPwd1 !== this.rPwd2 ? true : !true;
    }
  },
  methods: {
    errorMsg: function errorMsg(res) {
      this.$notify.error({
        title: 'failed',
        message: res.data.msg
      });
    },
    successMsg: function successMsg(res) {
      this.$notify.success({
        title: 'success',
        message: res.data.msg
      });
    },
    confirm: function confirm() {
      this.$ga.event('Button', 'Confirm', 'Reset password');
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].ResetPassword({
        new: this.nPwd1,
        refundPassword: this.rPwd1
      }).then(function (res) {
        var username = vm.$store.state.user.userinfo.username;
        if (res.data.code !== 200) {
          vm.errorMsg(res);
        } else {
          vm.successMsg(res);
          vm.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_types__["t" /* SIGNOUT */]);
          vm.$router.push({
            name: 'Login',
            query: {
              id: username
            }
          });
        }
      });
    }
  }
});

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_compute__ = __webpack_require__(226);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Service-fee-setting',
  data: function data() {
    return {
      open: [],
      available: [],
      newUser: true,
      btnDisable: true
    };
  },

  computed: {
    nextBtn: function nextBtn() {
      var flag = false;
      for (var i = 0; i < this.open.length; i++) {
        if (this.open[i].save) {
          flag = true;
        }
      }
      return flag;
    }
  },
  created: function created() {
    initPage(this);
  },

  methods: {
    gotoDashboard: function gotoDashboard() {
      this.$ga.event('Link', 'Go to Dashboard', 'Service Fee');
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].FinishOnboarding().then(function (res) {
        if (res.data.code === 200) {
          vm.$store.commit(__WEBPACK_IMPORTED_MODULE_1__store_types__["v" /* SETFEE */]);
          vm.$router.push({
            name: 'Dashboard',
            query: {
              new: '1'
            }
          });
        }
      });
    },
    goto: function goto() {
      this.newUser = false;
    },
    onFocus: function onFocus(i) {
      var item = this.open.splice(i, 1)[0];
      item.save = true;
      this.open.splice(i, 0, item);
    },
    OnChargeFee: function OnChargeFee(i) {
      var item = this.open.splice(i, 1)[0];
      this.open.splice(i, 0, item);
      if (item.chargeFee === false) {
        item.rateStatus = 1;
        this.confirm(i);
      } else {
        item.rateStatus = 2;
        this.confirm(i);
      }
    },
    OnActive: function OnActive(i) {
      var item = this.available.splice(i, 1)[0];
      this.available.splice(i, 0, item);
      this.active(i);
    },
    validateCRate: function validateCRate(val) {
      if (val < 0) {
        this.$message.error(this.$t('Views.PaymentChannel.msg2'));
        return false;
      }
      return true;
    },
    onInput: function onInput(i) {
      var self = this.open[i];
      if (self.cRate.toString().length > 4) {
        self.cRate = self.cRate.toString().slice(0, 4);
      }
    },
    onChange: function onChange(i) {
      var self = this.open[i];

      if (self.cRate > self.maxRate) {
        this.open.splice(i, 1, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(self, {
          error: true
        }));
      } else {
        this.open.splice(i, 1, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(self, {
          error: false
        }));
      }
    },
    errorMsg: function errorMsg(res) {
      this.$notify.error({
        title: 'failed',
        message: res.data.msg
      });
    },
    successMsg: function successMsg(res) {
      this.$notify.success({
        title: 'success',
        message: res.data.msg
      });
    },
    cancel: function cancel(i) {
      this.$ga.event('Button', 'Cancel', 'Service Fee');
      var item = this.open.splice(i, 1)[0];
      item.save = false;
      item.error = false;
      item.cRate = item.defaultRate;
      this.open.splice(i, 0, item);
    },
    confirm: function confirm(i) {
      this.$ga.event('Button', 'Confirm', 'Service Fee');
      var item = this.open[i];
      var vm = this;
      if (!this.validateCRate(item.cRate)) {
        return false;
      }
      if (item.cRate > item.maxRate) {
        this.$notify.error({
          title: 'error',
          message: 'Service fee cannot be set higher than ' + item.maxRate + '%'
        });
        return false;
      }
      if (item.chargeFee === false) {
        item.cRate = item.defaultRate;
      }
      item.loading = true;
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].UpdateChannel(item.channelId, {
        cRate: __WEBPACK_IMPORTED_MODULE_3__util_compute__["a" /* default */].div(item.cRate, 100),
        rateStatus: item.rateStatus
      }).then(function (res) {
        if (res.data.code === 200) {
          vm.btnDisable = false;
          vm.successMsg(res);
          vm.open.splice(i, 1, vm.initActive(res.data.data));
        } else {
          vm.errorMsg(res);
        }
        item.loading = false;
      });
    },
    disable: function disable(i) {
      var item = this.open[i];
      var vm = this;
      item.loading = true;
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].DeleteChannel(item.channelId).then(function (res) {
        if (res.data.code === 200) {
          vm.successMsg(res);
          initPage(vm);
        } else {
          vm.errorMsg(res);
        }
        item.loading = false;
      });
    },
    active: function active(i) {
      var item = this.available[i];
      var vm = this;
      item.loading = true;
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].ActiveChannel(item.channelId).then(function (res) {
        if (res.data.code === 200) {
          vm.successMsg(res);
          initPage(vm);
        } else {
          vm.errorMsg(res);
        }
        item.loading = false;
      });
    },
    initActive: function initActive(item) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(item, {
        save: false,
        error: false,
        loading: false,
        chargeFee: item.rateStatus === '2' ? true : !true,

        defaultRate: Number((item.cRate * 100).toFixed(2)),
        cRate: Number((item.cRate * 100).toFixed(2)),
        rate: __WEBPACK_IMPORTED_MODULE_3__util_compute__["a" /* default */].mul(item.rate, 100),
        maxRate: __WEBPACK_IMPORTED_MODULE_3__util_compute__["a" /* default */].mul(item.maxRate, 100),
        active: true
      });
    }
  }
});

function initPage(vm) {
  __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].FetchChannel().then(function (res) {
    vm.open = res.data.data.open;
    vm.available = res.data.data.available;
    vm.open.map(function (item) {
      item.save = item.error = item.loading = false;
      item.chargeFee = item.rateStatus === '2' ? true : !true;

      item.defaultRate = item.cRate = Number((item.cRate * 100).toFixed(2));
      item.rate = __WEBPACK_IMPORTED_MODULE_3__util_compute__["a" /* default */].mul(item.rate, 100);
      item.maxRate = __WEBPACK_IMPORTED_MODULE_3__util_compute__["a" /* default */].mul(item.maxRate, 100);
    });
    vm.available.map(function (item) {
      item.rate = __WEBPACK_IMPORTED_MODULE_3__util_compute__["a" /* default */].mul(item.rate, 100);
      item.loading = false;
    });
  });
}

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_date__ = __webpack_require__(121);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Refund',
  data: function data() {
    return {
      fullLoading: false,
      conLoading: false,
      loading: false,
      ContactBlock: false,
      ContactBlockShow: true,
      tableData: [],
      table: this.$store.state.refunds.table,
      condition: this.$store.state.refunds.condition,
      datePicker: this.$store.state.refunds.datePicker,
      shopOptions: [],
      statusOptions: [],
      tips: {},
      reloadBtn: false
    };
  },

  methods: {
    gotoPage: function gotoPage(id) {
      this.$ga.event('Link', 'Detail', 'Refunds');
      this.$router.push({
        name: 'Refund-Detail',
        params: {
          id: id
        }
      });
    },
    formatterDate: function formatterDate(row, column) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_date__["a" /* default */])(row.createTime * 1000).format('L');
    },
    handleSizeChange: function handleSizeChange(per) {
      this.table.per = per;
      updateTable(this, initParams(this));
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.table.page = page;
      updateTable(this, initParams(this));
    },
    handleSortChange: function handleSortChange(_ref) {
      var column = _ref.column,
          prop = _ref.prop,
          order = _ref.order;

      this.table = {
        page: this.table.page,
        per: this.table.per,
        order: order === null ? '' : order === 'descending' ? 'DESC' : 'ASC',
        orderBy: prop === null ? '' : prop
      };
      updateTable(this, initParams(this));
    },
    clearSelectors: function clearSelectors() {
      this.$ga.event('Button', 'ClearAll', 'Refunds');
      this.condition = {
        trxId: '',
        customer: '',
        begin: '',
        end: ''
      };
      this.datePicker = [];
    },
    searchByCondition: function searchByCondition() {
      this.$ga.event('Button', 'TableSearch', 'Refunds');
      updateTable(this, initParams(this));
    },
    download: function download() {
      this.$ga.event('Button', 'Download', 'Refunds');
      var params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, initParams(this));
      var st = '';
      for (var i in params) {
        if (params.hasOwnProperty(i)) {
          st = st + '&' + i + '=' + params[i];
        }
      }
      var url = '/client/refund?download=csv' + st;
      window.open(url);
    },
    onRefundDetail: function onRefundDetail() {
      this.$ga.event('Button', 'Pending refunds', 'Refunds');
      this.ContactBlock = true;
    },
    reloadTable: function reloadTable() {
      this.$ga.event('Button', 'Reload', 'Refunds');
      updateTable(this, initParams(this));
    }
  },
  created: function created() {
    updateTable(this, initParams(this));
    var vm = this;
    this.conLoading = true;
    __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].showRefundDetail().then(function (res) {
      if (res.data.code === 200) {
        vm.tips = res.data.data;
        vm.ContactBlockShow = +vm.tips.refundTotal === 0 ? !true : true;
      }
      vm.conLoading = false;
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name !== 'Refund-Detail') {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_types__["e" /* InitRefundTable */]);
    }
    next();
  }
});

function updateTable(vm, params) {
  vm.loading = true;
  __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].FetchRefundTable(params).then(function (res) {
    var result = res.data.data;
    vm.table = {
      total: result.total,
      page: ~~result.page,
      per: ~~result.per,
      order: result.order,
      orderBy: result.orderBy
    };
    vm.tableData = result.list;
    vm.reloadBtn = vm.loading = false;
  }).catch(function (error) {
    console.log(error);
    vm.tableData = [];
    vm.loading = false;
    vm.reloadBtn = true;
  });
}

function initParams(vm) {
  vm.$store.commit(__WEBPACK_IMPORTED_MODULE_3__store_types__["d" /* SetRefundTable */], {
    table: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, vm.table),
    condition: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, vm.condition),
    datePicker: vm.datePicker.map(function (item) {
      return item;
    })
  });
  var ts = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, vm.$store.state.refunds);
  var tb = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(ts.table));
  var cd = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(ts.condition));
  delete tb.total;
  if (ts.datePicker.length === 2) {
    cd.begin = ts.datePicker[0] === null ? '' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_date__["a" /* default */])(ts.datePicker[0]).format('LT');
    cd.end = ts.datePicker[1] === null ? '' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_date__["a" /* default */])(ts.datePicker[1]).format('LT');
  } else {
    delete cd.begin;
    delete cd.end;
  }
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, tb, cd);
}

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(6);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'view-refund-detail',
  created: function created() {
    var vm = this;
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].FetchRefundById(this.$route.params.id).then(function (res) {
      if (res.data.code === 200) {
        vm.form = res.data.data;
      }
      vm.fullLoading = false;
    });
  },
  data: function data() {
    return {
      fullLoading: true,
      form: {}
    };
  }
});

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(6);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'reset-password',
  data: function data() {
    return {
      oPwd: '',
      nPwd1: '',
      nPwd2: '',
      error: false,
      btnLoading: false
    };
  },

  watch: {
    nPwd1: function nPwd1() {
      this.error = this.nPwd1 !== this.nPwd2 ? !0 : 0;
    },
    nPwd2: function nPwd2() {
      this.error = this.nPwd1 !== this.nPwd2 ? !0 : 0;
    }
  },
  computed: {
    btnDisable: function btnDisable() {
      return this.error || this.oPwd === '' || this.nPwd1 === '' || this.nPwd2 === '';
    }
  },
  methods: {
    errorMsg: function errorMsg(res) {
      this.$notify.error({
        title: 'failed',
        message: res.data.msg
      });
    },
    successMsg: function successMsg(res) {
      this.$notify.success({
        title: 'success',
        message: res.data.msg
      });
    },
    confirm: function confirm() {
      this.$ga.event('Button', 'Confirm', 'Modify password');
      var vm = this;
      this.btnLoading = true;
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].UpdatePassword({
        old: this.oPwd,
        new: this.nPwd1
      }).then(function (res) {
        if (res.data.code !== 200) {
          vm.errorMsg(res);
        } else {
          vm.successMsg(res);
          vm.$router.push({
            name: 'Login'
          });
        }
        vm.btnLoading = false;
      });
    }
  }
});

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_compute__ = __webpack_require__(226);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'payment-channel',
  data: function data() {
    return {
      fullLoading: true,
      open: [],
      available: []
    };
  },
  created: function created() {
    var vm = this;
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].FetchChannel().then(function (res) {
      vm.open = res.data.data.open;
      vm.available = res.data.data.available;
      vm.open.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(item, {
          save: false,
          error: false,
          loading: false,
          chargeFee: item.rateStatus === '2' ? true : !true,

          defaultRate: Number((item.cRate * 100).toFixed(2)),
          cRate: Number((item.cRate * 100).toFixed(2)),
          rate: __WEBPACK_IMPORTED_MODULE_2__util_compute__["a" /* default */].mul(item.rate, 100),
          maxRate: __WEBPACK_IMPORTED_MODULE_2__util_compute__["a" /* default */].mul(item.maxRate, 100),
          active: true
        });
      });
      vm.available.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(item, {
          rate: __WEBPACK_IMPORTED_MODULE_2__util_compute__["a" /* default */].mul(item.rate, 100),
          loading: false,
          active: false
        });
      });
      vm.fullLoading = false;
    });
  },

  methods: {
    onFocus: function onFocus(i) {
      var item = this.open.splice(i, 1)[0];
      item.save = true;
      this.open.splice(i, 0, item);
    },
    OnChargeFee: function OnChargeFee(i) {
      var item = this.open.splice(i, 1)[0];
      this.open.splice(i, 0, item);
      if (item.chargeFee === false) {
        item.rateStatus = 1;
        this.confirm(i);
      } else {
        item.rateStatus = 2;
        this.confirm(i);
      }
    },
    OnDisable: function OnDisable(i) {
      var item = this.open.splice(i, 1)[0];
      this.open.splice(i, 0, item);
      this.disable(i);
    },
    OnActive: function OnActive(i) {
      var item = this.available.splice(i, 1)[0];
      this.available.splice(i, 0, item);
      this.active(i);
    },
    validateCRate: function validateCRate(val) {
      if (val < 0) {
        this.$message.error(this.$t('Views.PaymentChannel.msg2'));
        return false;
      }
      return true;
    },
    onInput: function onInput(i) {
      var self = this.open[i];
      if (self.cRate.toString().length > 4) {
        self.cRate = self.cRate.toString().slice(0, 4);
      }
    },
    onChange: function onChange(i) {
      var self = this.open[i];

      if (self.cRate.toString().length > 4) {
        self.cRate = self.cRate.toString().slice(0, 4);
      }
      if (self.cRate > self.maxRate) {
        this.open.splice(i, 1, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(self, {
          error: true
        }));
      } else {
        this.open.splice(i, 1, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(self, {
          error: false
        }));
      }
    },
    errorMsg: function errorMsg(res) {
      this.$notify.error({
        title: this.$t('Notify.err'),
        message: res.data.msg
      });
    },
    successMsg: function successMsg(res) {
      this.$notify.success({
        title: this.$t('Notify.suc'),
        message: res.data.msg
      });
    },
    cancel: function cancel(i) {
      this.$ga.event('Button', 'Cancel', 'Payment channel');
      var item = this.open.splice(i, 1)[0];
      item.save = false;
      item.error = false;
      item.cRate = item.defaultRate;
      this.open.splice(i, 0, item);
    },
    confirm: function confirm(i) {
      this.$ga.event('Button', 'Confirm', 'Payment channel');
      var item = this.open[i];
      var vm = this;
      if (!this.validateCRate(item.cRate)) {
        return false;
      }
      if (item.cRate > item.maxRate) {
        this.$notify.error({
          title: this.$t('Notify.err'),
          message: this.$t('Views.PaymentChannel.msg') + (' ' + item.maxRate + '%')
        });
        return false;
      }
      if (item.chargeFee === false) {
        item.cRate = item.defaultRate;
      }
      item.loading = true;
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].UpdateChannel(item.channelId, {
        cRate: __WEBPACK_IMPORTED_MODULE_2__util_compute__["a" /* default */].div(item.cRate, 100),
        rateStatus: item.rateStatus
      }).then(function (res) {
        if (res.data.code === 200) {
          vm.successMsg(res);
          vm.open.splice(i, 1, vm.initActive(res.data.data));
        } else {
          vm.errorMsg(res);
        }
        item.loading = false;
      });
    },
    disable: function disable(i) {
      var item = this.open[i];
      var vm = this;
      item.loading = true;
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].DeleteChannel(item.channelId).then(function (res) {
        if (res.data.code === 200) {
          vm.successMsg(res);
          vm.open.splice(i, 1);
          vm.available.push(vm.initDisable(res.data.data));
        } else {
          vm.errorMsg(res);
        }
        item.loading = false;
      });
    },
    initDisable: function initDisable(item) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(item, {
        rate: __WEBPACK_IMPORTED_MODULE_2__util_compute__["a" /* default */].mul(item.rate, 100),
        loading: false,
        active: false
      });
    },
    active: function active(i) {
      var item = this.available[i];
      var vm = this;
      item.loading = true;
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].ActiveChannel(item.channelId).then(function (res) {
        if (res.data.code === 200) {
          vm.successMsg(res);
          vm.available.splice(i, 1);
          vm.open.push(vm.initActive(res.data.data));
        } else {
          vm.errorMsg(res);
        }
        item.loading = false;
      });
    },
    initActive: function initActive(item) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(item, {
        save: false,
        error: false,
        loading: false,
        chargeFee: item.rateStatus === '2' ? true : !true,

        defaultRate: Number((item.cRate * 100).toFixed(2)),
        cRate: Number((item.cRate * 100).toFixed(2)),
        rate: __WEBPACK_IMPORTED_MODULE_2__util_compute__["a" /* default */].mul(item.rate, 100),
        maxRate: __WEBPACK_IMPORTED_MODULE_2__util_compute__["a" /* default */].mul(item.maxRate, 100),
        active: true
      });
    }
  }
});

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_download__ = __webpack_require__(227);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'QRcode',
  data: function data() {
    return {
      qrcodeData: [],
      checkAll: false,
      checkedBoxes: [],
      stores: [],
      isIndeterminate: false,
      fullLoading: false
    };
  },
  created: function created() {
    var vm = this;
    this.fullLoading = true;
    __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].FetchQrCode().then(function (res) {
      if (res.data.code === 200) {
        var result = res.data.data;
        vm.qrcodeData = [result.merchant.qrcodeUrl, result.merchant.tableQrcodeUrl];
        vm.stores = result.storeList;
      }
      vm.fullLoading = false;
    });
  },

  methods: {
    handleCheckAllChange: function handleCheckAllChange(event) {
      this.checkedBoxes = event.target.checked ? this.stores.map(function (item) {
        return item.storeId;
      }) : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.stores.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.stores.length;
    },
    beforeDownload: function beforeDownload() {
      return this.checkedBoxes.length === 0 ? !true : true;
    },
    checkDownload: function checkDownload() {
      this.$ga.event('Button', 'Download', 'QR code');
      if (!this.beforeDownload()) {
        this.$message.error('Please select at least one store.');
        return false;
      }
      var vm = this;
      this.fullLoading = true;
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].CheckDownloadQrcodeZip({
        storeId: this.checkedBoxes.join(','),
        style: this.$store.state.theme.name === 'default' ? '01' : this.$store.state.theme.name.concat('_01')
      }).then(function (res) {
        if (typeof res.data.code === 'number' && res.data.code !== 200) {
          vm.$message.error(res.data.msg);
          vm.fullLoading = false;
        } else {
          vm.download();
        }
      });
    },
    download: function download() {
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].DownloadQrcodeZip({
        storeId: this.checkedBoxes.join(','),
        style: this.$store.state.theme.name === 'default' ? '01' : this.$store.state.theme.name.concat('_01')
      }).then(function (response) {
        var data = new Blob([response.data], {
          type: response.headers['content-type']
        });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_download__["a" /* default */])(data, response.headers['content-disposition'].replace(/"/g, '').split('filename=')[1]);
        vm.fullLoading = false;
      });
    }
  }
});

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(6);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'reset-refund-password',
  data: function data() {
    return {
      oPwd: '',
      nPwd1: '',
      nPwd2: '',
      error: false,
      btnLoading: false
    };
  },

  watch: {
    nPwd1: function nPwd1() {
      this.error = this.nPwd1 !== this.nPwd2 ? !0 : 0;
    },
    nPwd2: function nPwd2() {
      this.error = this.nPwd1 !== this.nPwd2 ? !0 : 0;
    }
  },
  computed: {
    btnDisable: function btnDisable() {
      return this.error || this.oPwd === '' || this.nPwd1 === '' || this.nPwd2 === '';
    }
  },
  methods: {
    errorMsg: function errorMsg(res) {
      this.$notify.error({
        title: 'failed',
        message: res.data.msg
      });
    },
    successMsg: function successMsg(res) {
      this.$notify.success({
        title: 'success',
        message: res.data.msg
      });
    },
    confirm: function confirm() {
      this.$ga.event('Button', 'Confirm', 'Modify refund password');
      var vm = this;
      this.btnLoading = true;
      __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].UpdateRefundPassword({
        password: this.oPwd,
        refund: this.nPwd1
      }).then(function (res) {
        if (res.data.code !== 200) {
          vm.errorMsg(res);
        } else {
          ['oPwd', 'nPwd1', 'nPwd2'].map(function (item) {
            vm[item] = '';
          });
          vm.error = false;
          vm.successMsg(res);
        }
        vm.btnLoading = false;
      });
    }
  }
});

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_date__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_download__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_types__ = __webpack_require__(10);








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Transactions',
  data: function data() {
    return {
      fullLoading: false,
      loading: false,
      tableData: [],
      table: this.$store.state.settlements.table,
      condition: this.$store.state.settlements.condition,
      datePicker: this.$store.state.settlements.datePicker,
      reloadBtn: false
    };
  },

  methods: {
    handleSizeChange: function handleSizeChange(per) {
      this.table.per = per;
      updateTable(this, initParams(this));
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.table.page = page;
      updateTable(this, initParams(this));
    },
    handleSortChange: function handleSortChange(_ref) {
      var column = _ref.column,
          prop = _ref.prop,
          order = _ref.order;

      this.table = {
        page: this.table.page,
        per: this.table.per,
        order: order === null ? '' : order === 'descending' ? 'DESC' : 'ASC',
        orderBy: prop === null ? '' : prop
      };
      updateTable(this, initParams(this));
    },
    clearSelectors: function clearSelectors() {
      this.$ga.event('Button', 'ClearAll', 'Settlements');
      this.condition = {
        begin: '',
        end: ''
      };
      this.datePicker = [];
    },
    searchByCondition: function searchByCondition() {
      this.$ga.event('Button', 'TableSearch', 'Settlements');
      updateTable(this, initParams(this));
    },
    download: function download() {
      this.$ga.event('Button', 'Download', 'Settlements');
      var params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, initParams(this));
      var st = '';
      for (var i in params) {
        if (params.hasOwnProperty(i)) {
          st = st + '&' + i + '=' + params[i];
        }
      }
      var url = '/client/settlement?download=csv' + st;
      window.open(url);
    },
    downStatement: function downStatement(id) {
      this.$ga.event('Button', 'Download Statement', 'Settlements');
      var vm = this;
      this.fullLoading = true;
      __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].DownloadStatement(id).then(function (response) {
        var data = new Blob([response.data], {
          type: response.headers['content-type']
        });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_download__["a" /* default */])(data, response.headers['content-disposition'].replace(/"/g, '').split('filename=')[1]);
        vm.fullLoading = false;
      });
    },
    reloadTable: function reloadTable() {
      this.$ga.event('Button', 'Reload', 'Settlements');
      updateTable(this, initParams(this));
    }
  },
  created: function created() {
    updateTable(this, initParams(this));
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_types__["c" /* InitSettleTable */]);
    next();
  }
});

function updateTable(vm, params) {
  vm.loading = true;
  __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].FetchSettleTable(params).then(function (res) {
    var result = res.data.data;
    vm.table = {
      total: result.total,
      page: ~~result.page,
      per: ~~result.per,
      order: result.order,
      orderBy: result.orderBy
    };
    vm.tableData = result.list;
    vm.reloadBtn = vm.loading = false;
  }).catch(function (error) {
    console.log(error);
    vm.tableData = [];
    vm.loading = false;
    vm.reloadBtn = true;
  });
}

function initParams(vm) {
  vm.$store.commit(__WEBPACK_IMPORTED_MODULE_5__store_types__["b" /* SetSettleTable */], {
    table: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, vm.table),
    condition: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, vm.condition),
    datePicker: vm.datePicker.map(function (item) {
      return item;
    })
  });
  var ts = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, vm.$store.state.settlements);
  var tb = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(ts.table));
  var cd = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(ts.condition));
  if (ts.datePicker.length === 2) {
    cd.begin = ts.datePicker[0] === null ? '' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_date__["a" /* default */])(ts.datePicker[0]).format('LT');
    cd.end = ts.datePicker[1] === null ? '' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_date__["a" /* default */])(ts.datePicker[1]).format('LT');
  } else {
    delete cd.begin;
    delete cd.end;
  }
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, tb, cd);
}

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_types__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_date__ = __webpack_require__(121);







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Transactions',
  data: function data() {
    return {
      fullLoading: false,
      conditionLoading: true,
      loading: false,
      tableData: [],
      table: this.$store.state.trxList.table,
      condition: this.$store.state.trxList.condition,
      datePicker: this.$store.state.trxList.datePicker,
      shopOptions: [],
      statusOptions: [],
      reloadBtn: false
    };
  },

  methods: {
    gotoPage: function gotoPage(id) {
      this.$ga.event('Link', 'Detail', 'Transactions');
      this.$router.push({
        name: 'Transaction-Detail',
        params: {
          id: id
        }
      });
    },
    formatterDate: function formatterDate(row, column) {
      return __WEBPACK_IMPORTED_MODULE_4__util_date__["a" /* default */].tz(row.createTime * 1000, 'Asia/shanghai').format('LT');
    },
    handleSizeChange: function handleSizeChange(per) {
      this.table.per = per;
      updateTable(this, initParams(this));
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.table.page = page;
      updateTable(this, initParams(this));
    },
    handleSortChange: function handleSortChange(_ref) {
      var column = _ref.column,
          prop = _ref.prop,
          order = _ref.order;

      this.table = {
        page: this.table.page,
        per: this.table.per,
        order: order === null ? '' : order === 'descending' ? 'DESC' : 'ASC',
        orderBy: prop === null ? '' : prop
      };
      updateTable(this, initParams(this));
    },
    clearSelectors: function clearSelectors() {
      this.$ga.event('Button', 'ClearAll', 'Transactions');
      this.condition = {
        outletId: 9999,
        status: 9999,
        begin: '',
        end: '',
        search: ''
      };
      this.datePicker = [];
    },
    searchByCondition: function searchByCondition() {
      this.$ga.event('Button', 'TableSearch', 'Transactions');
      updateTable(this, initParams(this));
    },
    download: function download() {
      this.$ga.event('Button', 'Download', 'Transactions');
      var params = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, initParams(this));
      var st = '';
      for (var i in params) {
        if (params.hasOwnProperty(i)) {
          st = st + '&' + i + '=' + params[i];
        }
      }
      var url = '/client/trx?download=csv' + st;
      window.open(url);
    },
    reloadTable: function reloadTable() {
      this.$ga.event('Button', 'Reload', 'Transactions');
      updateTable(this, initParams(this));
    }
  },
  created: function created() {
    var vm = this;
    updateTable(this, initParams(this));
    __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].FetchTrxCondition().then(function (res) {
      vm.shopOptions = initCondition(res.data.data.outlet, vm.$tc('Functional.all', 1));
      vm.statusOptions = initCondition(res.data.data.status, vm.$tc('Functional.all', 2));
      vm.conditionLoading = false;
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (to.name !== 'Transaction-Detail') {
      this.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_types__["m" /* InitTrxListTable */]);
    }
    next();
  }
});

function updateTable(vm, params) {
  vm.loading = true;
  __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].FetchTrxTable(params).then(function (res) {
    var result = res.data.data;
    vm.table = {
      total: result.total,
      page: ~~result.page,
      per: ~~result.per,
      order: result.order,
      orderBy: result.orderBy
    };
    vm.tableData = result.list;
    vm.reloadBtn = vm.loading = false;
  }).catch(function (error) {
    console.log(error);
    vm.tableData = [];
    vm.loading = false;
    vm.reloadBtn = true;
  });
}

function initCondition(arr, name) {
  return [{
    value: 9999,
    name: name
  }].concat(arr);
}

function initParams(vm) {
  vm.$store.commit(__WEBPACK_IMPORTED_MODULE_2__store_types__["l" /* SetTrxListTable */], {
    table: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, vm.table),
    condition: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, vm.condition),
    datePicker: vm.datePicker.map(function (item) {
      return item;
    })
  });
  var ts = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, vm.$store.state.trxList);
  var tb = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(ts.table));
  var cd = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(ts.condition));
  delete tb.total;
  if (cd.outletId === 9999) {
    delete cd.outletId;
  }
  if (cd.status === 9999) {
    delete cd.status;
  }
  if (ts.datePicker.length === 2) {
    cd.begin = ts.datePicker[0] === null ? '' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_date__["a" /* default */])(ts.datePicker[0]).format('LT');
    cd.end = ts.datePicker[1] === null ? '' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_date__["a" /* default */])(ts.datePicker[1]).format('LT');
  } else {
    delete cd.begin;
    delete cd.end;
  }
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, tb, cd);
}

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'view-transactions',
  created: function created() {
    var vm = this;
    __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].FetchTrxById(this.$route.params.id).then(function (res) {
      if (res.data.code === 200) {
        vm.form = res.data.data;
        vm.form.settleTime = vm.form.settleTime === '0' ? '-' : __WEBPACK_IMPORTED_MODULE_2_moment___default()(vm.form.settleTime * 1000).format('LT');
        vm.transferNameList.map(function (item) {
          if (item.name === vm.form.settleStatus) {
            vm.transferName = item.value;
          }
        });
      }
      vm.loading = false;
    });
  },

  computed: {
    allDistable: function allDistable() {
      if (+this.form.refundAmount === 0) {
        return true;
      }
      return false;
    },
    localTime: function localTime() {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default.a.tz(this.form.createTimeStamp * 1000, 'Asia/shanghai').clone().tz(this.$store.state.theme.companyInfo.timeZone).format('LT');
    }
  },
  data: function data() {
    return {
      loading: true,
      saveRemarkLoading: false,
      show: false,
      refundShow: true,
      amount: 0,
      checked: false,
      form: {
        refundList: []
      },
      transferName: '',
      transferNameList: [{
        name: '1',
        value: this.$tc('Views.TrxViewDeital.transferNameList', 1)
      }, {
        name: '2',
        value: this.$tc('Views.TrxViewDeital.transferNameList', 2)
      }, {
        name: '3',
        value: this.$tc('Views.TrxViewDeital.transferNameList', 3)
      }],
      finalAmount: 0,
      refundPwd: '',
      dialogVisible: false,
      currency: this.$store.state.theme.companyInfo.currency,
      type: 'password',
      editRemark: false,
      remarkCnt: '',
      remarkNumber: 200
    };
  },

  watch: {
    amount: function amount() {
      checkAmount(this);
    },
    checked: function checked() {
      if (this.checked === true) {
        this.finalAmount = this.form.refundAmount;
        this.amount = (this.finalAmount / (1 + +this.form.cRate)).toFixed(2);
        this.show = true;
        this.refundShow = false;
      } else {
        checkAmount(this);
        this.show = false;
      }
    }
  },
  methods: {
    handleRemarkChange: function handleRemarkChange(val) {
      this.remarkNumber = 200 - val.length;
    },
    saveRemark: function saveRemark() {
      this.$ga.event('Button', 'Remark', 'View transaction detail');
      this.saveRemarkLoading = true;
      var vm = this;
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].changeRemark(this.form.trxId, {
        remark: this.remarkCnt
      }).then(function (res) {
        if (res.data.code === 200) {
          vm.form.remark = vm.remarkCnt;
        } else {
          vm.errorMsg(res);
        }
        vm.editRemark = vm.saveRemarkLoading = false;
      }).catch(function (error) {
        vm.editRemark = vm.saveRemarkLoading = false;
        vm.errorMsg(error);
      });
    },
    refund: function refund() {
      var _this = this;

      var vm = this;
      this.$loading();
      __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].RefundTrxAmount(this.form.trxId, {
        amount: this.finalAmount,
        password: this.refundPwd
      }).then(function (res) {
        if (res.data.code === 200) {
          vm.successMsg(res);
          vm.$router.push({
            path: '/trx'
          });
        } else {
          vm.dialogVisible = false;
          vm.errorMsg(res);
        }
        _this.$loading().close();
      });
    },
    successMsg: function successMsg(res) {
      this.$notify.success({
        title: this.$t('Notify.suc'),
        message: res.data.msg
      });
    },
    errorMsg: function errorMsg(res) {
      this.$notify.error({
        title: this.$t('Notify.err'),
        message: res.data.msg
      });
    }
  }
});

function checkAmount(vm) {
  if (vm.checked === false) {
    vm.finalAmount = (vm.amount * (1 + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(vm.form.cRate))).toFixed(2);
    if (vm.finalAmount > 0 && vm.finalAmount <= vm.form.refundAmount) {
      vm.refundShow = false;
    } else {
      vm.refundShow = true;
    }
  } else {
    vm.finalAmount = vm.form.refundAmount;
    vm.refundShow = false;
  }
}

/***/ }),
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 938 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 939 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 940 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 941 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 942 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 943 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 944 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 945 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 946 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 947 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 948 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 949 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 950 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 951 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 952 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 953 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 954 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 955 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 956 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 957 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 958 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 959 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 960 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 961 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 962 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 963 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 964 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 965 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 966 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 967 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 968 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 969 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 970 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 971 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 972 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 973 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 974 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 975 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 976 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 977 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 978 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 979 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 980 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 981 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 982 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 983 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 984 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 985 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 986 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 987 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 988 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 989 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 990 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 991 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 992 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 993 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 994 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 995 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 996 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 997 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 998 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 999 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1000 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 309,
	"./af.js": 309,
	"./ar": 316,
	"./ar-dz": 310,
	"./ar-dz.js": 310,
	"./ar-kw": 311,
	"./ar-kw.js": 311,
	"./ar-ly": 312,
	"./ar-ly.js": 312,
	"./ar-ma": 313,
	"./ar-ma.js": 313,
	"./ar-sa": 314,
	"./ar-sa.js": 314,
	"./ar-tn": 315,
	"./ar-tn.js": 315,
	"./ar.js": 316,
	"./az": 317,
	"./az.js": 317,
	"./be": 318,
	"./be.js": 318,
	"./bg": 319,
	"./bg.js": 319,
	"./bn": 320,
	"./bn.js": 320,
	"./bo": 321,
	"./bo.js": 321,
	"./br": 322,
	"./br.js": 322,
	"./bs": 323,
	"./bs.js": 323,
	"./ca": 324,
	"./ca.js": 324,
	"./cs": 325,
	"./cs.js": 325,
	"./cv": 326,
	"./cv.js": 326,
	"./cy": 327,
	"./cy.js": 327,
	"./da": 328,
	"./da.js": 328,
	"./de": 331,
	"./de-at": 329,
	"./de-at.js": 329,
	"./de-ch": 330,
	"./de-ch.js": 330,
	"./de.js": 331,
	"./dv": 332,
	"./dv.js": 332,
	"./el": 333,
	"./el.js": 333,
	"./en-au": 334,
	"./en-au.js": 334,
	"./en-ca": 335,
	"./en-ca.js": 335,
	"./en-gb": 336,
	"./en-gb.js": 336,
	"./en-ie": 337,
	"./en-ie.js": 337,
	"./en-nz": 338,
	"./en-nz.js": 338,
	"./eo": 339,
	"./eo.js": 339,
	"./es": 341,
	"./es-do": 340,
	"./es-do.js": 340,
	"./es.js": 341,
	"./et": 342,
	"./et.js": 342,
	"./eu": 343,
	"./eu.js": 343,
	"./fa": 344,
	"./fa.js": 344,
	"./fi": 345,
	"./fi.js": 345,
	"./fo": 346,
	"./fo.js": 346,
	"./fr": 349,
	"./fr-ca": 347,
	"./fr-ca.js": 347,
	"./fr-ch": 348,
	"./fr-ch.js": 348,
	"./fr.js": 349,
	"./fy": 350,
	"./fy.js": 350,
	"./gd": 351,
	"./gd.js": 351,
	"./gl": 352,
	"./gl.js": 352,
	"./gom-latn": 353,
	"./gom-latn.js": 353,
	"./he": 354,
	"./he.js": 354,
	"./hi": 355,
	"./hi.js": 355,
	"./hr": 356,
	"./hr.js": 356,
	"./hu": 357,
	"./hu.js": 357,
	"./hy-am": 358,
	"./hy-am.js": 358,
	"./id": 359,
	"./id.js": 359,
	"./is": 360,
	"./is.js": 360,
	"./it": 361,
	"./it.js": 361,
	"./ja": 362,
	"./ja.js": 362,
	"./jv": 363,
	"./jv.js": 363,
	"./ka": 364,
	"./ka.js": 364,
	"./kk": 365,
	"./kk.js": 365,
	"./km": 366,
	"./km.js": 366,
	"./kn": 367,
	"./kn.js": 367,
	"./ko": 368,
	"./ko.js": 368,
	"./ky": 369,
	"./ky.js": 369,
	"./lb": 370,
	"./lb.js": 370,
	"./lo": 371,
	"./lo.js": 371,
	"./lt": 372,
	"./lt.js": 372,
	"./lv": 373,
	"./lv.js": 373,
	"./me": 374,
	"./me.js": 374,
	"./mi": 375,
	"./mi.js": 375,
	"./mk": 376,
	"./mk.js": 376,
	"./ml": 377,
	"./ml.js": 377,
	"./mr": 378,
	"./mr.js": 378,
	"./ms": 380,
	"./ms-my": 379,
	"./ms-my.js": 379,
	"./ms.js": 380,
	"./my": 381,
	"./my.js": 381,
	"./nb": 382,
	"./nb.js": 382,
	"./ne": 383,
	"./ne.js": 383,
	"./nl": 385,
	"./nl-be": 384,
	"./nl-be.js": 384,
	"./nl.js": 385,
	"./nn": 386,
	"./nn.js": 386,
	"./pa-in": 387,
	"./pa-in.js": 387,
	"./pl": 388,
	"./pl.js": 388,
	"./pt": 390,
	"./pt-br": 389,
	"./pt-br.js": 389,
	"./pt.js": 390,
	"./ro": 391,
	"./ro.js": 391,
	"./ru": 392,
	"./ru.js": 392,
	"./sd": 393,
	"./sd.js": 393,
	"./se": 394,
	"./se.js": 394,
	"./si": 395,
	"./si.js": 395,
	"./sk": 396,
	"./sk.js": 396,
	"./sl": 397,
	"./sl.js": 397,
	"./sq": 398,
	"./sq.js": 398,
	"./sr": 400,
	"./sr-cyrl": 399,
	"./sr-cyrl.js": 399,
	"./sr.js": 400,
	"./ss": 401,
	"./ss.js": 401,
	"./sv": 402,
	"./sv.js": 402,
	"./sw": 403,
	"./sw.js": 403,
	"./ta": 404,
	"./ta.js": 404,
	"./te": 405,
	"./te.js": 405,
	"./tet": 406,
	"./tet.js": 406,
	"./th": 407,
	"./th.js": 407,
	"./tl-ph": 408,
	"./tl-ph.js": 408,
	"./tlh": 409,
	"./tlh.js": 409,
	"./tr": 410,
	"./tr.js": 410,
	"./tzl": 411,
	"./tzl.js": 411,
	"./tzm": 413,
	"./tzm-latn": 412,
	"./tzm-latn.js": 412,
	"./tzm.js": 413,
	"./uk": 414,
	"./uk.js": 414,
	"./ur": 415,
	"./ur.js": 415,
	"./uz": 417,
	"./uz-latn": 416,
	"./uz-latn.js": 416,
	"./uz.js": 417,
	"./vi": 418,
	"./vi.js": 418,
	"./x-pseudo": 419,
	"./x-pseudo.js": 419,
	"./yo": 420,
	"./yo.js": 420,
	"./zh-cn": 421,
	"./zh-cn.js": 421,
	"./zh-hk": 422,
	"./zh-hk.js": 422,
	"./zh-tw": 423,
	"./zh-tw.js": 423
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1005;

/***/ }),
/* 1006 */,
/* 1007 */,
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/center.56ee1c2.png";

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAA2VJREFUWAnN1n1IE3EYB/Dv3Tb34uZMzRKL6B21jAwisr+MXoi0ICPCSimJEKEIipAIJYgsRKK/eiFFCwmi9K8E6QUCUUzBqCCwdygCX1Y6t3Mv1+85vSTddnebc3tg+912d8/vw/N7ueMwFaIocvoLw+Xw44TIiTkQYZXPxarlOa6Go84tVc4MweO6LwIFscLM7Jdw3mup1TxVLl5xhOZpWOeichYDsMTOzyyE5t9y5eQbeZpz8o9I2sp8E67usUSSAjNxlIyXFkREaSdvvtMtYNdaA7IX6cLKFghHifhIVisN6419FmxdpseIS0TtCxeqd5o1A4PhJoGa003fsNjG49QWEx6X2tBxMgn9P3zIy9RjQ4b6KobCUU/66e60H30a9qPxtYCBQR8Gx0Xc3J+IdCuPSzssONA0qphQCUcJOP7cIFvE2uJpuQ2/3SIuto9D8AKvKpKQfd0BFzs+mJuAIaeIZwOekEnV4ChBWMClyTyqCsw4kmdEc5+AtEQOvd+9qH3pDomST6rF0fWqN65kM4e6QgvaymwozDKg4okT6+oc0LMMRdkJqMw3g5OeSzIjcKsFRxlUVdDIZmpnpR23u9z4zOZdwyGrdFzT4ZIUy1N4ZLAF0/mVjXGI0IqjVKoqSBXq/ubFrS4BWek6vP/lw70eASsYjILQ0cBRblVAu4mThvL0NhP2MmxRwx9p/h3dZKQcihFO5eSkIYE24+Skav/gQfH6BBzfbJRwC8w8Shmu9e2EnCdoGwmOkgYE0qrsO2OH43IKWtmioC2lpGUMtDG/OZvMPnZcee5C/09fUJiUfOqVKeRFCicDLpL6IouEau4V2MpNxEIG3n13FG6viDVpOnwZ8cGpULxIKye7ZwGpYqsZYmO9AxOsQDpW45YSKzKTeAk5Kijv63OFk0ZBlsptQ48bK1N5FLMnAoXPDxx+MIaPQ37kqnjGziWO+p9VQfpzX44BjWyvK24aU3xk0fVyzDWO8gZcJG3vPCh7OIZHx6zYvoq9U6mIaOCo24BAOiEjaQ4qRbRw1G/I1y1CKkU0cdS3ivoEJ0YbFxFwPnBhA+cLFxZwPnGagfON0wSMBU41MFY4VcBY4hSBscaFBMYDLigwXnABgfGEmwWMN9x/wHjE/QPGK46A0J8fqpYO4vTrL3vpTu0BHpkUAAAAAElFTkSuQmCC"

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAcCAYAAAAJKR1YAAAAAXNSR0IArs4c6QAAAadJREFUSA3tVr1OwzAQvi+hqApIlJQVlGdoR54AwVZGNtauhS5IYSt07crGCHN5CfoMlVghVAyookpMzqJV5dp1+ieWeIntu/vuy/3JIMtyGu/CorKQOGkfYJ6BM0/4H7KckC3qeYTyCNkiYJPnNZRHyBYBmzyvIVuE4F59XAoSHRJUtClvVA4aglCXT4FCc1CNk/iJhAg26tQEDvRdxz0ftUqvsoZ4s+ttVVOGLyabTd2zT/bNHNjHpKi/wr3oZsc/dYBbIqz1Uab/GQj2xT7Z91hH+3pzr6MTkYhHIuGPFdf7RQQHF/Gd31VxtYRYqdj8DH6S+Dkt9opqtNIZ1Nt23Nqwtd/X4UxSpgrZ4MgrHwN4UGXLnhmLMU1kGNcYoWmnK4+Gv5aO78vWn8tEiMkVGoNKDE7hgqOBW1q4tVG71Jv+SdPemDLVgAHlaABmClHVHZ/TFHVlS2ckw3aZCbGyHA2efyZHA5DwnXalMtnSqe50S2t1lcvMKVPsyDwazC2tYujOSxNisJnRYGlpHQH1biVCDBaEovj2HXV4f+j59X6IIe+XXb+VVIIOZmt8NwAAAABJRU5ErkJggg=="

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAkNJREFUaAXtmDFLw0AUx19sOyi0WLo5ODkpiJ9BxUFENyfFQdBv4IcQ/AAKuoiDLqKDgxS/gi666CwuxdKCgmmJ+R8ErndJe7lLLwnkQWnS5OV+v/fS5BLH84NyHBM5ZmfohUDaHSw6UHTAsALFKWRYQOP03HegHFaCp48erZ93yO1n4yZdKTn0sF+j5TkZV+pA+9djO97sVgmJaQcYwAJ4sIkhCaycdujb33FzvsIS05TA2Nc7VcYCJrCJIQm8fPZoNQMSAfzWQoUVFExgE0MSwA5pS6jCgzVUIE0JwOOcH1V5MCIiBbDRdicCePz/cM5HnTZgC2KoAHayJaEDD76RAjYkdOGVBcYpYQIfS2AcEqbwsQWSlEgCXksgCYmk4LUFTCSShDcSQDIfKnMnHp7PNVlWuoyGDbA0U6bmYY3qkw41392RE0AeHjcp5LBc/xg4lm5oCfDw928ubVx0h04ARXjcYZGDXFOJ2AI8/N2rS9uXXfbgI96xb/eqNFsvsQ+WxekBHpaQayrhiO9GS0etyG7y8Bg4gOcTsM/jQY0aU4MPQ60fj9bO5ClxWHdQjKjoHzcGNil3QAUeR8bgiydtunr+o6+uxz5Yxm9hYKadUOqAKvxAaWKuqHYidgdswMNVtxNDTyFb8EGzdCQiBWzD60qECqQFryMhCaQNH1dCugrh5dG0Pz2Ius4HA9j65q9OARs/tiSAjXl6tRgqwBtmfVn6D2QdWOQrBMSK2F4vOmC74uJ4RQfEitheLzpgu+LieP+sZxiZ44h/xgAAAABJRU5ErkJggg=="

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAADGCAYAAADrGBFyAAAAAXNSR0IArs4c6QAAAMBJREFUWAntmVEOgjAQBa3hdJ6kN2ovgterlaSkoB/7MRpNhoSwDcuUHd4fqZTSLoHjGujZWpbRmHMe5eFaa93WYeI/NO5Tj+kOI0+L8DDTM58q+7uuz/PM34cZN1prt1HP1/AwL8SU0r2TQtGbd/zJWo/MZ9GjHhkDDMU86pExwFDMox4ZAwzFPOqRMcBQzKMeGQMMxTzqkTHAUMyjHhkDDMU86pExwFDMox4ZAwzFPOqRMcBQzOOXPfbt3v5ifQB4bvLpU1JtjwAAAABJRU5ErkJggg=="

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAABLFJREFUaAXtWWtsFFUU/ma7O9vu7hSK0kZUGmN4GxWjUUmgwYA8lCJoLQWJRI3G+EMU4iPRX0DExPiAEMUoBlpSXqEJFvBB0PpCIymokBrUmApUKwm1O+12u9vd9dySqcveuzN3ZrezknD/zM6d8/i+e+7j3LNKihou4ea5hLEPQr9MoNAR9MoA+PhUHJuPRPHdHwPoTwA1N6p4fUEQJT4Z7eGVUcwW8flICo/u7sG+kzEOxZKb/di+NMT1u92RdQ10hJOY8XZYCJ6B3HG8Hxu+irqNl/MnJBCjabJ4q462zgFOIb3juf0RfNNuLpMuPxy/hQTWHOrD96etgcUTKdQ26Pi7p3BHCUegk8C8+WWf9GB1dCexZLuOZIE4cAQaj/UjErOHpuW3OF48EJEmnU9BjkBzG7/jyDh8raUPe08405Wxn02GI3DqXDKbrGX/I7t6kIu+pQOBAEfgXK9zAno0hWWN7q4HjsDoINcl4J29q/XMAH76i/ZhlxqH9rpRXJdtKP4i2yqOFTi090xSHRtjigunqJhY7h4DjkDtTSoURXFEYu4EFY3LNEe6TpU4ApVlHjx0i/0ozB6vommFBr9UfusULq/HEWAia+cGUOyTjwKLWH1dCKp7M2eIiZDANSM8eGZ6yZCQ1Q8249xcuOl4hASYwPMzi1GhZf2cbgNJSoRW7vufpBIGMs2vYNOioPFq+dx6NIqNX7t/PzAd4kU3qKilm5dse/bDCJrb4rLieZEzJcA8bLwviPKQpdggGDaVllJqfbyjgCdx5rBcEVCw+QH5u28vpeLVH+g4/Y/znCoTg9m71NBWT/bhhZnyu9LZ7gSmberGsbPWkWB5UyvJJRzyNa1KpDNnN6557+k49It8zh9QFTTUaZRe8PWXPloqNfU6Dv58wd7Uq71U5dAwYbTUmA5BkybANFiZ5da3utHeZT2yhgePR8H6+QGsmlFsdCFK1+0FW8I4/OvFC14rVrDlwRAW0+Yh22wRYEZPdiZQReWWroi9mNdN9WPDwiCBT2F5Yw8+p2totraqqgSvzAugSCIYtgkwp99ShW72u2Hbd2eWcsgWw6uu92EHJYblIfOUxhEBRuITKjey3YaVVoarXVXqwa7lGqZVZs8QJYIkhnf3eN9gadFXZD5CYm253j+pOnjXO2HTCqDjCBgQWCTu36bbnk6GvuyTZQTv14S4grLjCBiOWSQ+fbwUZYGcTRkmhc+dVItd3dzLfcuL1zvGetHyZCkqy4b3QrDnR/4MygsBNixTKopw9OkRmDVOfg/nhtOiwytAK+iysGLyeRTlTQcf02ylHSbmuE+3U6QzW14JMON08GIdHUJNK0qls9hMUNnen7jzv9PckMk7AcMwSwBPrB5p6z5h6Iqe1VSumUMbRmbLeRvNNCh6b6Ki71NNvejU7aUfhq1JFV58QZsEm6KZzRUCzKnen8Krn0XxBv33EI3Ln963XevF3oc1jKFTWdRcI2A4P0N/iLz0UQQNrTHTvIil4iupMvLyrBLTco3rBAwi7V1J7Pwhhv30f8Tv55NgVXF2dR13pQf3UnmTZa8VFokcs1UwAgaRXJ/iiZWrVRf1LxNwcbCFrv4FmDp6IOsKYKsAAAAASUVORK5CYII="

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAABONJREFUWAntWE1sG0UUnje2Y7uunchOS6kEKlVb0SJxQRGCA6oodw4IxJkDRySQYhJoqZWW0sQHJDj1Aj3DoUeEQBBBLwgoINEe+CkSrZJAvG7rZJv4Z+fxZr0zO2N7Y7tBTQ4ZaffNfO9n3s68eTOzjO2UzY0AKHVerLxG9XcZst0K602hRkqve+XCR735vdHYpPMKMvY+Y5jrLRGgwFap9raYG/9AIjyASY+d6++clMYcAp7VegNW2jp9nPPN0wBJX4ISOshYRoF9KcLgssrYcDraflzpd1Oo2hjm7bbdeuICJn5frGUlmsvl1m6+AWuWBCDQyBhlMPvmCBrKzBXlQkE972Tye0xmr/rPf1a/WXWbjnwWFqsLpRJG2fbVpU1lX1IC3V52NzTSSyEKQ4ayk6Dg2LwZ3xKlIAyYQ5H/zcGheh1CeNs7GLFIIBUrVr5UH3rGdXS+VNjQtGORkM0vqA897YiQkrmus0Q4iDFEdqJTeFNtPwZDB6j2rO1PyDP7CacYoGEy+tSHkVWmBtcxfNEO0hxeVJb6UQ7s424ZuGtg9eOMCaMtt6yLZnujOq13bd+KreTUnUOCiw334piA2vr5seudHewureytN1r7JR73sLo2m/+7UyY1dfugxzfe7rjgq/Xzo3906u6073UE9BSPTDvHBPK90hAIWG3Ojf0QZfTFTzB26cfqkwz4SC8ZjmK5MVu4avKS07UjHnp+CHCOlca5/K8mf6RYOSp47AGJcRD/Nt4rXJN1nWZaLbzCmJeUoCypk7cPrp8d+6vdst+XrlRPCIGfk7zNCFqCQZM+Iv3pS6AFml7jMqUVf08XAlqPlTBztRRmjhay75nn+acYWl11MkV50d4vtXOSITxutSWmCiXVSF5bBhPL15ieHR8zdRDjd3Ispuz5FCyb2r5OM5bwNmroKabvPUm70UPSNwDmHk5mr1tBZDidTie+W3ObH9LWpGOQTnsvM8RRQ8yuApsh+4clSPaXFv+5dZy/WX3YbzNYotPQKcp/B2SbNp0bkspiT0Mbu6c33Wl+oxjzHZAGnskUEvMlaEUZ45MVefcITs6AL0zkE2bMKr2tnGKjb4SumA08NISUz9uLhjFIfm1mq6Pp1SmFIgf3HLPPKl2fDSSvDzDR8joGY0XnAiK+2mWoB8AByq25QtFkxaedp9Bjj/oYwJI3m//M5NOCmALEIxIDWhSMi69QtBclrZolFDhBi+eAzwd2ozVbON2WlW8qvOjUaRXqVdlGo95QoYuOn3SjJDpxWkQ1GjH/1id5+x8s7DJvftR/k/rXMyrK4/7ghTE4sHN+1wN+SKebw7e1x7YqeAA4rzGkoJIn4C0oEQ7iujc3/pzyR95xZ1zHWASKE9L4pFOmZP10iNg1ukLs6nXnsKW6WxEOdgv2QwTg8xRjOlH3kx+UH8bgoBr3WW5rHAS2cqjGmta3Ihr/gsL/NlFTnOGTjqMMzLiGrgL70HQitY8OrvZenGzv/VmWvfutW71MfaiQWNiXyT+ywlYoThkbzWXdm4H9KAeJvfHfrEA/kkyMZJyow8IKadFh4XEi6cBAnjJ4Y76U82+Gkq+KOcWuAvtSQHkSuS8ldBDYWzQBA3RMv4ARTnV6R4lSn+HIzsLXp829uVNangnhJ5Jbbj/wSz/5bgs7yGAj8B9H2KB76HNKwwAAAABJRU5ErkJggg=="

/***/ }),
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(986)
__webpack_require__(985)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(505),
  /* template */
  __webpack_require__(1121),
  /* scopeId */
  "data-v-76c4819c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(948)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(506),
  /* template */
  __webpack_require__(1078),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(997)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(1132),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(508),
  /* template */
  __webpack_require__(1113),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(509),
  /* template */
  __webpack_require__(1123),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(960)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(510),
  /* template */
  __webpack_require__(1091),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(994)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(511),
  /* template */
  __webpack_require__(1129),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(950)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(513),
  /* template */
  __webpack_require__(1080),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(514),
  /* template */
  __webpack_require__(1111),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(971)

var Component = __webpack_require__(3)(
  /* script */
  null,
  /* template */
  __webpack_require__(1104),
  /* scopeId */
  "data-v-414bb4c5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(983)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(1119),
  /* scopeId */
  "data-v-742e5aa0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(991)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(516),
  /* template */
  __webpack_require__(1126),
  /* scopeId */
  "data-v-c425322c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(981)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(517),
  /* template */
  __webpack_require__(1115),
  /* scopeId */
  "data-v-66e290f4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(1102),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(519),
  /* template */
  __webpack_require__(1103),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(520),
  /* template */
  __webpack_require__(1117),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(521),
  /* template */
  __webpack_require__(1082),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(992)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(522),
  /* template */
  __webpack_require__(1127),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(976)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(523),
  /* template */
  __webpack_require__(1109),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(998)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(524),
  /* template */
  __webpack_require__(1133),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(947)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(525),
  /* template */
  __webpack_require__(1077),
  /* scopeId */
  "data-v-016fe418",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(962)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(526),
  /* template */
  __webpack_require__(1093),
  /* scopeId */
  "data-v-30a83aac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(949)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(527),
  /* template */
  __webpack_require__(1079),
  /* scopeId */
  "data-v-0419ee1a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(968)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(528),
  /* template */
  __webpack_require__(1099),
  /* scopeId */
  "data-v-37cfce8d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(965)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(529),
  /* template */
  __webpack_require__(1095),
  /* scopeId */
  "data-v-329177aa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(993)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(530),
  /* template */
  __webpack_require__(1128),
  /* scopeId */
  "data-v-cd546db8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(979)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(531),
  /* template */
  __webpack_require__(1112),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(967)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(532),
  /* template */
  __webpack_require__(1098),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(972)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(533),
  /* template */
  __webpack_require__(1105),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(961)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(534),
  /* template */
  __webpack_require__(1092),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(984)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(535),
  /* template */
  __webpack_require__(1120),
  /* scopeId */
  "data-v-747ca6c3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(974)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(536),
  /* template */
  __webpack_require__(1107),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(966)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(537),
  /* template */
  __webpack_require__(1096),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(977)
__webpack_require__(978)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(538),
  /* template */
  __webpack_require__(1110),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(969)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(539),
  /* template */
  __webpack_require__(1100),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(996)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(540),
  /* template */
  __webpack_require__(1131),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(957)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(541),
  /* template */
  __webpack_require__(1087),
  /* scopeId */
  "data-v-1f03a896",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(951)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(542),
  /* template */
  __webpack_require__(1081),
  /* scopeId */
  "data-v-0b853f92",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(970)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(543),
  /* template */
  __webpack_require__(1101),
  /* scopeId */
  "data-v-3a1d5f3e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(988)
__webpack_require__(987)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(544),
  /* template */
  __webpack_require__(1122),
  /* scopeId */
  "data-v-8a48994e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(995)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(545),
  /* template */
  __webpack_require__(1130),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(952)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(546),
  /* template */
  __webpack_require__(1083),
  /* scopeId */
  "data-v-18b2b875",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  null,
  /* template */
  null,
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(958)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(547),
  /* template */
  __webpack_require__(1088),
  /* scopeId */
  "data-v-23205028",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(956)
__webpack_require__(955)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(548),
  /* template */
  __webpack_require__(1086),
  /* scopeId */
  "data-v-1b255b33",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(1000)
__webpack_require__(999)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(549),
  /* template */
  __webpack_require__(1134),
  /* scopeId */
  "data-v-f9da744e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(953)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(550),
  /* template */
  __webpack_require__(1084),
  /* scopeId */
  "data-v-18e03304",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(980)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(551),
  /* template */
  __webpack_require__(1114),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(982)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(552),
  /* template */
  __webpack_require__(1118),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(964)
__webpack_require__(963)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(553),
  /* template */
  __webpack_require__(1094),
  /* scopeId */
  "data-v-319b0e42",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(990)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(502),
  /* template */
  __webpack_require__(1125),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(989)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(1124),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(975)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(504),
  /* template */
  __webpack_require__(1108),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(554),
  /* template */
  __webpack_require__(1090),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(555),
  /* template */
  __webpack_require__(1097),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(973)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(556),
  /* template */
  __webpack_require__(1106),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(557),
  /* template */
  __webpack_require__(1116),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(959)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(558),
  /* template */
  __webpack_require__(1089),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1077 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coupon-agreement"
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-coupon-form"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('Views.CouponAgreement.title')))]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', _vm._l((_vm.cnt), function(item) {
    return _c('li', [_vm._v(_vm._s(item))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.agree),
      callback: function($$v) {
        _vm.agree = $$v
      },
      expression: "agree"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Views.CouponAgreement.btn')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "confirm"
  }, [_c('el-button', {
    attrs: {
      "disabled": !_vm.agree,
      "loading": _vm.btnLoading
    },
    on: {
      "click": _vm.handleAgree
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.confirm')))])], 1)])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    attrs: {
      "id": "content-wrap"
    }
  }, [_c('div', {
    staticClass: "fade-header"
  }), _vm._v(" "), _c('section', {
    staticClass: "sl-content"
  }, [_c('transition', {
    attrs: {
      "name": "page",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coupon-list"
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-coupon-form"
  }, [_c('div', {
    staticClass: "sl-btn-list"
  }, [_c('router-link', {
    staticClass: "sl-el-btn sl-btn-green",
    attrs: {
      "tag": "el-button",
      "to": {
        name: 'Choose-Coupon'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.$ga.event('Button', '+ Create New Coupon', 'Coupons')
      }
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('Views.Coupons.CNC')))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.validLoading),
      expression: "validLoading"
    }],
    staticClass: "sl-table-list"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('Views.Coupons.AC')))]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [(_vm.valid.length === 0) ? _c('div', {
    staticClass: "no-item"
  }, [_vm._v(_vm._s(_vm.$t('Views.Coupons.none')))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.valid), function(item, index) {
    return _c('div', {
      staticClass: "item"
    }, [(_vm.$route.query.new === 1 && index === 0) ? _c('img', {
      attrs: {
        "src": __webpack_require__(1009)
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "item-top"
    }, [_c('div', {
      staticClass: "item-top-title",
      staticStyle: {
        "-webkit-box-orient": "vertical"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "item-top-time"
    }, [_vm._v(_vm._s(item.dateRange))])]), _vm._v(" "), _c('div', {
      staticClass: "item-middle"
    }), _vm._v(" "), _c('div', {
      staticClass: "item-bottom"
    }, [_c('div', {
      staticClass: "item-top-title"
    }, [_vm._v(_vm._s(item.redeem) + " " + _vm._s(_vm.$t('Views.Coupons.redeem')))])])])
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.invalidLoading),
      expression: "invalidLoading"
    }],
    staticClass: "sl-table-list"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('Views.Coupons.IC')))]), _vm._v(" "), _c('div', {
    staticClass: "list"
  }, [(_vm.valid.length === 0) ? _c('div', {
    staticClass: "no-item"
  }, [_vm._v(_vm._s(_vm.$t('Views.Coupons.none')))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.invalid), function(item) {
    return _c('div', {
      staticClass: "item item-invalid"
    }, [_c('div', {
      staticClass: "item-top"
    }, [_c('div', {
      staticClass: "item-top-title",
      staticStyle: {
        "-webkit-box-orient": "vertical"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "item-top-time"
    }, [_vm._v(_vm._s(_vm.$t('Views.Coupons.invalid')))])]), _vm._v(" "), _c('div', {
      staticClass: "item-middle"
    }), _vm._v(" "), _c('div', {
      staticClass: "item-bottom"
    }, [_c('div', {
      staticClass: "item-top-title"
    }, [_vm._v(_vm._s(item.redeemed) + " " + _vm._s(_vm.$t('Views.Coupons.redeem')))])])])
  })], 2)])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-button', {
    staticClass: "sl-el-btn",
    class: {
      className: _vm.className, 'sl-disabled': _vm.disabled
    },
    attrs: {
      "icon": _vm.icon,
      "loading": _vm.loading,
      "disabled": _vm.disabled
    }
  }, [_vm._v(_vm._s(_vm.text))])
},staticRenderFns: []}

/***/ }),
/* 1081 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contract"
  }, [_c('vue-pdf-viewer', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "download-contract",
    attrs: {
      "url": _vm.src,
      "height": _vm.height
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "agree",
    class: {
      'sl-btn-disable': _vm.btnDisable
    },
    attrs: {
      "type": "button",
      "name": "button",
      "disabled": _vm.btnDisable
    },
    on: {
      "click": function($event) {
        _vm.ConfirmBlock = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Views.Contract.agree')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-bottom": "60px"
    }
  }, [_c('a', {
    staticClass: "contact",
    on: {
      "click": function($event) {
        _vm.ContactBlock = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Views.Contract.contact')))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ConfirmBlock),
      expression: "ConfirmBlock"
    }],
    staticClass: "sl-mask-confirm"
  }, [_c('div', {
    staticClass: "sl-block"
  }, [_c('p', {
    staticClass: "sl-block-title"
  }, [_vm._v(_vm._s(_vm.$t('Views.Contract.info')))]), _vm._v(" "), _c('p', {
    staticClass: "sl-block-cnt"
  }, [_vm._v(_vm._s(_vm.$t('Views.Contract.cnt')))]), _vm._v(" "), _c('div', {
    staticClass: "sl-block-btn"
  }, [_c('button', {
    staticClass: "sl-block-cancel",
    on: {
      "click": function($event) {
        _vm.ConfirmBlock = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "sl-block-confirm",
    on: {
      "click": _vm.confirmContract
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.confirm')))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ContactBlock),
      expression: "ContactBlock"
    }],
    staticClass: "sl-mask-confirm"
  }, [_c('div', {
    staticClass: "sl-block-contact"
  }, [_c('i', {
    staticClass: "sl-block-icon",
    on: {
      "click": function($event) {
        _vm.ContactBlock = false
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('p', {
    staticClass: "sl-block-title",
    staticStyle: {
      "padding-bottom": "30px"
    }
  }, [_vm._v(_vm._s(_vm.$t('Views.Contract.tip')))]), _vm._v(" "), _c('p', {
    staticClass: "sl-contact-cnt"
  }, [_vm._v(_vm._s(_vm.$t('Views.Contract.mail')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.$store.state.theme.companyInfo.email))])]), _vm._v(" "), _c('p', {
    staticClass: "sl-contact-cnt"
  }, [_vm._v(_vm._s(_vm.$t('Views.Contract.phone')) + ": "), _c('strong', [_vm._v(_vm._s(_vm.$store.state.theme.companyInfo.phone))])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1082 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "analytics analytics-customers"
  }, [_c('row', [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.tabClick
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('Views.Analytics.Customer.generalStatus'),
      "name": "first"
    }
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-body"
  }, [_c('p', {
    staticClass: "sl-name"
  }, [_vm._v(_vm._s(_vm.$t('Chart.customerGrowthChart')))]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.first.customersRadio),
      callback: function($$v) {
        _vm.first.customersRadio = $$v
      },
      expression: "first.customersRadio"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "op1",
      "option": _vm.first.customersOption.week
    },
    nativeOn: {
      "click": function($event) {
        _vm.resetFirstCustomersOp('week', 'Recent 7 days')
      }
    }
  }, [_vm._v(_vm._s(_vm.$tc('Date.dateRange', 0)))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "op2",
      "option": _vm.first.customersOption.month
    },
    nativeOn: {
      "click": function($event) {
        _vm.resetFirstCustomersOp('month', 'Recent 30 days')
      }
    }
  }, [_vm._v(_vm._s(_vm.$tc('Date.dateRange', 1)))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "op3",
      "option": _vm.first.customersOption.year
    },
    nativeOn: {
      "click": function($event) {
        _vm.resetFirstCustomersOp('year', 'Recent 12 months')
      }
    }
  }, [_vm._v(_vm._s(_vm.$tc('Date.dateRange', 2)))])], 1)], 1), _vm._v(" "), _c('chart', {
    ref: "firstCustomers",
    attrs: {
      "options": _vm.first.customersOption.default,
      "auto-resize": "",
      "theme": "default"
    }
  })], 1)])])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('Views.Analytics.Customer.customerCategories'),
      "name": "third"
    }
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "box-header with-border ui-sortable-handle",
    staticStyle: {
      "cursor": "move"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.$t('Chart.customerCategories')))]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sl-body"
  }, [_c('row', [_c('div', {
    staticClass: "col-md-4"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('Chart.customerStatus')))]), _vm._v(" "), _c('div', {
    staticClass: "chart col-lg-3"
  }, [_c('chart', {
    ref: "thirdCustomerStatus",
    attrs: {
      "options": _vm.third.customerStatusOption,
      "auto-resize": "",
      "theme": "default"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.third.customerStatusTable,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": "100",
      "show-overflow-tooltip": true,
      "prop": "name",
      "label": _vm.$t('Views.Analytics.Customer.t1h1')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "label",
          style: ({
            backgroundColor: scope.row.color
          })
        }, [_vm._v("  ")]), _vm._v(" "), _c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.category))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "300",
      "show-overflow-tooltip": true,
      "prop": "def",
      "label": _vm.$t('Views.Analytics.Customer.t1h2')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "250",
      "show-overflow-tooltip": true,
      "prop": "value",
      "label": _vm.$t('Views.Analytics.Customer.t1h3')
    }
  })], 1)], 1)]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "col-md-4"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('Chart.customerFrequency')))]), _vm._v(" "), _c('div', {
    staticClass: "chart col-lg-3"
  }, [_c('chart', {
    ref: "thirdCustomerFrequency",
    attrs: {
      "options": _vm.third.customerFrequencyOption,
      "auto-resize": "",
      "theme": "default"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.third.customerFrequencyTable,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": "100",
      "show-overflow-tooltip": true,
      "prop": "name",
      "label": _vm.$t('Views.Analytics.Customer.t2h1')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "label",
          style: ({
            backgroundColor: scope.row.color
          })
        }, [_vm._v("  ")]), _vm._v(" "), _c('span', {
          staticStyle: {
            "margin-left": "10px"
          }
        }, [_vm._v(_vm._s(scope.row.category))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "300",
      "show-overflow-tooltip": true,
      "prop": "def",
      "label": _vm.$t('Views.Analytics.Customer.t2h2')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "250",
      "show-overflow-tooltip": true,
      "prop": "value",
      "label": _vm.$t('Views.Analytics.Customer.t2h3')
    }
  })], 1)], 1)]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "col-md-4"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('Chart.customerContribution')))]), _vm._v(" "), _c('div', {
    staticClass: "chart col-lg-3"
  }, [_c('chart', {
    ref: "thirdCustomerContribution",
    attrs: {
      "options": _vm.third.customerContributionOption,
      "auto-resize": "",
      "theme": "default"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.third.customerContributionTable,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": "100",
      "show-overflow-tooltip": true,
      "prop": "name",
      "label": _vm.$t('Views.Analytics.Customer.t3h1')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "label",
          style: ({
            backgroundColor: scope.row.color
          })
        }, [_vm._v("  ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.category))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "300",
      "show-overflow-tooltip": true,
      "prop": "def",
      "label": _vm.$t('Views.Analytics.Customer.t3h2')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "250",
      "show-overflow-tooltip": true,
      "prop": "value",
      "label": _vm.$t('Views.Analytics.Customer.t3h3')
    }
  })], 1)], 1)])], 1)])])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('Views.Analytics.Customer.ARPC'),
      "name": "fourth"
    }
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-2"
  }, [_c('div', {
    staticClass: "sl-body"
  }, [_c('p', {
    staticClass: "sl-name"
  }, [_vm._v(_vm._s(_vm.$t('Chart.arpcByOutlet')))]), _vm._v(" "), _c('chart', {
    ref: "fourthOutlet",
    attrs: {
      "options": _vm.fourth.outletOption,
      "auto-resize": "",
      "theme": "default"
    }
  })], 1)])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view-refund-detail"
  }, [_c('row', [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fullLoading),
      expression: "fullLoading"
    }],
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-form"
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.RefundDetail.form.trxId')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.trxId))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.RefundDetail.form.cTime')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.createTime))])])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.RefundDetail.form.ptId')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.businessId))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.RefundDetail.form.pType')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.payType))])])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.RefundDetail.form.customer')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.customer))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.RefundDetail.form.fee')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.serviceFee))])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "border-line",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.RefundDetail.form.rAmount')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.refundAmount))])])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('Views.RefundDetail.form.settled')))])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "border-line",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.RefundDetail.form.sTime')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.settleTime))])])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('Views.RefundDetail.form.rComplete')) + ": " + _vm._s(_vm.form.refundStatusTxt))])])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.form.refundStatus == '12' ? _vm.$t('Views.RefundDetail.form.failedTime') : _vm.$t('Views.RefundDetail.form.completeTime')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.modifyTime))])])])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "el-button",
      "to": {
        name: 'Refund'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.$ga.event('Link', 'Back', 'Refund details')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.back')))])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1084 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reset-refund-password"
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-pwd"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Views.RefundPassword.title')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oPwd),
      expression: "oPwd"
    }],
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('Views.RefundPassword.old')
    },
    domProps: {
      "value": (_vm.oPwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oPwd = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nPwd1),
      expression: "nPwd1"
    }],
    class: {
      'sl-error': _vm.error
    },
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('Views.RefundPassword.new')
    },
    domProps: {
      "value": (_vm.nPwd1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nPwd1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nPwd2),
      expression: "nPwd2"
    }],
    class: {
      'sl-error': _vm.error
    },
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('Views.RefundPassword.rNew')
    },
    domProps: {
      "value": (_vm.nPwd2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nPwd2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "sl-error-msg"
  }, [_vm._v("* " + _vm._s(_vm.$t('Views.RefundPassword.err')))]), _vm._v(" "), _c('el-button', {
    class: {
      'sl-btn-disable': _vm.btnDisable
    },
    attrs: {
      "disabled": _vm.btnDisable,
      "loading": _vm.btnLoading
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.$t('Views.RefundPassword.confirm')))])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sl-box"
  }, [_c('div', {
    staticClass: "revenu",
    class: _vm.classObject
  }, [_c('div', {
    staticClass: "sl-cnt"
  }, [_c('span', [_vm._v(_vm._s(_vm.value))])]), _vm._v(" "), _c('div', {
    staticClass: "sl-title"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")])])])
},staticRenderFns: []}

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payment-channel"
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4 flex"
  }, [_vm._l((_vm.open), function(item, index) {
    return _c('div', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (item.loading),
        expression: "item.loading"
      }],
      staticClass: "sl-box"
    }, [_c('div', {
      staticClass: "sl-top"
    }, [_c('el-switch', {
      attrs: {
        "on-text": _vm.$tc('Views.PaymentChannel.channel', 0),
        "off-text": _vm.$tc('Views.PaymentChannel.channel', 1),
        "width": 40
      },
      on: {
        "change": function($event) {
          _vm.OnDisable(index)
        }
      },
      model: {
        value: (item.active),
        callback: function($$v) {
          item.active = $$v
        },
        expression: "item.active"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "sl-img"
    }, [_c('img', {
      attrs: {
        "src": ("/static/imgs/" + (item.channelId) + ".png"),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "sl-channel"
    }, [_c('p', {
      staticClass: "sl-name"
    }, [_vm._v(_vm._s(item.channelName))]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.$t('Views.PaymentChannel.subTitle')))]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(item.rate) + "%")])])])]), _vm._v(" "), _c('div', {
      staticClass: "sl-charge"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('Views.PaymentChannel.CBSF')))]), _vm._v(" "), _c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": "",
        "width": 40
      },
      on: {
        "change": function($event) {
          _vm.OnChargeFee(index)
        }
      },
      model: {
        value: (item.chargeFee),
        callback: function($$v) {
          item.chargeFee = $$v
        },
        expression: "item.chargeFee"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "sl-line"
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.chargeFee),
        expression: "item.chargeFee"
      }],
      staticClass: "sl-rate",
      class: {
        'sl-error': item.error
      }
    }, [_c('span', {
      staticClass: "sl-del"
    }, [_vm._v(_vm._s(_vm.$t('Views.PaymentChannel.SFR')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.cRate),
        expression: "item.cRate"
      }],
      staticClass: "sl-input",
      attrs: {
        "type": "number",
        "step": "0.1"
      },
      domProps: {
        "value": (item.cRate)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          item.cRate = $event.target.value
        }, function($event) {
          _vm.onInput(index)
        }],
        "change": function($event) {
          _vm.onChange(index)
        },
        "focus": function($event) {
          _vm.onFocus(index)
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('span', [_vm._v("%")])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.chargeFee),
        expression: "!item.chargeFee"
      }],
      staticClass: "sl-rate-dis"
    }, [_vm._v("\n          " + _vm._s(_vm.$t('Views.PaymentChannel.MBSF')) + "\n        ")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.error),
        expression: "item.error"
      }],
      staticClass: "sl-error-msg"
    }, [_c('span', [_vm._v("* " + _vm._s(_vm.$t('Views.PaymentChannel.err')) + " ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Views.PaymentChannel.than')) + " " + _vm._s(item.maxRate) + " %")])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.save),
        expression: "item.save"
      }],
      staticClass: "sl-btn"
    }, [_c('button', {
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          _vm.cancel(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('Views.PaymentChannel.cancel')))]), _vm._v(" "), _c('button', {
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          _vm.confirm(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('Views.PaymentChannel.save')))])])])
  }), _vm._v(" "), _vm._l((_vm.available), function(item, index) {
    return _c('div', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (item.loading),
        expression: "item.loading"
      }],
      staticClass: "sl-box sl-available"
    }, [_c('div', {
      staticClass: "sl-top"
    }, [_c('el-switch', {
      attrs: {
        "on-text": _vm.$tc('Views.PaymentChannel.channel', 0),
        "off-text": _vm.$tc('Views.PaymentChannel.channel', 1),
        "width": 40
      },
      on: {
        "change": function($event) {
          _vm.OnActive(index)
        }
      },
      model: {
        value: (item.active),
        callback: function($$v) {
          item.active = $$v
        },
        expression: "item.active"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "sl-img"
    }, [_c('img', {
      attrs: {
        "src": ("/static/imgs/" + (item.channelId) + "_disable.png"),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "sl-channel"
    }, [_c('p', {
      staticClass: "sl-name"
    }, [_vm._v(_vm._s(item.channelName))]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.$t('Views.PaymentChannel.SFR')) + " ")]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(item.rate) + "%")])])])])])
  })], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1087 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fullLoading),
      expression: "fullLoading"
    }],
    staticClass: "agreement"
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-agreement"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('Views.Agreement.title')))]), _vm._v(" "), (_vm.errorMsg !== '') ? _c('div', {
    staticClass: "error-msg"
  }, [_vm._v(_vm._s(_vm.errorMsg))]) : _vm._l((_vm.list), function(item) {
    return _c('div', {
      staticClass: "sl-table-sm"
    }, [_c('ul', [_c('li', {
      staticStyle: {
        "position": "relative"
      }
    }, [_c('img', {
      attrs: {
        "src": ("/static/imgs/T-" + (item.channelId) + ".png"),
        "alt": ""
      }
    }), _c('span', [_vm._v(_vm._s(item.channelName))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v(_vm._s(item.settleWay) + "+" + _vm._s(item.settlePeriod))])]), _vm._v(" "), _c('li', [_c('span', [_vm._v(_vm._s((item.rate / 100).toFixed(2)) + "%")])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.next')))])], 2)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1088 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reset-password"
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-pwd"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Views.Password.title')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oPwd),
      expression: "oPwd"
    }],
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('Views.Password.old')
    },
    domProps: {
      "value": (_vm.oPwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oPwd = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nPwd1),
      expression: "nPwd1"
    }],
    class: {
      'sl-error': _vm.error
    },
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('Views.Password.new')
    },
    domProps: {
      "value": (_vm.nPwd1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nPwd1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nPwd2),
      expression: "nPwd2"
    }],
    class: {
      'sl-error': _vm.error
    },
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('Views.Password.rNew')
    },
    domProps: {
      "value": (_vm.nPwd2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nPwd2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "sl-error-msg"
  }, [_vm._v("* " + _vm._s(_vm.$t('Views.Password.err')))]), _vm._v(" "), _c('el-button', {
    class: {
      'sl-btn-disable': _vm.btnDisable
    },
    attrs: {
      "disabled": _vm.btnDisable,
      "loading": _vm.btnLoading
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.$t('Views.Password.confirm')))])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1089 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1090 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "sl-sidebar"
  }, [_c('el-menu', {
    attrs: {
      "default-active": _vm.currentPage,
      "unique-opened": true,
      "router": true
    }
  }, [_vm._l((_vm.slider), function(item, index) {
    return [(item.menu === '/coupons') ? _c('div', {
      staticClass: "sl-sidebar-border"
    }) : _vm._e(), _vm._v(" "), (item.children.length === 0) ? _c('el-menu-item', {
      attrs: {
        "index": item.url
      }
    }, [_c('div', {
      staticStyle: {
        "height": "20px",
        "line-height": "20px",
        "display": "inline-block"
      }
    }, [_c('i', {
      class: item.icon,
      staticStyle: {
        "margin-right": "5px"
      }
    }), _vm._v(_vm._s(item.name) + "\n        ")])]) : _vm._e(), _vm._v(" "), (item.menu === '/dashboard') ? _c('div', {
      staticClass: "sl-sidebar-border"
    }) : _vm._e(), _vm._v(" "), (item.menu === '/coupons') ? _c('div', {
      staticClass: "sl-sidebar-border"
    }) : _vm._e(), _vm._v(" "), (item.children.length !== 0) ? _c('el-submenu', {
      attrs: {
        "index": index.toString()
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('div', {
      staticStyle: {
        "height": "20px",
        "line-height": "20px",
        "display": "inline-block"
      }
    }, [_c('i', {
      class: item.icon,
      staticStyle: {
        "margin-right": "5px"
      }
    }), _vm._v("\n            " + _vm._s(item.name) + "\n          ")])]), _vm._v(" "), _vm._l((item.children), function(it, i) {
      return _c('el-menu-item', {
        attrs: {
          "index": it.menu
        }
      }, [_c('div', {
        staticStyle: {
          "height": "20px",
          "line-height": "20px",
          "display": "inline-block"
        }
      }, [_c('i', {
        staticClass: "fa fa-crosshairs",
        staticStyle: {
          "margin-right": "5px"
        }
      }), _vm._v("\n            " + _vm._s(it.name) + "\n          ")])])
    })], 2) : _vm._e()]
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "sl-sidebar-app"
  }, [_c('img', {
    staticClass: "sidebar-logo",
    attrs: {
      "src": ("/static/" + (this.$store.state.theme.name) + "/sidebar-logo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name-app"
  }, [_vm._v(_vm._s(_vm.$t('Navigator.appName')))]), _vm._v(" "), _c('img', {
    staticClass: "qrcode-app",
    attrs: {
      "src": __webpack_require__(211),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "category-app"
  }, [_vm._v("iOS & Android")])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1092 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "update-account"
  }, [_c('row', [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-form"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.label.username
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.form.username),
      callback: function($$v) {
        _vm.form.username = $$v
      },
      expression: "form.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.name
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.form.name = $$v
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.password
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.form.password = $$v
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.phone
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.phone),
      callback: function($$v) {
        _vm.form.phone = $$v
      },
      expression: "form.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.email
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.form.email = $$v
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.admin
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form.admin),
      callback: function($$v) {
        _vm.form.admin = $$v
      },
      expression: "form.admin"
    }
  }, [_vm._v(_vm._s(_vm.$tc("Functional.yes", 2)))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.form.admin),
      callback: function($$v) {
        _vm.form.admin = $$v
      },
      expression: "form.admin"
    }
  }, [_vm._v(_vm._s(_vm.$tc("Functional.no", 2)))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.status
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.form.status = $$v
      },
      expression: "form.status"
    }
  }, [_vm._v(_vm._s(_vm.$tc("Functional.on", 2)))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.form.status = $$v
      },
      expression: "form.status"
    }
  }, [_vm._v(_vm._s(_vm.$tc("Functional.off", 2)))])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "sm-form-btn"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('Button.save')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v(_vm._s(_vm.$t('Button.delete')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "el-button",
      "to": {
        name: 'Accounts'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.$ga.event('Link', 'Cancel', 'Update account')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Button.cancel')))])], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1093 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fullLoading),
      expression: "fullLoading\n"
    }],
    staticClass: "choose-coupon sl-coupon"
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-coupon-form"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('i', {
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("\n                < " + _vm._s(_vm.$t('Functional.back')) + "\n              ")]), _vm._v("\n              " + _vm._s(_vm.$t('Views.ChooseCoupon.title')) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "type-list"
  }, _vm._l((_vm.types), function(item) {
    return _c('router-link', {
      staticClass: "type",
      attrs: {
        "to": {
          name: 'Add-Coupon',
          query: {
            id: item.id,
            name: item.title
          }
        },
        "tag": "div"
      },
      nativeOn: {
        "click": function($event) {
          _vm.$ga.event('Link', item.title, 'Choose coupon')
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.title))])])
  }))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "des"
  }, [_c('div', {
    staticClass: "des-title"
  }, [_vm._v(_vm._s(_vm.$t('Functional.help')))]), _vm._v(" "), _vm._l((_vm.types), function(item, index) {
    return _c('div', {
      staticClass: "des-item"
    }, [_c('p', [_vm._v(_vm._s(item.id) + "、" + _vm._s(item.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.subtitle))]), _vm._v(" "), _c('div', {}, [_c('span', [_vm._v(_vm._s(_vm.$t('Views.ChooseCoupon.example')) + ":")]), _vm._v(" "), _c('ul', _vm._l((item.example), function(it) {
      return _c('li', [_vm._v(_vm._s(it))])
    }))])])
  })], 2)])], 1)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "view-transactions-detail"
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-form",
    staticStyle: {
      "max-width": "700px",
      "margin": "16px auto"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('h3', {
    staticClass: "trx-title"
  }, [_vm._v(_vm._s(_vm.form.trxId))])])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.t1')))])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "border-line sl-trx-val",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.trxId')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.trxId))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.createTime')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.createTime))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.createLocalTime')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.localTime))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.customer')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.customer))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.payChannel')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.payType))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.payTrxId')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.businessId))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.posId')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.sn))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.cashier')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.username))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.customer')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.username))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(!_vm.editRemark) ? _c('div', {
    staticClass: "sl-remark"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.remark')) + ":")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "position": "relative",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.editRemark = true;
        _vm.remarkCnt = _vm.form.remark;
        _vm.remarkNumber = 200 - _vm.form.remark.length
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.form.remark))]), _c('i')])]) : _c('div', {
    staticClass: "sl-remark-edit"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.remark')) + ":")]), _vm._v(" "), _c('div', [_c('el-input', {
    attrs: {
      "maxlength": 200,
      "type": "textarea",
      "autosize": {
        minRows: 1,
        maxRows: 5
      },
      "placeholder": "remark"
    },
    on: {
      "change": _vm.handleRemarkChange
    },
    model: {
      value: (_vm.remarkCnt),
      callback: function($$v) {
        _vm.remarkCnt = $$v
      },
      expression: "remarkCnt"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sl-remark-number"
  }, [_vm._v(_vm._s(_vm.remarkNumber))]), _vm._v(" "), _c('div', {
    staticClass: "sl-remark-action"
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": function($event) {
        _vm.editRemark = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "success",
      "loading": _vm.saveRemarkLoading
    },
    on: {
      "click": _vm.saveRemark
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.save')))])], 1)], 1)])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "border-line sl-trx-val",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    class: {
      'sl-no-coupon': _vm.form.disAmount === '0.00' || _vm.form.disAmount === ''
    },
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('img', {
    staticClass: "sl-line-01",
    attrs: {
      "src": __webpack_require__(1012)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sl-trx-mainval"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.realAmount')) + ":")]), _vm._v(" "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.currency))]), _vm._v(_vm._s(_vm.form.realAmount))])]), _vm._v(" "), _c('div', {
    staticClass: "sl-trx-subval"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(210),
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.customerAmount')) + ":")]), _vm._v(" "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.currency))]), _vm._v(_vm._s(_vm.form.initAmount))])]), _vm._v(" "), _c('div', {
    staticClass: "sl-trx-subval sl-trx-discount"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(210),
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.discount')) + ":")]), _vm._v(" "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.currency))]), _vm._v("-" + _vm._s(_vm.form.disAmount))])]), _vm._v(" "), _c('div', {
    staticClass: "sl-trx-subval"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(210),
      "alt": ""
    }
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.fee')) + ":")]), _vm._v(" "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.currency))]), _vm._v(_vm._s(_vm.form.serviceFee))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.cRate')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s((_vm.form.cRate * 100).toFixed(2)) + "%")])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.mRate')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s((_vm.form.merchantFeeRate * 100).toFixed(2)) + "%")])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.settleAmount')) + ":")]), _vm._v(" "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.currency))]), _vm._v(_vm._s(_vm.form.settleAmount))])])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('h3', [_vm._v(_vm._s(_vm.transferName))])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "border-line sl-trx-val",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.settleTime')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.settleTime))])])])], 1), _vm._v(" "), (_vm.form.refundList.length !== 0) ? [_vm._l((_vm.form.refundList), function(item, index) {
    return [_c('el-row', {
      staticClass: "sl-trx-val",
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.refundRecord')))])])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.refundStatus')) + ":")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.status === '10'),
        expression: "item.status === '10'"
      }]
    }, [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.requestForRefund')))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.status === '11'),
        expression: "item.status === '11'"
      }]
    }, [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.refunded')))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.status === '12'),
        expression: "item.status === '12'"
      }]
    }, [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.refundFailed')))])])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.appTime')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.createTime))])])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.completeTime')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.modifyTime))])])])], 1), _vm._v(" "), _c('el-row', {
      staticClass: "sl-trx-val",
      class: {
        'border-inline': index + 1 !== _vm.form.refundList.length
      },
      staticStyle: {
        "margin-bottom": "10px"
      },
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.refundAmount')) + ":")]), _vm._v(" "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.currency))]), _vm._v(_vm._s(item.refundAmount))])])])], 1)]
  })] : _vm._e(), _vm._v(" "), _c('el-row', {
    class: {
      'border-top': _vm.form.refundList.length !== 0
    },
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.refund')))])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "sl-trx-val",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.refundAbleAmount')) + ":")]), _vm._v(" "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.currency))]), _vm._v(_vm._s(_vm.form.refundAmount))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.refundAmount')) + ":")]), _vm._v(" "), _c('el-input', {
    staticClass: "sl-fr sl-val-input",
    class: {
      'disabled': _vm.show
    },
    attrs: {
      "type": "number",
      "disabled": _vm.show,
      "step": "0.01",
      "auto-complete": "off",
      "min": "0"
    },
    on: {
      "focus": function($event) {
        _vm.type = 'text'
      },
      "blur": function($event) {
        _vm.type = 'password'
      }
    },
    model: {
      value: (_vm.amount),
      callback: function($$v) {
        _vm.amount = $$v
      },
      expression: "amount"
    }
  }), _vm._v(" "), _c('b', {
    staticClass: "sl-fr"
  }, [_vm._v(_vm._s(_vm.currency))]), _vm._v(" "), _c('el-checkbox', {
    staticClass: "sl-fr sl-checkbox",
    attrs: {
      "disabled": _vm.allDistable
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v(_vm._s(_vm.$tc('Functional.all', 0)))])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.table.finalAmount')) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "final-amount"
  }, [_c('b', [_vm._v(_vm._s(_vm.currency))]), _vm._v(_vm._s(_vm.finalAmount))])])])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('router-link', {
    attrs: {
      "tag": "el-button",
      "to": {
        name: 'Transactions'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.$ga.event('Link', 'Back', 'View transaction detail')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.back')))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.amount !== 0),
      expression: "form.amount !== 0"
    }],
    attrs: {
      "disabled": _vm.refundShow
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogVisible = true;
        _vm.$ga.event('Button', 'Refund', 'View transaction detail')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Button.refund')))])], 1)], 1)], 2)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('Views.TrxViewDeital.tips.title'),
      "size": "tiny"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Views.TrxViewDeital.tips.cnt')))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-input', {
    staticClass: "refund-pwd",
    attrs: {
      "type": _vm.type,
      "placeholder": _vm.$t('Views.TrxViewDeital.tips.placeholder'),
      "auto-complete": "off"
    },
    model: {
      value: (_vm.refundPwd),
      callback: function($$v) {
        _vm.refundPwd = $$v
      },
      expression: "refundPwd"
    }
  }), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.refund
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.confirm')))])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1095 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customers"
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-condition"
  }, [_c('row', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('el-checkbox', {
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  }, [_vm._v(_vm._s(_vm.$t('Views.Customers.checkbox.all')))]), _vm._v(" "), _c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedChange
    },
    model: {
      value: (_vm.checkList),
      callback: function($$v) {
        _vm.checkList = $$v
      },
      expression: "checkList"
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('el-checkbox', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v(_vm._s(_vm.$tc('Views.Customers.checkbox.activeCustomers', 0)))]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v(_vm._s(_vm.$tc('Views.Customers.checkbox.activeCustomers', 1)))]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "3"
    }
  }, [_vm._v(_vm._s(_vm.$tc('Views.Customers.checkbox.activeCustomers', 2)))])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('el-checkbox', {
    attrs: {
      "label": "4"
    }
  }, [_vm._v(_vm._s(_vm.$tc('Views.Customers.checkbox.frequencyCustomers', 0)))]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "5"
    }
  }, [_vm._v(_vm._s(_vm.$tc('Views.Customers.checkbox.frequencyCustomers', 1)))]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "6"
    }
  }, [_vm._v(_vm._s(_vm.$tc('Views.Customers.checkbox.frequencyCustomers', 2)))])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('el-checkbox', {
    attrs: {
      "label": "7"
    }
  }, [_vm._v(_vm._s(_vm.$tc('Views.Customers.checkbox.contributionCustomers', 0)))]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "8"
    }
  }, [_vm._v(_vm._s(_vm.$tc('Views.Customers.checkbox.contributionCustomers', 1)))]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "9"
    }
  }, [_vm._v(_vm._s(_vm.$tc('Views.Customers.checkbox.contributionCustomers', 2)))])], 1)])], 1)])]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "btn btn-success btn-flat",
    on: {
      "click": _vm.searchByCondition
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.confirm')))]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-danger btn-flat ",
    on: {
      "click": _vm.clearSelectors
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.clear')))])])])])], 1)])]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "sl-body"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": "150",
      "show-overflow-tooltip": true,
      "prop": "id",
      "label": _vm.$t('Views.Customers.table.id'),
      "sortable": "",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "150",
      "show-overflow-tooltip": true,
      "prop": "name",
      "label": _vm.$t('Views.Customers.table.name'),
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "150",
      "show-overflow-tooltip": true,
      "prop": "phone",
      "label": _vm.$t('Views.Customers.table.mobile'),
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "150",
      "show-overflow-tooltip": true,
      "prop": "gender",
      "label": _vm.$t('Views.Customers.table.gender')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "150",
      "show-overflow-tooltip": true,
      "prop": "joinTime",
      "label": _vm.$t('Views.Customers.table.joinDate')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "150",
      "show-overflow-tooltip": true,
      "prop": "totalAmount",
      "label": _vm.$t('Views.Customers.table.totalSpending')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "150",
      "show-overflow-tooltip": true,
      "prop": "lastVisitTime",
      "label": _vm.$t('Views.Customers.table.lastVisitDate')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "150",
      "show-overflow-tooltip": true,
      "prop": "avgAmount",
      "label": _vm.$t('Views.Customers.table.averageSpending')
    }
  })], 1)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1096 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-new-outlet"
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-form"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.label.name
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.form.name = $$v
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.place
    }
  }, [_c('gmap-autocomplete', {
    staticClass: "googlePlace",
    attrs: {
      "select-first-on-enter": true,
      "default-place": _vm.googlePlace
    },
    on: {
      "place_changed": _vm.updatePlace
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.country
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.form.country),
      callback: function($$v) {
        _vm.form.country = $$v
      },
      expression: "form.country"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.state
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.form.state),
      callback: function($$v) {
        _vm.form.state = $$v
      },
      expression: "form.state"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.city
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.form.city),
      callback: function($$v) {
        _vm.form.city = $$v
      },
      expression: "form.city"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.lng
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.form.lng),
      callback: function($$v) {
        _vm.form.lng = $$v
      },
      expression: "form.lng"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.lat
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.form.lat),
      callback: function($$v) {
        _vm.form.lat = $$v
      },
      expression: "form.lat"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.address1
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.address1),
      callback: function($$v) {
        _vm.form.address1 = $$v
      },
      expression: "form.address1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.address2
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.address2),
      callback: function($$v) {
        _vm.form.address2 = $$v
      },
      expression: "form.address2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.contact
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.contact),
      callback: function($$v) {
        _vm.form.contact = $$v
      },
      expression: "form.contact"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.phone
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.phone),
      callback: function($$v) {
        _vm.form.phone = $$v
      },
      expression: "form.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('Views.ViewOutletDetail.table.pt')
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('el-upload', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.insideLoading),
      expression: "insideLoading"
    }],
    staticClass: "upload-photo",
    attrs: {
      "action": "/client/upload?type=photo",
      "show-file-list": false,
      "before-upload": _vm.beforePhotoUpload,
      "on-success": _vm.uploadInsidePhotoSuccess,
      "on-progress": _vm.uploadInsideProcess,
      "on-error": _vm.uploadInsidePhotoError
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Views.ViewOutletDetail.table.p1')))]), _vm._v(" "), (_vm.insidePhotoUrl !== '') ? _c('img', {
    staticClass: "shop-avatar",
    attrs: {
      "src": _vm.insidePhotoUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus shop-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('el-upload', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.outsideLoading),
      expression: "outsideLoading"
    }],
    staticClass: "upload-photo",
    attrs: {
      "action": "/client/upload?type=photo",
      "show-file-list": false,
      "before-upload": _vm.beforePhotoUpload,
      "on-success": _vm.uploadOutsidePhotoSuccess,
      "on-progress": _vm.uploadOutsideProcess,
      "on-error": _vm.uploadOutsidePhotoError
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Views.ViewOutletDetail.table.p2')))]), _vm._v(" "), (_vm.outsidePhotoUrl !== '') ? _c('img', {
    staticClass: "shop-avatar",
    attrs: {
      "src": _vm.outsidePhotoUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus shop-uploader-icon"
  })])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.activeTime
    }
  }, _vm._l((_vm.weeks), function(item) {
    return _c('el-row', {
      key: item,
      staticClass: "sl-form-box-week"
    }, [_c('el-col', {
      staticClass: "week-name",
      attrs: {
        "span": 4,
        "xs": 12
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 20,
        "xs": 12
      }
    }, [_c('el-input', {
      attrs: {
        "auto-complete": "off"
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          item.value = $$v
        },
        expression: "item.value"
      }
    })], 1)], 1)
  })), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success",
      "loading": _vm.btnLoading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('Button.save')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "el-button",
      "to": {
        name: 'Outlets'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.$ga.event('Link', 'Cancel', 'Add new store')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Button.cancel')))])], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1097 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default", [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])], 2)])
},staticRenderFns: []}

/***/ }),
/* 1098 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accounts"
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-condition"
  }, [_c('row', [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('Placeholder.AccountSearch')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.searchByCondition($event)
      }
    },
    model: {
      value: (_vm.condition.search),
      callback: function($$v) {
        _vm.condition.search = $$v
      },
      expression: "condition.search"
    }
  })], 1)])]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Status",
      "clearable": ""
    },
    model: {
      value: (_vm.condition.status),
      callback: function($$v) {
        _vm.condition.status = $$v
      },
      expression: "condition.status"
    }
  }, _vm._l((_vm.statusOp), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 sm-margin"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('sl-btn', {
    staticClass: "sl-btn-lightblue",
    attrs: {
      "text": _vm.$t('Functional.confirm')
    },
    nativeOn: {
      "click": function($event) {
        _vm.searchByCondition($event)
      }
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "sl-el-btn sl-btn-green",
    attrs: {
      "tag": "el-button",
      "to": {
        name: 'Add-New-Account'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.$ga.event('Link', 'Create new account', 'Accounts')
      }
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('Views.Accounts.btn.add')))])], 1)])])], 1)])]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "sl-body"
  }, [_c('row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reloadBtn),
      expression: "reloadBtn"
    }],
    staticClass: "sl-table-reload"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('Notify.errorMsg')) + "\n          "), _c('sl-btn', {
    staticClass: "sl-btn-lightblue",
    attrs: {
      "text": _vm.$t('Functional.reload')
    },
    nativeOn: {
      "click": function($event) {
        _vm.reloadTable($event)
      }
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": "150",
      "fixed": _vm.$store.state.userAgent.isPhone ? false : 'left',
      "show-overflow-tooltip": true,
      "prop": "username",
      "label": _vm.$t('Views.Accounts.table.username')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "150",
      "show-overflow-tooltip": true,
      "prop": "name",
      "label": _vm.$t('Views.Accounts.table.name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "150",
      "show-overflow-tooltip": true,
      "prop": "phone",
      "label": _vm.$t('Views.Accounts.table.mobile')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "150",
      "show-overflow-tooltip": true,
      "prop": "email",
      "label": _vm.$t('Views.Accounts.table.email')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "150",
      "show-overflow-tooltip": true,
      "prop": "status",
      "label": _vm.$t('Views.Accounts.table.status'),
      "formatter": _vm.formatterStatus
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "150",
      "show-overflow-tooltip": true,
      "prop": "lastLoginTime",
      "label": _vm.$t('Views.Accounts.table.lastTime'),
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "150",
      "show-overflow-tooltip": true,
      "prop": "createTime",
      "label": _vm.$t('Views.Accounts.table.createdAt'),
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "150",
      "show-overflow-tooltip": true,
      "prop": "modifyTime",
      "label": _vm.$t('Views.Accounts.table.updatedAt')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "150",
      "show-overflow-tooltip": true,
      "prop": "admin",
      "label": _vm.$t('Views.Accounts.table.admin'),
      "formatter": _vm.formatterAdmin
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": _vm.$store.state.userAgent.isPhone ? 100 : 150,
      "fixed": "right",
      "label": _vm.$t('Table.actions')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "sl-edit",
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.edit(scope.row.id)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('Table.edit')))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.reloadBtn),
      expression: "!reloadBtn"
    }],
    attrs: {
      "current-page": _vm.table.page,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.table.per,
      "layout": "prev, pager, next, sizes, jumper, total",
      "total": _vm.table.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fullLoading),
      expression: "fullLoading\n"
    }],
    staticClass: "coupon-tips sl-coupon"
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-coupon-form"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('Views.CouponsTips.title')))]), _vm._v(" "), _c('img', {
    staticClass: "coupon-tips-center",
    attrs: {
      "src": __webpack_require__(1008)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "coupon-tips-1"
  }, [_vm._v(_vm._s(_vm.$t('Views.CouponsTips.tip1')))]), _vm._v(" "), _c('p', {
    staticClass: "coupon-tips-2"
  }, [_vm._v(_vm._s(_vm.$t('Views.CouponsTips.tip2')))]), _vm._v(" "), _c('img', {
    staticClass: "coupon-tips-down",
    attrs: {
      "src": __webpack_require__(1010)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "coupon-tips-btm"
  }, [_c('div', {
    staticClass: "coupon-tips-btm-item"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1011),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.email))])]), _vm._v(" "), _c('div', {
    staticClass: "coupon-tips-btm-item"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(1013),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.number))])])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "update-outlet"
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-form"
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fullLoading),
      expression: "fullLoading"
    }],
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "160px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.label.name
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.form.name = $$v
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.place
    }
  }, [_c('gmap-autocomplete', {
    staticClass: "googlePlace",
    attrs: {
      "select-first-on-enter": true,
      "default-place": _vm.googlePlace
    },
    on: {
      "place_changed": _vm.updatePlace
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.country
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.form.country),
      callback: function($$v) {
        _vm.form.country = $$v
      },
      expression: "form.country"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.state
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.form.state),
      callback: function($$v) {
        _vm.form.state = $$v
      },
      expression: "form.state"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.city
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.form.city),
      callback: function($$v) {
        _vm.form.city = $$v
      },
      expression: "form.city"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.lng
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.form.lng),
      callback: function($$v) {
        _vm.form.lng = $$v
      },
      expression: "form.lng"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.lat
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.form.lat),
      callback: function($$v) {
        _vm.form.lat = $$v
      },
      expression: "form.lat"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.address1
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.address1),
      callback: function($$v) {
        _vm.form.address1 = $$v
      },
      expression: "form.address1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.address2
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.address2),
      callback: function($$v) {
        _vm.form.address2 = $$v
      },
      expression: "form.address2"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.contact
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.contact),
      callback: function($$v) {
        _vm.form.contact = $$v
      },
      expression: "form.contact"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.phone
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.phone),
      callback: function($$v) {
        _vm.form.phone = $$v
      },
      expression: "form.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Upload photos of store"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('el-upload', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.insideLoading),
      expression: "insideLoading"
    }],
    staticClass: "upload-photo",
    attrs: {
      "action": "/client/upload?type=photo",
      "show-file-list": false,
      "before-upload": _vm.beforePhotoUpload,
      "on-success": _vm.uploadInsidePhotoSuccess,
      "on-progress": _vm.uploadInsideProcess,
      "on-error": _vm.uploadInsidePhotoError
    }
  }, [_c('p', [_vm._v("Shop inside photo")]), _vm._v(" "), (_vm.insidePhotoUrl !== '') ? _c('img', {
    staticClass: "shop-avatar",
    attrs: {
      "src": _vm.insidePhotoUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus shop-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('el-upload', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.outsideLoading),
      expression: "outsideLoading"
    }],
    staticClass: "upload-photo",
    attrs: {
      "action": "/client/upload?type=photo",
      "show-file-list": false,
      "before-upload": _vm.beforePhotoUpload,
      "on-success": _vm.uploadOutsidePhotoSuccess,
      "on-progress": _vm.uploadOutsideProcess,
      "on-error": _vm.uploadOutsidePhotoError
    }
  }, [_c('p', [_vm._v("Shop outside photo")]), _vm._v(" "), (_vm.outsidePhotoUrl !== '') ? _c('img', {
    staticClass: "shop-avatar",
    attrs: {
      "src": _vm.outsidePhotoUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus shop-uploader-icon"
  })])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.activeTime
    }
  }, _vm._l((_vm.weeks), function(item) {
    return _c('el-row', {
      key: item,
      staticClass: "sl-form-box-week"
    }, [_c('el-col', {
      staticClass: "week-name",
      attrs: {
        "span": 4,
        "xs": 12
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 20,
        "xs": 12
      }
    }, [_c('el-input', {
      attrs: {
        "auto-complete": "off"
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          item.value = $$v
        },
        expression: "item.value"
      }
    })], 1)], 1)
  })), _vm._v(" "), _c('el-form-item', {
    staticClass: "sm-form-btn"
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "loading": _vm.btnLoading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        _vm.deleteDialog = true;
        _vm.$ga.event('Button', 'Delete', 'Edit store')
      }
    }
  }, [_vm._v("Delete")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "el-button",
      "to": {
        name: 'Outlets'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.$ga.event('Link', 'Cancel', 'Edit store')
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Delete store",
      "size": "tiny"
    },
    model: {
      value: (_vm.deleteDialog),
      callback: function($$v) {
        _vm.deleteDialog = $$v
      },
      expression: "deleteDialog"
    }
  }, [_c('span', [_vm._v("Are you sure you want to delete this store ? ")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.deleteDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.deleteOutlet
    }
  }, [_vm._v("Confirm")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1101 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customers"
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-resetpwd"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Views.ResetPwd.t1')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nPwd1),
      expression: "nPwd1"
    }],
    class: {
      'sl-error': _vm.error
    },
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.nPwd1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nPwd1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nPwd2),
      expression: "nPwd2"
    }],
    class: {
      'sl-error': _vm.error
    },
    attrs: {
      "type": "password",
      "placeholder": "Confirm password"
    },
    domProps: {
      "value": (_vm.nPwd2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nPwd2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "sl-error-msg"
  }, [_vm._v("* " + _vm._s(_vm.$t('Views.ResetPwd.err')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('Views.ResetPwd.t2')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rPwd1),
      expression: "rPwd1"
    }],
    class: {
      'sl-error': _vm.rError
    },
    attrs: {
      "type": "password",
      "placeholder": "Refund password"
    },
    domProps: {
      "value": (_vm.rPwd1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rPwd1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rPwd2),
      expression: "rPwd2"
    }],
    class: {
      'sl-error': _vm.rError
    },
    attrs: {
      "type": "password",
      "placeholder": "Confirm refund password"
    },
    domProps: {
      "value": (_vm.rPwd2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rPwd2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rError),
      expression: "rError"
    }],
    staticClass: "sl-error-msg"
  }, [_vm._v("* " + _vm._s(_vm.$t('Views.ResetPwd.err')))]), _vm._v(" "), _c('button', {
    class: {
      'disable-btn': _vm.disableBtn
    },
    attrs: {
      "disabled": _vm.disableBtn
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.confirm')))])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sl-sp-page', {
    attrs: {
      "data": _vm.info
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1103 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sl-sp-page', {
    attrs: {
      "data": _vm.info
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1104 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-new-account"
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-form"
  }, [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.label.username
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.username),
      callback: function($$v) {
        _vm.form.username = $$v
      },
      expression: "form.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.name
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.form.name = $$v
      },
      expression: "form.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.password
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.form.password = $$v
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.phone
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.phone),
      callback: function($$v) {
        _vm.form.phone = $$v
      },
      expression: "form.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.email
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.form.email = $$v
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.label.admin
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.form.admin),
      callback: function($$v) {
        _vm.form.admin = $$v
      },
      expression: "form.admin"
    }
  }, [_vm._v(_vm._s(_vm.$tc('Functional.yes', 2)))]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "0"
    },
    model: {
      value: (_vm.form.admin),
      callback: function($$v) {
        _vm.form.admin = $$v
      },
      expression: "form.admin"
    }
  }, [_vm._v(_vm._s(_vm.$tc('Functional.no', 2)))])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success",
      "disabled": _vm.form.username === '' || _vm.form.password === ''
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('Button.save')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "el-button",
      "to": {
        name: 'Accounts'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.$ga.event('Link', 'Cancel', 'Add new account')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Button.cancel')))])], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),
/* 1107 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "invoices"
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-condition"
  }, [_c('row', [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "month",
      "placeholder": _vm.$t('Date.placeholder')
    },
    model: {
      value: (_vm.datePicker),
      callback: function($$v) {
        _vm.datePicker = $$v
      },
      expression: "datePicker"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 sm-margin"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('sl-btn', {
    staticClass: "sl-btn-lightblue",
    attrs: {
      "text": _vm.$t('Functional.confirm')
    },
    nativeOn: {
      "click": function($event) {
        _vm.searchByCondition($event)
      }
    }
  })], 1)])])], 1)])]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "sl-body"
  }, [_c('row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reloadBtn),
      expression: "reloadBtn"
    }],
    staticClass: "sl-table-reload"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('Notify.errorMsg')) + "\n          "), _c('sl-btn', {
    staticClass: "sl-btn-lightblue",
    attrs: {
      "text": _vm.$t('Functional.reload')
    },
    nativeOn: {
      "click": function($event) {
        _vm.reloadTable($event)
      }
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": "200",
      "show-overflow-tooltip": true,
      "prop": "createMonth",
      "label": _vm.$t('Views.Invoices.month'),
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "200",
      "show-overflow-tooltip": true,
      "prop": "amount",
      "label": _vm.$t('Views.Invoices.amount'),
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "200",
      "show-overflow-tooltip": true,
      "prop": "GST",
      "label": _vm.$t('Views.Invoices.gst')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "200",
      "show-overflow-tooltip": true,
      "prop": "totalAmount",
      "label": _vm.$t('Views.Invoices.tAmount')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "200",
      "show-overflow-tooltip": true,
      "prop": "invoiceNo",
      "label": _vm.$t('Views.Invoices.in')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": _vm.$store.state.userAgent.isPhone ? 100 : 200,
      "fixed": "right",
      "label": _vm.$t('Table.actions')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('a', {
          staticClass: "sl-edit",
          attrs: {
            "href": ("/client/invoice/" + (scope.row.invoiceNo)),
            "download": "FileName"
          },
          on: {
            "click": function($event) {
              _vm.$ga.event('Button', 'Download', 'Invoices')
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('Functional.download')))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.reloadBtn),
      expression: "!reloadBtn"
    }],
    attrs: {
      "current-page": _vm.table.page,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.table.per,
      "layout": "prev, pager, next, sizes,jumper,total",
      "total": _vm.table.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nprogress-container"
  })
},staticRenderFns: []}

/***/ }),
/* 1109 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "analytics analytics-transactions"
  }, [_c('row', [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.tabClick
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('Views.Analytics.Transaction.generalStatus'),
      "name": "first"
    }
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-body"
  }, [_c('p', {
    staticClass: "sl-name"
  }, [_vm._v(_vm._s(_vm.$t('Chart.trxAmount')) + " (" + _vm._s(_vm.$store.state.theme.companyInfo.currency) + ")")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.first.statusRadio),
      callback: function($$v) {
        _vm.first.statusRadio = $$v
      },
      expression: "first.statusRadio"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "op1",
      "option": _vm.first.statusOption.week
    },
    nativeOn: {
      "click": function($event) {
        _vm.resetStatusOp('week', 'Recent 7 days')
      }
    }
  }, [_vm._v(_vm._s(_vm.$tc('Date.dateRange', 0)))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "op2",
      "option": _vm.first.statusOption.month
    },
    nativeOn: {
      "click": function($event) {
        _vm.resetStatusOp('month', 'Recent 30 days')
      }
    }
  }, [_vm._v(_vm._s(_vm.$tc('Date.dateRange', 1)))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "op3",
      "option": _vm.first.statusOption.year
    },
    nativeOn: {
      "click": function($event) {
        _vm.resetStatusOp('year', 'Recent 12 months')
      }
    }
  }, [_vm._v(_vm._s(_vm.$tc('Date.dateRange', 2)))])], 1)], 1), _vm._v(" "), _c('chart', {
    ref: "status",
    attrs: {
      "options": _vm.first.statusOption.default,
      "auto-resize": "",
      "theme": "default"
    }
  })], 1)])])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('Views.Analytics.Transaction.byChannel'),
      "name": "second"
    }
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-body"
  }, [_c('p', {
    staticClass: "sl-name"
  }, [_vm._v(_vm._s(_vm.$t('Chart.transactionByChannel')) + " (" + _vm._s(_vm.$store.state.theme.companyInfo.currency) + ")")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.second.channelRadio),
      callback: function($$v) {
        _vm.second.channelRadio = $$v
      },
      expression: "second.channelRadio"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "op1",
      "option": _vm.second.channelOption.week
    },
    nativeOn: {
      "click": function($event) {
        _vm.resetChannelOp('week', 'Recent 7 days')
      }
    }
  }, [_vm._v(_vm._s(_vm.$tc('Date.dateRange', 0)))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "op2",
      "option": _vm.second.channelOption.month
    },
    nativeOn: {
      "click": function($event) {
        _vm.resetChannelOp('month', 'Recent 30 days')
      }
    }
  }, [_vm._v(_vm._s(_vm.$tc('Date.dateRange', 1)))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "op3",
      "option": _vm.second.channelOption.year
    },
    nativeOn: {
      "click": function($event) {
        _vm.resetChannelOp('year', 'Recent 12 months')
      }
    }
  }, [_vm._v(_vm._s(_vm.$tc('Date.dateRange', 2)))])], 1)], 1), _vm._v(" "), _c('chart', {
    ref: "byChannel",
    staticClass: "sl-any-bar",
    attrs: {
      "options": _vm.second.channelOption.default,
      "auto-resize": "",
      "theme": "default"
    }
  })], 1)])])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('Views.Analytics.Transaction.percentage'),
      "name": "third"
    }
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-2"
  }, [_c('div', {
    staticClass: "sl-body"
  }, [_c('p', {
    staticClass: "sl-name"
  }, [_vm._v(_vm._s(_vm.$t('Chart.channelPercentage')))]), _vm._v(" "), _c('chart', {
    ref: "percentageChannel",
    attrs: {
      "options": _vm.third.channelOption,
      "auto-resize": "",
      "theme": "default"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "sl-col-2"
  }, [_c('div', {
    staticClass: "sl-body"
  }, [_c('p', {
    staticClass: "sl-name"
  }, [_vm._v(_vm._s(_vm.$t('Chart.statusPercentage')))]), _vm._v(" "), _c('chart', {
    ref: "percentageStatus",
    attrs: {
      "options": _vm.third.statusOption,
      "auto-resize": "",
      "theme": "default"
    }
  })], 1)])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1110 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outlets"
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-condition"
  }, [_c('row', [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('Placeholder.OutletSearch')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.searchByCondition($event)
      }
    },
    model: {
      value: (_vm.condition.search),
      callback: function($$v) {
        _vm.condition.search = $$v
      },
      expression: "condition.search"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 sm-margin"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('sl-btn', {
    staticClass: "sl-btn-lightblue",
    attrs: {
      "text": _vm.$t('Functional.confirm')
    },
    nativeOn: {
      "click": function($event) {
        _vm.searchByCondition($event)
      }
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "sl-el-btn sl-btn-green",
    attrs: {
      "tag": "el-button",
      "to": {
        name: 'Add-New-Outlet'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.$ga.event('Link', 'Add new store', 'Stores')
      }
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('Button.addNewOutlet')))])], 1)])])], 1)])]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "sl-body"
  }, [_c('row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reloadBtn),
      expression: "reloadBtn"
    }],
    staticClass: "sl-table-reload"
  }, [_vm._v(" " + _vm._s(_vm.$t('Notify.errorMsg')) + "\n          "), _c('sl-btn', {
    staticClass: "sl-btn-lightblue",
    attrs: {
      "text": _vm.$t('Functional.reload')
    },
    nativeOn: {
      "click": function($event) {
        _vm.reloadTable($event)
      }
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": "200",
      "fixed": _vm.$store.state.userAgent.isPhone ? false : 'left',
      "show-overflow-tooltip": true,
      "prop": "name",
      "label": _vm.$t('Views.Outlets.table.name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "200",
      "show-overflow-tooltip": true,
      "prop": "address",
      "label": _vm.$t('Views.Outlets.table.address'),
      "formatter": _vm.formatterAddress
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "200",
      "show-overflow-tooltip": true,
      "prop": "contact",
      "label": _vm.$t('Views.Outlets.table.contact')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "200",
      "show-overflow-tooltip": true,
      "prop": "phone",
      "label": _vm.$t('Views.Outlets.table.phone')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "200",
      "show-overflow-tooltip": true,
      "prop": "status",
      "label": "Approval status",
      "formatter": _vm.formatterStatus
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": _vm.$store.state.userAgent.isPhone ? 150 : 200,
      "fixed": "right",
      "label": _vm.$t('Table.actions')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "sl-edit",
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.edit(scope.row.id)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('Table.edit')))]), _vm._v(" "), _c('el-button', {
          staticClass: "sl-detail",
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.gotoPage(scope.row.id)
            }
          }
        }, [_vm._v(_vm._s(_vm.$tc('Table.view', 1)))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.reloadBtn),
      expression: "!reloadBtn"
    }],
    attrs: {
      "current-page": _vm.table.page,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.table.per,
      "layout": "prev, pager, next, sizes,jumper,total",
      "total": _vm.table.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: this['class']
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1112 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [(_vm.isPhone) ? _c('div', {
    staticClass: "container-table phone",
    style: ({
      height: _vm.contentHeight
    })
  }, [_c('div', {
    staticClass: "bg-img",
    style: ({
      'background-image': ("url(/static/" + (_vm.$store.state.theme.name) + "/phone_login_background.jpg)")
    })
  }, [_c('img', {
    staticClass: "m_logo",
    attrs: {
      "src": ("/static/" + (_vm.$store.state.theme.name) + "/logo_login.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticClass: "input",
    attrs: {
      "placeholder": _vm.$t('Views.Login.id')
    },
    model: {
      value: (_vm.form.id),
      callback: function($$v) {
        _vm.form.id = $$v
      },
      expression: "form.id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticClass: "input password",
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('Views.Login.pwd')
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.form.password = $$v
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "success",
      "loading": _vm.loginLoading
    },
    on: {
      "click": _vm.onLogin
    }
  }, [_vm._v(_vm._s(_vm.loginName))])], 1)], 1)], 1)]) : _c('div', {
    staticClass: "container-table web",
    style: ({
      height: _vm.contentHeight
    })
  }, [_c('div', {
    staticClass: "bg-img",
    style: ({
      'background-image': ("url(/static/" + (_vm.$store.state.theme.name) + "/lgbg.png)")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('img', {
    staticClass: "m_logo",
    attrs: {
      "src": ("/static/" + (_vm.$store.state.theme.name) + "/logo_login.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticClass: "input",
    attrs: {
      "placeholder": _vm.$t('Views.Login.id')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onLogin($event)
      }
    },
    model: {
      value: (_vm.form.id),
      callback: function($$v) {
        _vm.form.id = $$v
      },
      expression: "form.id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    staticClass: "input password",
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('Views.Login.pwd')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.onLogin($event)
      }
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.form.password = $$v
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "success",
      "loading": _vm.loginLoading
    },
    on: {
      "click": _vm.onLogin
    }
  }, [_vm._v(_vm._s(_vm.loginName))])], 1)], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1113 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "sl-header"
  }, [_c('slider-mini', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMiniMenu),
      expression: "showMiniMenu"
    }],
    attrs: {
      "showMiniMenu": _vm.showMiniMenu
    },
    on: {
      "update:showMiniMenu": function($event) {
        _vm.showMiniMenu = $event
      }
    }
  }), _vm._v(" "), (_vm.showMiniMenu) ? _c('div', {
    staticClass: "sl-mini-sidebar-mask",
    on: {
      "click": function($event) {
        _vm.showMiniMenu = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sl-menu-icon",
    on: {
      "click": function($event) {
        _vm.showMiniMenu = true;
        _vm.$ga.event('Button', 'showMiniMenu', 'Navigator')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sl-header-logo"
  }, [_c('img', {
    attrs: {
      "src": ("/static/" + (_vm.$store.state.theme.name) + "/logo_login.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sl-path-title"
  }, [_vm._v(" " + _vm._s(_vm.$store.state.nav.navtitle) + " ")]), _vm._v(" "), _c('el-popover', {
    ref: "setting",
    attrs: {
      "popper-class": "sl-el-pop",
      "placement": "bottom",
      "width": "140",
      "trigger": "click"
    },
    model: {
      value: (_vm.settingPopoverVisible),
      callback: function($$v) {
        _vm.settingPopoverVisible = $$v
      },
      expression: "settingPopoverVisible"
    }
  }, _vm._l((_vm.$store.state.user.setting.children), function(it) {
    return _c('div', {
      staticClass: "sl-setting-item",
      class: {
        'sl-setting-item-active': _vm.$route.path === it.url
      }
    }, [_c('router-link', {
      staticClass: "sl-user-li",
      attrs: {
        "tag": "div",
        "to": {
          path: ("" + (it.url))
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.settingPopoverVisible = false
        }
      }
    }, [_c('i', {
      staticClass: "sl-icon-spot",
      class: {
        'sl-icon-spot-cell': _vm.$store.state.userAgent.isPhone
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(it.name))])])], 1)
  })), _vm._v(" "), _c('el-popover', {
    ref: "user",
    attrs: {
      "popper-class": "sl-el-pop",
      "placement": "bottom",
      "width": "140",
      "trigger": "click"
    }
  }, [_c('div', {
    staticClass: "sl-setting-item"
  }, [_c('div', {
    staticClass: "sl-user-li",
    on: {
      "click": _vm.onSignOut
    }
  }, [_c('i', {
    staticClass: "sl-icon-spot",
    class: {
      'sl-icon-spot-cell': _vm.$store.state.userAgent.isPhone
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Navigator.signOut')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "sl-right-icons"
  }, [_c('ul', [(_vm.$store.state.theme.companyInfo.international) ? _c('li', {
    staticClass: "language",
    on: {
      "click": function($event) {
        _vm.dialogVisible = true;
        _vm.$ga.event('Button', 'Show Change Language Icon', 'Navigator')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "qrcode",
    class: {
      'sl-setting-active': _vm.$route.path === '/settings/qrcode'
    },
    attrs: {
      "to": {
        path: '/settings/qrcode'
      },
      "tag": "li"
    }
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "popover",
      rawName: "v-popover:setting",
      arg: "setting"
    }],
    staticClass: "setting",
    class: {
      'sl-setting-active': _vm.settingActive
    }
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "popover",
      rawName: "v-popover:user",
      arg: "user"
    }],
    staticClass: "user"
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dialogVisible),
      expression: "dialogVisible"
    }],
    staticClass: "sl-mask"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.changeLoading),
      expression: "!changeLoading"
    }],
    staticClass: "sl-lang"
  }, [_c('i', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('p', {
    staticClass: "sl-item",
    class: {
      'sl-lang-active': _vm.$store.state.user.userinfo.lang === 'en'
    },
    attrs: {
      "type": "text",
      "plain": true
    },
    on: {
      "click": function($event) {
        _vm.onChange('en')
      }
    }
  }, [_vm._v("English")]), _vm._v(" "), _c('p', {
    staticClass: "sl-item",
    class: {
      'sl-lang-active': _vm.$store.state.user.userinfo.lang === 'th'
    },
    attrs: {
      "type": "text",
      "plain": true
    },
    on: {
      "click": function($event) {
        _vm.onChange('th')
      }
    }
  }, [_vm._v("ภาษาไทย")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changeLoading),
      expression: "changeLoading"
    }],
    staticClass: "sl-lang"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Navigator.changeLang')))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fullLoading),
      expression: "fullLoading"
    }],
    staticClass: "settlement"
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-condition"
  }, [_c('row', [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "placeholder": _vm.$t('Date.placeholder')
    },
    model: {
      value: (_vm.datePicker),
      callback: function($$v) {
        _vm.datePicker = $$v
      },
      expression: "datePicker"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 sm-margin"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('sl-btn', {
    staticClass: "sl-btn-lightblue",
    attrs: {
      "text": _vm.$t('Functional.confirm')
    },
    nativeOn: {
      "click": function($event) {
        _vm.searchByCondition($event)
      }
    }
  }), _vm._v(" "), _c('sl-btn', {
    staticClass: "sl-btn-lightred",
    attrs: {
      "text": _vm.$t('Functional.clear')
    },
    nativeOn: {
      "click": function($event) {
        _vm.clearSelectors($event)
      }
    }
  })], 1)])])], 1)])]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "sl-body"
  }, [_c('row', {
    staticStyle: {
      "margin-bottom": "10px",
      "position": "relative",
      "left": "19px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "float": "right"
    }
  }, [_c('sl-btn', {
    attrs: {
      "text": _vm.$t('Functional.download'),
      "icon": "sl-download"
    },
    nativeOn: {
      "click": function($event) {
        _vm.download($event)
      }
    }
  })], 1)])]), _vm._v(" "), _c('row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reloadBtn),
      expression: "reloadBtn"
    }],
    staticClass: "sl-table-reload"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('Notify.errorMsg')) + "\n          "), _c('sl-btn', {
    staticClass: "sl-btn-lightblue",
    attrs: {
      "text": _vm.$t('Functional.reload')
    },
    nativeOn: {
      "click": function($event) {
        _vm.reloadTable($event)
      }
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": "200",
      "fixed": _vm.$store.state.userAgent.isPhone ? !true : true,
      "sortable": "custom",
      "show-overflow-tooltip": true,
      "prop": "transferDate",
      "label": _vm.$t('Views.Settlement.table.tDate')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "200",
      "show-overflow-tooltip": true,
      "prop": "amount",
      "label": _vm.$t('Views.Settlement.table.sAmount')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "200",
      "show-overflow-tooltip": true,
      "prop": "uploadTime",
      "label": _vm.$t('Views.Settlement.table.cTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "200",
      "show-overflow-tooltip": true,
      "prop": "status",
      "label": _vm.$t('Views.Settlement.table.sStatus')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "200",
      "show-overflow-tooltip": true,
      "prop": "settleTime",
      "label": _vm.$t('Views.Settlement.table.sTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": _vm.$store.state.userAgent.isPhone ? 100 : 200,
      "fixed": "right",
      "show-overflow-tooltip": true,
      "label": _vm.$t('Table.actions')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "sl-detail",
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.downStatement(scope.row.id)
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('Functional.download')))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.reloadBtn),
      expression: "!reloadBtn"
    }],
    attrs: {
      "current-page": _vm.table.page,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.table.per,
      "layout": " prev, pager, next, sizes,jumper,total",
      "total": _vm.table.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1115 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sl-switcher"
  }, _vm._l((_vm.switchArray), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "sl-btn",
      class: {
        'sl-btn-active': index === _vm.switchActive
      },
      on: {
        "click": function($event) {
          _vm.handleSwitcher(index)
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  }))
},staticRenderFns: []}

/***/ }),
/* 1116 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 1117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sl-sp-page', {
    attrs: {
      "data": _vm.info
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1118 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fullLoading),
      expression: "fullLoading"
    }],
    staticClass: "transactions"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.conditionLoading),
      expression: "conditionLoading"
    }],
    staticStyle: {
      "margin-top": "28px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-left": "28px",
      "padding-right": "10px"
    },
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "col-md2-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('el-select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.condition.outletId),
      callback: function($$v) {
        _vm.condition.outletId = $$v
      },
      expression: "condition.outletId"
    }
  }, _vm._l((_vm.shopOptions), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }))], 1)])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "col-md2-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('el-select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.condition.status),
      callback: function($$v) {
        _vm.condition.status = $$v
      },
      expression: "condition.status"
    }
  }, _vm._l((_vm.statusOptions), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }))], 1)])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "col-md2-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "placeholder": _vm.$t('Date.placeholder')
    },
    model: {
      value: (_vm.datePicker),
      callback: function($$v) {
        _vm.datePicker = $$v
      },
      expression: "datePicker"
    }
  })], 1)])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('Views.Transactions.filter.id')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.searchByCondition($event)
      }
    },
    model: {
      value: (_vm.condition.search),
      callback: function($$v) {
        _vm.condition.search = $$v
      },
      expression: "condition.search"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 sm-margin"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('sl-btn', {
    staticClass: "sl-btn-blue",
    attrs: {
      "text": _vm.$t('Functional.confirm')
    },
    nativeOn: {
      "click": function($event) {
        _vm.searchByCondition($event)
      }
    }
  }), _vm._v(" "), _c('sl-btn', {
    staticClass: "sl-btn-blue",
    attrs: {
      "text": _vm.$t('Functional.clear')
    },
    nativeOn: {
      "click": function($event) {
        _vm.clearSelectors($event)
      }
    }
  })], 1)])])], 1)], 1), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "sl-body"
  }, [_c('row', {
    staticStyle: {
      "margin-bottom": "10px",
      "position": "relative",
      "left": "19px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "float": "right"
    }
  }, [_c('sl-btn', {
    attrs: {
      "text": _vm.$t('Functional.download'),
      "icon": "sl-download"
    },
    nativeOn: {
      "click": function($event) {
        _vm.download($event)
      }
    }
  })], 1)])]), _vm._v(" "), _c('row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reloadBtn),
      expression: "reloadBtn"
    }],
    staticClass: "sl-table-reload"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('Notify.errorMsg')) + "\n          "), _c('sl-btn', {
    staticClass: "sl-btn-lightblue",
    attrs: {
      "text": _vm.$t('Functional.reload')
    },
    nativeOn: {
      "click": function($event) {
        _vm.reloadTable($event)
      }
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "200",
      "fixed": _vm.$store.state.userAgent.isPhone ? !true : true,
      "show-overflow-tooltip": true,
      "prop": "createTime",
      "label": _vm.$t('Views.Transactions.table.date')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatterDate(scope.row)))]), _vm._v(" "), (scope.row.couponCode !== '') ? _c('img', {
          staticStyle: {
            "width": "20px",
            "height": "20px",
            "position": "relative",
            "top": "-1px"
          },
          attrs: {
            "src": "/static/imgs/coupon_icon.png"
          }
        }) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "show-overflow-tooltip": true,
      "prop": "trxId",
      "label": _vm.$t('Views.Transactions.table.id')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "show-overflow-tooltip": true,
      "prop": "amount",
      "label": _vm.$t('Views.Transactions.table.cAmount')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "show-overflow-tooltip": true,
      "prop": "realAmount",
      "label": _vm.$t('Views.Transactions.table.realAmount')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "show-overflow-tooltip": true,
      "prop": "settleAmount",
      "label": _vm.$t('Views.Transactions.table.amount')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "show-overflow-tooltip": true,
      "prop": "status",
      "label": _vm.$t('Views.Transactions.table.status')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "show-overflow-tooltip": true,
      "prop": "customer",
      "label": _vm.$t('Views.Transactions.table.customer')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticStyle: {
            "width": "20px",
            "height": "20px"
          },
          attrs: {
            "src": ("/static/imgs/T-" + (scope.row.channelId) + ".png")
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.customer))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "show-overflow-tooltip": true,
      "prop": "remark",
      "label": _vm.$t('Views.Transactions.table.remark')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "show-overflow-tooltip": true,
      "prop": "outlet",
      "label": _vm.$t('Views.Transactions.table.outlet')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "show-overflow-tooltip": true,
      "prop": "sn",
      "label": _vm.$t('Views.Transactions.table.posID')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "200",
      "show-overflow-tooltip": true,
      "prop": "username",
      "label": _vm.$t('Views.Transactions.table.posUsername')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": _vm.$store.state.userAgent.isPhone ? 100 : 200,
      "fixed": "right",
      "show-overflow-tooltip": true,
      "label": _vm.$t('Table.actions')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "sl-detail",
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.gotoPage(scope.row.id)
            }
          }
        }, [_vm._v(_vm._s(_vm.$tc('Table.view',
          1)))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.reloadBtn),
      expression: "!reloadBtn"
    }],
    attrs: {
      "current-page": _vm.table.page,
      "page-sizes": [5, 10, 20, 50, 100],
      "page-size": _vm.table.per,
      "small": "",
      "layout": " prev, pager, next, sizes,jumper,total",
      "total": _vm.table.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1119 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "sl-show-box"
  }, _vm._l((_vm.data), function(item, index) {
    return _c('sl-box', {
      key: index,
      attrs: {
        "title": item.name,
        "cnt": item.number,
        "index": index
      }
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 1120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "download-contract"
  }, [_c('vue-pdf-viewer', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "download-contract",
    attrs: {
      "url": _vm.src,
      "height": _vm.height
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1121 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sl-mini-page",
    class: [_vm.themeClass],
    attrs: {
      "id": "app"
    }
  }, [_c('nprogress-container'), _vm._v(" "), _c('router-view'), _vm._v(" "), (_vm.$store.state.userAgent.isPhone && _vm.$store.state.user.userinfo !== null && _vm.versions === 'ios') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.popWindow),
      expression: "popWindow"
    }],
    staticClass: "sl-download-app"
  }, [_c('b', {
    on: {
      "click": function($event) {
        _vm.popWindow = false
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _vm._m(0)]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://itunes.apple.com/app/ai-merchant/id1265743674"
    }
  }, [_vm._v("Please download the newest version APP")])])
}]}

/***/ }),
/* 1122 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "payment-channel"
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4 flex"
  }, _vm._l((_vm.open), function(item, index) {
    return _c('div', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (item.loading),
        expression: "item.loading"
      }],
      staticClass: "sl-box"
    }, [_c('div', {
      staticClass: "sl-top"
    }), _vm._v(" "), _c('div', {
      staticClass: "sl-img"
    }, [_c('img', {
      attrs: {
        "src": ("/static/imgs/" + (item.channelId) + ".png"),
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "sl-channel"
    }, [_c('p', {
      staticClass: "sl-name"
    }, [_vm._v(_vm._s(item.channelName))]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.$t('Views.ServiceFee.t')))]), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(item.rate) + "%")])])])]), _vm._v(" "), _c('div', {
      staticClass: "sl-charge"
    }, [_c('span', [_vm._v(_vm._s(_vm.$t('Views.ServiceFee.st')))]), _vm._v(" "), _c('el-switch', {
      attrs: {
        "on-text": "",
        "off-text": "",
        "width": 40
      },
      on: {
        "change": function($event) {
          _vm.OnChargeFee(index)
        }
      },
      model: {
        value: (item.chargeFee),
        callback: function($$v) {
          item.chargeFee = $$v
        },
        expression: "item.chargeFee"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "sl-line"
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.chargeFee),
        expression: "item.chargeFee"
      }],
      staticClass: "sl-rate",
      class: {
        'sl-error': item.error
      }
    }, [_c('span', {
      staticClass: "sl-del"
    }, [_vm._v(_vm._s(_vm.$t('Views.ServiceFee.r')))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.cRate),
        expression: "item.cRate"
      }],
      staticClass: "sl-input",
      attrs: {
        "type": "number",
        "step": "0.1"
      },
      domProps: {
        "value": (item.cRate)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          item.cRate = $event.target.value
        }, function($event) {
          _vm.onInput(index)
        }],
        "change": function($event) {
          _vm.onChange(index)
        },
        "focus": function($event) {
          _vm.onFocus(index)
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), _c('span', [_vm._v("%")])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.chargeFee),
        expression: "!item.chargeFee"
      }],
      staticClass: "sl-rate-dis"
    }, [_vm._v("\n          " + _vm._s(_vm.$t('Views.ServiceFee.mf')) + "\n        ")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.error),
        expression: "item.error"
      }],
      staticClass: "sl-error-msg"
    }, [_c('span', [_vm._v("* " + _vm._s(_vm.$t('Views.ServiceFee.sf')))]), _vm._v(" "), _c('span', [_vm._v("than " + _vm._s(item.maxRate) + " %")])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.save),
        expression: "item.save"
      }],
      staticClass: "sl-btn"
    }, [_c('button', {
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          _vm.cancel(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('Functional.cancel')))]), _vm._v(" "), _c('button', {
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          _vm.confirm(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('Functional.save')))])])])
  }))]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "sl-col-4",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "sl-go-dashboard",
    class: {
      'sl-btn-disable': _vm.nextBtn
    },
    attrs: {
      "disabled": _vm.nextBtn
    },
    on: {
      "click": _vm.gotoDashboard
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.next')))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "sl-mini-sidebar"
  }, [_c('div', {
    staticClass: "sl-username"
  }, [_c('span', [_vm._v(_vm._s(_vm.$store.state.user.userinfo.merchantName))]), _vm._v(" "), _c('div', {
    staticClass: "sl-menu-close-icon",
    on: {
      "click": _vm.hideMenu
    }
  })]), _vm._v(" "), _c('el-menu', {
    attrs: {
      "default-active": _vm.currentPage,
      "unique-opened": true,
      "router": true
    },
    on: {
      "select": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_vm._l((_vm.slider), function(item, index) {
    return [(item.menu === '/coupons') ? _c('div', {
      staticClass: "sl-sidebar-border"
    }) : _vm._e(), _vm._v(" "), (item.children.length === 0) ? _c('el-menu-item', {
      attrs: {
        "index": item.url
      }
    }, [_c('div', {
      staticStyle: {
        "height": "20px",
        "line-height": "20px",
        "display": "inline-block"
      }
    }, [_c('i', {
      class: item.icon,
      staticStyle: {
        "margin-right": "5px"
      }
    }), _vm._v(_vm._s(item.name) + "\n        ")])]) : _vm._e(), _vm._v(" "), (item.menu === '/dashboard') ? _c('div', {
      staticClass: "sl-sidebar-border"
    }) : _vm._e(), _vm._v(" "), (item.menu === '/coupons') ? _c('div', {
      staticClass: "sl-sidebar-border"
    }) : _vm._e(), _vm._v(" "), (item.children.length !== 0) ? _c('el-submenu', {
      attrs: {
        "index": index.toString()
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('div', {
      staticStyle: {
        "height": "20px",
        "line-height": "20px",
        "display": "inline-block"
      }
    }, [_c('i', {
      class: item.icon,
      staticStyle: {
        "margin-right": "5px"
      }
    }), _vm._v(_vm._s(item.name) + "\n          ")])]), _vm._v(" "), _vm._l((item.children), function(it, i) {
      return _c('el-menu-item', {
        attrs: {
          "index": it.url
        }
      }, [_c('div', {
        staticStyle: {
          "height": "20px",
          "line-height": "20px",
          "display": "inline-block"
        }
      }, [_c('i', {
        staticClass: "fa fa-crosshairs",
        staticStyle: {
          "margin-right": "5px"
        }
      }), _vm._v(_vm._s(it.name) + "\n          ")])])
    })], 2) : _vm._e()]
  })], 2), _vm._v(" "), (!_vm.$store.state.userAgent.isPhone) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "sl-sidebar-app"
  }, [_c('img', {
    staticClass: "sidebar-logo",
    attrs: {
      "src": ("/static/" + (this.$store.state.theme.name) + "/sidebar-logo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "name-app"
  }, [_vm._v(_vm._s(_vm.$t('Navigator.appName')))]), _vm._v(" "), _c('img', {
    staticClass: "qrcode-app",
    attrs: {
      "src": __webpack_require__(211),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "category-app"
  }, [_vm._v("iOS & Android")])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1124 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.styleObject)
  })
},staticRenderFns: []}

/***/ }),
/* 1125 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "echarts"
  })
},staticRenderFns: []}

/***/ }),
/* 1126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sl-sp-page",
    style: ({
      'top': _vm.top
    })
  }, [_c('div', {
    staticClass: "sl-bg"
  }, [_vm._v(_vm._s(_vm.data.title))]), _vm._v(" "), _c('div', {
    staticClass: "sl-cnt"
  }, [_c('p', [_vm._v(_vm._s(_vm.data.cnt1))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.data.cnt2))])]), _vm._v(" "), _c('div', {
    staticClass: "sl-btn"
  }, [(_vm.data.showBtn1) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_vm._v(_vm._s(_vm.data.btn1))]) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'Dashboard'
      },
      "tag": "a"
    }
  }, [_vm._v(_vm._s(_vm.data.btn2))])], 1)])
},staticRenderFns: []}

/***/ }),
/* 1127 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "analytics analytics-outlets"
  }, [_c('row', [_c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.tabClick
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('Views.Analytics.Store.trx'),
      "name": "first"
    }
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-body"
  }, [_c('p', {
    staticClass: "sl-name"
  }, [_vm._v(_vm._s(_vm.$t('Chart.outletPerChannel')))]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.first.channelRadio),
      callback: function($$v) {
        _vm.first.channelRadio = $$v
      },
      expression: "first.channelRadio"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "op0",
      "option": _vm.first.channelOption.today
    },
    nativeOn: {
      "click": function($event) {
        _vm.resetPerChannelOption("today", 'Today')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Date.today')))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "op1",
      "option": _vm.first.channelOption.week
    },
    nativeOn: {
      "click": function($event) {
        _vm.resetPerChannelOption("week", 'Recent 7 days')
      }
    }
  }, [_vm._v(_vm._s(_vm.$tc('Date.dateRange', 0)))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "op2",
      "option": _vm.first.channelOption.month
    },
    nativeOn: {
      "click": function($event) {
        _vm.resetPerChannelOption("month", 'Recent 30 days')
      }
    }
  }, [_vm._v(_vm._s(_vm.$tc('Date.dateRange', 1)))]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "op3",
      "option": _vm.first.channelOption.year
    },
    nativeOn: {
      "click": function($event) {
        _vm.resetPerChannelOption("year", 'Recent 12 months')
      }
    }
  }, [_vm._v(_vm._s(_vm.$tc('Date.dateRange', 2)))])], 1)], 1), _vm._v(" "), _c('chart', {
    ref: "perChannel",
    attrs: {
      "options": _vm.first.channelOption.default,
      "auto-resize": "",
      "theme": "default"
    }
  })], 1)])])], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('Views.Analytics.Store.percent'),
      "name": "second"
    }
  }, [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-body"
  }, [_c('p', {
    staticClass: "sl-name"
  }, [_vm._v(_vm._s(_vm.$t('Chart.transactionsByOutlet')))]), _vm._v(" "), _c('chart', {
    ref: "percentageTransactions",
    staticClass: "sl-chart-bar",
    attrs: {
      "options": _vm.second.transactionsOption,
      "auto-resize": "",
      "theme": "default"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-body"
  }, [_c('p', {
    staticClass: "sl-name"
  }, [_vm._v(_vm._s(_vm.$t('Chart.RefundByOutlet')))]), _vm._v(" "), _c('chart', {
    ref: "percentageRefund",
    staticClass: "sl-chart-bar",
    attrs: {
      "options": _vm.second.refundOption,
      "auto-resize": "",
      "theme": "default"
    }
  })], 1)])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1128 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard grid-container"
  }, [_c('div', {
    staticClass: "dashboard-header"
  }, [_c('sl-switcher'), _vm._v(" "), _c('div', {
    staticClass: "sl-btn-list"
  }, [(_vm.$store.state.user.userinfo.roleId === '2') ? _c('router-link', {
    staticClass: "sl-el-btn sl-btn-green",
    attrs: {
      "tag": "el-button",
      "to": {
        name: 'Choose-Coupon'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.$ga.event('Link', '+ Create New Coupon', 'Dashboard')
      }
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('Views.Coupons.CNC')))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dashboard-stats"
  }, [_c('sl-show-box', {
    attrs: {
      "data": _vm.box
    }
  })], 1), _vm._v(" "), _c('el-card', {
    staticClass: "dashboard-chart",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    slot: "header"
  }, [_c('span', {
    staticClass: "sl-name"
  }, [_vm._v(_vm._s(_vm.$t('Chart.revenue')) + " (" + _vm._s(_vm.$store.state.theme.companyInfo.currency) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "sl-body"
  }, [_c('chart', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.rLoading),
      expression: "rLoading"
    }],
    ref: "revenue",
    attrs: {
      "options": _vm.revenueConfig.default,
      "auto-resize": "",
      "theme": "default"
    }
  })], 1)]), _vm._v(" "), _c('el-card', {
    staticClass: "dashboard-chart",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    slot: "header"
  }, [_c('span', {
    staticClass: "sl-name"
  }, [_vm._v(_vm._s(_vm.$t('Chart.numberOfOrder')))])]), _vm._v(" "), _c('div', {
    staticClass: "sl-body"
  }, [_c('chart', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.nooLoading),
      expression: "nooLoading"
    }],
    ref: "order",
    attrs: {
      "options": _vm.orderConfig.default,
      "auto-resize": "",
      "theme": "default"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.newUser),
      expression: "newUser"
    }],
    staticClass: "sl-mask"
  }, [_c('div', {
    staticClass: "sl-block-welcome"
  }, [_c('p', {
    staticClass: "sl-title"
  }, [_vm._v(_vm._s(_vm.$t('Views.Dashboard.welTitle')))]), _vm._v(" "), _c('p', {
    staticClass: "sl-cnt"
  }, [_vm._v(_vm._s(_vm.$t('Views.Dashboard.welCnt')))]), _vm._v(" "), _c('div', {
    staticClass: "sl-btn",
    on: {
      "click": _vm.goDashboard
    }
  }, [_vm._v(_vm._s(_vm.$store.state.theme.companyInfo.welcome))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sl-a-download sl-el-btn el-button el-icon-sl-download",
    attrs: {
      "href": _vm.href,
      "download": ""
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}

/***/ }),
/* 1130 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fullLoading),
      expression: "fullLoading"
    }],
    staticClass: "refunds",
    staticStyle: {
      "margin-top": "28px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-left": "28px",
      "padding-right": "10px"
    },
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "col-md2-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('Views.Refund.filter.trxId')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.searchByCondition($event)
      }
    },
    model: {
      value: (_vm.condition.trxId),
      callback: function($$v) {
        _vm.condition.trxId = $$v
      },
      expression: "condition.trxId"
    }
  })], 1)])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "col-md2-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('Views.Refund.filter.customer')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.searchByCondition($event)
      }
    },
    model: {
      value: (_vm.condition.customer),
      callback: function($$v) {
        _vm.condition.customer = $$v
      },
      expression: "condition.customer"
    }
  })], 1)])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "col-md2-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "placeholder": _vm.$t('Date.placeholder')
    },
    model: {
      value: (_vm.datePicker),
      callback: function($$v) {
        _vm.datePicker = $$v
      },
      expression: "datePicker"
    }
  })], 1)])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "col-md2-6 sm-margin"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('sl-btn', {
    staticClass: "sl-btn-blue",
    attrs: {
      "text": _vm.$t('Functional.confirm')
    },
    nativeOn: {
      "click": function($event) {
        _vm.searchByCondition($event)
      }
    }
  }), _vm._v(" "), _c('sl-btn', {
    staticClass: "sl-btn-blue",
    attrs: {
      "text": _vm.$t('Functional.clear')
    },
    nativeOn: {
      "click": function($event) {
        _vm.clearSelectors($event)
      }
    }
  }), _vm._v(" "), (!_vm.ContactBlockShow) ? _c('sl-btn', {
    attrs: {
      "text": _vm.$t('Views.Refund.button.refund'),
      "icon": "sl-pending_refund",
      "disabled": !_vm.ContactBlockShow
    }
  }) : _c('sl-btn', {
    attrs: {
      "text": _vm.$t('Views.Refund.button.refund'),
      "icon": "sl-pending_refund"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onRefundDetail($event)
      }
    }
  })], 1)])])], 1), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "sl-body"
  }, [_c('row', {
    staticStyle: {
      "margin-bottom": "10px",
      "position": "relative",
      "left": "19px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "float": "right"
    }
  }, [_c('sl-btn', {
    attrs: {
      "text": _vm.$t('Functional.download'),
      "icon": "sl-download"
    },
    nativeOn: {
      "click": function($event) {
        _vm.download($event)
      }
    }
  })], 1)])]), _vm._v(" "), _c('row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reloadBtn),
      expression: "reloadBtn"
    }],
    staticClass: "sl-table-reload"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('Notify.errorMsg')) + "\n            "), _c('sl-btn', {
    staticClass: "sl-btn-lightblue",
    attrs: {
      "text": _vm.$t('Functional.reload')
    },
    nativeOn: {
      "click": function($event) {
        _vm.reloadTable($event)
      }
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "sort-change": _vm.handleSortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "min-width": "200",
      "fixed": _vm.$store.state.userAgent.isPhone ? !true : true,
      "show-overflow-tooltip": true,
      "prop": "refundTime",
      "label": _vm.$t('Views.Refund.table.rTime'),
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "200",
      "show-overflow-tooltip": true,
      "prop": "trxId",
      "label": _vm.$t('Views.Refund.table.trxId'),
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "200",
      "show-overflow-tooltip": true,
      "prop": "refundAmount",
      "label": _vm.$t('Views.Refund.table.rAmount'),
      "sortable": "custom"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "200",
      "show-overflow-tooltip": true,
      "prop": "status",
      "label": _vm.$t('Views.Refund.table.rStatus')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "200",
      "show-overflow-tooltip": true,
      "prop": "customer",
      "label": _vm.$t('Views.Refund.table.customer')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticStyle: {
            "width": "20px",
            "height": "20px"
          },
          attrs: {
            "src": ("/static/imgs/T-" + (scope.row.channelId) + ".png"),
            "alt": ""
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.customer))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "200",
      "show-overflow-tooltip": true,
      "prop": "description",
      "label": _vm.$t('Views.Refund.table.remark')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "200",
      "show-overflow-tooltip": true,
      "prop": "outlet",
      "label": _vm.$t('Views.Refund.table.store')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": "200",
      "show-overflow-tooltip": true,
      "prop": "POSId",
      "label": _vm.$t('Views.Refund.table.posId')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "min-width": _vm.$store.state.userAgent.isPhone ? 100 : 200,
      "fixed": "right",
      "show-overflow-tooltip": true,
      "label": _vm.$t('Table.actions')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticClass: "sl-detail",
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.gotoPage(scope.row.id)
            }
          }
        }, [_vm._v(_vm._s(_vm.$tc('Table.view', 1)))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.reloadBtn),
      expression: "!reloadBtn"
    }],
    attrs: {
      "small": "",
      "current-page": _vm.table.page,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.table.per,
      "layout": " prev, pager, next, sizes,jumper, total",
      "total": _vm.table.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ContactBlock),
      expression: "ContactBlock"
    }],
    staticClass: "sl-mask-confirm"
  }, [_c('div', {
    staticClass: "sl-block-contact"
  }, [_c('i', {
    staticClass: "sl-block-icon",
    on: {
      "click": function($event) {
        _vm.ContactBlock = false
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('p', {
    staticClass: "sl-block-title",
    staticStyle: {
      "padding-bottom": "10px"
    }
  }, [_vm._v(_vm._s(_vm.$t('Views.Refund.mask.title')))]), _vm._v(" "), _c('p', {
    staticClass: "sl-contact-cnt"
  }, [_vm._v(_vm._s(_vm.$t('Views.Refund.mask.name')) + ":\n          "), _c('strong', [_vm._v(_vm._s(_vm.tips.agencyName))])]), _vm._v(" "), _c('p', {
    staticClass: "sl-contact-cnt"
  }, [_vm._v(_vm._s(_vm.$t('Views.Refund.mask.amount')) + ":\n          "), _c('strong', [_vm._v("$" + _vm._s(_vm.tips.refundTotal))])]), _vm._v(" "), _c('p', {
    staticClass: "sl-contact-cnt"
  }, [_vm._v(_vm._s(_vm.$t('Views.Refund.mask.cnt')))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1131 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "outlet-detail"
  }, [_c('row', [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fullLoading),
      expression: "fullLoading"
    }],
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-form"
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.label.name) + ":")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.form.name))])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.label.country) + ":")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.form.country))])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.label.state) + ":")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.form.state))])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.label.city) + ":")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.form.city))])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.label.place) + ":")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.form.address1) + " " + _vm._s(_vm.form.address2))])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.label.lat) + ":")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.form.lat))])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.label.lng) + ":")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.form.lng))])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.label.contact) + ":")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.form.contact))])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.label.phone) + ":")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.form.phone))])]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('Views.ViewOutletDetail.table.pt')) + ":")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "280px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Views.ViewOutletDetail.table.p1')))]), _vm._v(" "), (_vm.form.insidePics !== '') ? _c('img', {
    staticClass: "shop-avatar",
    attrs: {
      "src": _vm.form.insidePics
    }
  }) : _c('i', {
    staticClass: "el-icon-plus shop-uploader-icon"
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "xs": 24
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Views.ViewOutletDetail.table.p2')))]), _vm._v(" "), (_vm.form.outsidePics !== '') ? _c('img', {
    staticClass: "shop-avatar",
    attrs: {
      "src": _vm.form.outsidePics
    }
  }) : _c('i', {
    staticClass: "el-icon-plus shop-uploader-icon"
  })])], 1), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('Views.AddNewOutlet.form.activeTime')) + ":")]), _vm._v(" "), _vm._l((_vm.weeks), function(item) {
    return _c('el-row', {
      key: item,
      staticClass: "sl-form-box-week"
    }, [_c('el-col', {
      staticClass: "week-name",
      attrs: {
        "span": 4,
        "xs": 12
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 20,
        "xs": 12
      }
    }, [_c('el-input', {
      attrs: {
        "auto-complete": "off",
        "disabled": true
      },
      model: {
        value: (item.value),
        callback: function($$v) {
          item.value = $$v
        },
        expression: "item.value"
      }
    })], 1)], 1)
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "el-button",
      "to": {
        name: 'Outlets'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.$ga.event('Link', 'Back', 'View store detail')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.back')))])], 2)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('Slider'), _vm._v(" "), _c('NaviBar'), _vm._v(" "), _c('ContentWrap', {
    staticClass: "sl-ml sl-full"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-coupon sl-coupon"
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-coupon-form"
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('i', {
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("< " + _vm._s(_vm.$t('Views.AddCoupon.type')))]), _vm._v(_vm._s(_vm.$route.query.name))]), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form,
      "label-width": "100px"
    }
  }, [(_vm.$route.query.id === '1') ? _c('el-form-item', {
    staticClass: "form-font",
    attrs: {
      "label": _vm.$t('Views.AddCoupon.f1'),
      "prop": "discount"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$tc('Views.AddCoupon.t1f1', 1)))]), _vm._v(" "), _c('el-input', {
    class: {
      'sl-input-danger': _vm.form.discount === '' || _vm.showErr
    },
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number",
      "auto-complete": "off",
      "maxlength": _vm.maxlength
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.form.discount),
      callback: function($$v) {
        _vm.form.discount = _vm._n($$v)
      },
      expression: "form.discount"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("%")])], 2), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$tc('Views.AddCoupon.t1f1', 2)))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showErr),
      expression: "showErr"
    }],
    staticClass: "sl-cp-error"
  }, [_vm._v(_vm._s(_vm.errorMsg))])], 1) : (_vm.$route.query.id === '2') ? _c('el-form-item', {
    staticClass: "form-font",
    attrs: {
      "label": _vm.$t('Views.AddCoupon.f1'),
      "prop": "discount"
    }
  }, [_c('el-input', {
    class: {
      'sl-input-danger': _vm.form.discountPrice === '' || _vm.showErr
    },
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number",
      "auto-complete": "off"
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.form.discountPrice),
      callback: function($$v) {
        _vm.form.discountPrice = _vm._n($$v)
      },
      expression: "form.discountPrice"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v(_vm._s(_vm.$store.state.theme.companyInfo.currency))])], 2), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$tc('Views.AddCoupon.t2f1', 1)))]), _vm._v(" "), _c('el-input', {
    class: {
      'sl-input-danger': _vm.form.minSpending === '' || _vm.showErr
    },
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "number",
      "auto-complete": "off"
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.form.minSpending),
      callback: function($$v) {
        _vm.form.minSpending = _vm._n($$v)
      },
      expression: "form.minSpending"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v(_vm._s(_vm.$store.state.theme.companyInfo.currency))])], 2), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$tc('Views.AddCoupon.t2f1', 2)))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showErr),
      expression: "showErr"
    }],
    staticClass: "sl-cp-error"
  }, [_vm._v(_vm._s(_vm.errorMsg))])], 1) : (_vm.$route.query.id === '3') ? _c('el-form-item', {
    staticClass: "form-font",
    attrs: {
      "label": _vm.$t('Views.AddCoupon.f1'),
      "prop": "discount"
    }
  }, [_c('el-input', {
    class: {
      'sl-input-danger': _vm.form.discount === '' || _vm.showErr
    },
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number",
      "auto-complete": "off"
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.form.discount),
      callback: function($$v) {
        _vm.form.discount = _vm._n($$v)
      },
      expression: "form.discount"
    }
  }, [_c('template', {
    slot: "append"
  }, [_vm._v("%")])], 2), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$tc('Views.AddCoupon.t2f1', 1)))]), _vm._v(" "), _c('el-input', {
    class: {
      'sl-input-danger': _vm.form.minSpending === '' || _vm.showErr
    },
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number",
      "auto-complete": "off"
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.form.minSpending),
      callback: function($$v) {
        _vm.form.minSpending = _vm._n($$v)
      },
      expression: "form.minSpending"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v(_vm._s(_vm.$store.state.theme.companyInfo.currency))])], 2), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$tc('Views.AddCoupon.t2f1', 2)))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showErr),
      expression: "showErr"
    }],
    staticClass: "sl-cp-error"
  }, [_vm._v(_vm._s(_vm.errorMsg))])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('Views.AddCoupon.f2'),
      "prop": "name"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "filterable": "",
      "placeholder": _vm.$t('Views.AddCoupon.placeholder')
    },
    model: {
      value: (_vm.form.nameId),
      callback: function($$v) {
        _vm.form.nameId = $$v
      },
      expression: "form.nameId"
    }
  }, _vm._l((_vm.CouponOP), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-font",
    attrs: {
      "label": _vm.$t('Views.AddCoupon.f3'),
      "prop": "age"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.month),
      callback: function($$v) {
        _vm.form.month = $$v
      },
      expression: "form.month"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v(_vm._s(_vm.$tc('Views.AddCoupon.month', 1)))]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "3"
    }
  }, [_vm._v(_vm._s(_vm.$tc('Views.AddCoupon.month', 2)))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "rules"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Views.AddCoupon.rules')))]), _vm._v(" "), _c('ul', _vm._l((_vm.rules), function(item) {
    return _c('li', [_vm._v(_vm._s(item) + ".")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "btn-list"
  }, [_c('el-button', {
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success",
      "disabled": _vm.btnDisabled
    },
    on: {
      "click": _vm.handlePublish
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.publish')))])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "use"
  })])], 1)], 1)])]), _vm._v(" "), _c('el-dialog', {
    model: {
      value: (_vm.couponDialog),
      callback: function($$v) {
        _vm.couponDialog = $$v
      },
      expression: "couponDialog"
    }
  }, [_c('p', {
    staticClass: "coupon-name"
  }, [_vm._v(_vm._s(_vm.r1))]), _vm._v(" "), _c('p', {
    staticClass: "coupon-time"
  }, [_vm._v(_vm._s(_vm.time))]), _vm._v(" "), _c('img', {
    staticClass: "coupon-img",
    attrs: {
      "src": __webpack_require__(211),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('Views.AddCoupon.tip')))]), _vm._v(" "), _c('el-button', {
    staticClass: "coupon-btn",
    on: {
      "click": function($event) {
        _vm.couponDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.cancel')))]), _vm._v(" "), _c('el-button', {
    staticClass: "coupon-btn",
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "click": _vm.publish
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.confirm')))])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fullLoading),
      expression: "fullLoading"
    }],
    staticClass: "sl-qrcode"
  }, [_c('row', [_c('div', {
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-form"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Views.QrCode.title')))]), _vm._v(" "), _c('div', {
    staticClass: "sl-merchant-qrcode"
  }, _vm._l((_vm.qrcodeData), function(item) {
    return _c('div', {
      staticClass: "sl-qrimg"
    }, [_c('img', {
      attrs: {
        "src": item,
        "alt": ""
      }
    }), _vm._v(" "), _c('sl-a', {
      staticClass: "sl-el-btn el-button",
      attrs: {
        "href": item,
        "text": _vm.$t('Views.QrCode.download')
      },
      nativeOn: {
        "click": function($event) {
          _vm.$ga.event('Button', 'Download', 'QrCode')
        }
      }
    })], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "sl-store-qrcode"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Views.QrCode.storeTitle')))]), _vm._v(" "), _c('div', {
    staticClass: "sl-store-qrcode-checkbox"
  }, [_c('el-checkbox-group', {
    staticClass: "sl-checkbox-group",
    on: {
      "change": _vm.handleCheckedCitiesChange
    },
    model: {
      value: (_vm.checkedBoxes),
      callback: function($$v) {
        _vm.checkedBoxes = $$v
      },
      expression: "checkedBoxes"
    }
  }, _vm._l((_vm.stores), function(item) {
    return _c('el-checkbox', {
      key: item.storeId,
      attrs: {
        "label": item.storeId
      }
    }, [_c('span', [_vm._v(_vm._s(item.storeName))]), _vm._v(" "), _c('el-tooltip', {
      attrs: {
        "placement": "bottom",
        "effect": "light"
      }
    }, [_c('img', {
      staticClass: "sl-hover-qrcode",
      attrs: {
        "src": item.qrcodeUrl,
        "alt": ""
      },
      slot: "content"
    }), _vm._v(" "), _c('img', {
      staticClass: "sl-mini-qrcode",
      attrs: {
        "src": __webpack_require__(1014),
        "alt": ""
      }
    })])], 1)
  })), _vm._v(" "), _c('el-checkbox', {
    staticClass: "sl-select-all",
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  }, [_vm._v("Select all")]), _vm._v(" "), _c('sl-btn', {
    attrs: {
      "text": _vm.$t('Functional.download'),
      "icon": "sl-download"
    },
    nativeOn: {
      "click": function($event) {
        _vm.checkDownload($event)
      }
    }
  })], 1)])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */
/***/ (function(module, exports) {

module.exports = {
	"Notify": {
		"err": "Error",
		"errorMsg": "Net error. Please try again later",
		"suc": "Successful"
	},
	"Navigator": {
		"profile": "Profile",
		"signOut": "Sign out",
		"signIn": "Sign in",
		"signOutTips": "Are you sure?",
		"tip": "Tips",
		"cancel": "Cancel",
		"confirm": "Confirm",
		"lang": "Language",
		"changeLang": "Switching language",
		"appName": "AI Merchant"
	},
	"Functional": {
		"save": "Save",
		"cancel": "Cancel",
		"confirm": "Confirm",
		"publish": "Publish",
		"clear": "Clear All",
		"download": "Download",
		"upload": "Upload device",
		"next": "Next",
		"back": "Back",
		"help": "Help",
		"on": "On | ON",
		"off": "Off | OFF",
		"create": "Create",
		"delete": "Delete",
		"all": "All | All Stores | All Status | All Types | Select All",
		"comingSoon": "Coming Soon.",
		"controlPanel": "Control panel",
		"more": "More | More Info",
		"yes": "Yes | YES",
		"no": "No | NO",
		"reload": "Reload"
	},
	"Date": {
		"dateRange": "Recent 7 days | Recent 30 days | Recent 12 months",
		"today": "Today",
		"openTime": "Open time",
		"closeTime": "Close time",
		"placeholder": "Please choose date range"
	},
	"Chart": {
		"numberOfCustomers": "Number of customers",
		"numberOfOrder": "Number of orders",
		"arpcByOutlet": "ARPC by store",
		"revenue": "Revenue",
		"trxAmount": "Transaction amount",
		"transactionByChannel": "Transaction by channel",
		"channelPercentage": "Channel percentage",
		"outletPercentage": "Store percentage",
		"statusPercentage": "Status percentage",
		"customerGrowthChart": "Customers growth chart",
		"newCustomers": "New customers",
		"retention": "Retention",
		"customerCategories": "Customer categories",
		"customerStatus": "Customer Status",
		"customerFrequency": "Customer frequency",
		"customerContribution": "Customer contribution",
		"arpcByGender": "ARPC by Gender",
		"arpcByProduct": "ARPC by Product",
		"outletPerChannel": "Per channel",
		"transactionsByOutlet": "Transactions by store",
		"RefundByOutlet": "Refund by store",
		"ReversalByOutlet": "Reversal by store"
	},
	"Tab": {
		"generalStatus": "General status",
		"byChannel": "By channel",
		"percentage": "Percentage",
		"newCustomers": "New customers",
		"customerCategories": "Customer categories",
		"arpc": "Average revenue per customer(ARPC)",
		"customerMap": "Customer map",
		"transactions": "Transactions",
		"outletPercentage": "Percentage"
	},
	"Button": {
		"createNewCoupon": "+ Create new coupon",
		"addNewOutlet": "Add new store",
		"chooseCouponTemplate": "Choose Coupon Template",
		"backToTemplate": "Back to template selection",
		"saveCoupon": "Save coupon",
		"save": "Save",
		"cancel": "Cancel",
		"delete": "Delete",
		"refund": "Refund"
	},
	"Placeholder": {
		"TableSearch": "Please type id",
		"OutletSearch": "Store name , Address , Contact person , Mobile number",
		"AccountSearch": "Username , Name , Mobile number , Email"
	},
	"Step": {
		"Coupons": "CHOOSE COUNTRIES | CHOOSE TEMPLATE | EDIT COUPONS | CHOOSE STORES"
	},
	"Country": {
		"title": "Choose coupons distribution countries",
		"China": "China",
		"Australia": "Australia",
		"Indonesia": "Indonesia",
		"Malaysia": "Malaysia",
		"Singapore": "Singapre",
		"SouthKorea": "South Korea",
		"Thailand": "Thailand"
	},
	"Week": {
		"sunday": "Sunday",
		"monday": "Monday",
		"tuesday": "Tuesday",
		"wednesday": "Wednesday",
		"thursday": "Thursday",
		"friday": "Friday",
		"saturday": "Saturday"
	},
	"Table": {
		"id": "ID",
		"actions": "Actions",
		"view": "View | Detail | Details",
		"stop": "Stop",
		"update": "Update",
		"publish": "Publish",
		"upgrade": "Upgrade",
		"edit": "Edit",
		"resetPassword": "Reset Password",
		"permissions": "Permissions"
	},
	"Views": {
		"401": {
			"title": "401",
			"cnt1": "Sorry!",
			"cnt2": "You have no access rights",
			"btn1": "",
			"btn2": "Go to Dashboard"
		},
		"404": {
			"title": "404",
			"cnt1": "Sorry",
			"cnt2": "The page could not be found",
			"btn1": "Back to prev",
			"btn2": "Go to Dashboard"
		},
		"500": {
			"title": "500",
			"cnt1": "Sorry!",
			"cnt2": "The service is temporarily unresponsive",
			"btn1": "Refresh",
			"btn2": "Go to Dashboard"
		},
		"Login": {
			"msg": "Please type your name and password again.",
			"login": "Login",
			"loading": "Loading",
			"id": "ID",
			"pwd": "Password",
			"captcha": "Captcha"
		},
		"Dashboard": {
			"welTitle": "Congratulations! You have successfully activate your account!",
			"welCnt": "You can download the QR code via merchant portal. Related marketing materials and QR code will be delivered to your store within 3-5 working days."
		},
		"Transactions": {
			"filter": {
				"id": "Please type Transaction ID",
				"mid": "Please type Merchant ID",
				"mname": "Please type Merchant name"
			},
			"table": {
				"id": "Transaction ID",
				"date": "Transaction time",
				"amount": "Settlement amount",
				"realAmount": "Total amount",
				"status": "Payment status",
				"outlet": "Store",
				"posID": "POS ID",
				"remark": "Remark",
				"cAmount": "Order amount",
				"customer": "Customer",
				"posUsername": "POS Username"
			},
			"downloadFileName": "transaction"
		},
		"TrxViewDeital": {
			"table": {
				"id": "ID",
				"outletId": "Store ID",
				"merchantId": "Merchant ID",
				"trxId": "Transaction ID",
				"settleAmount": "Settlement amount",
				"realAmount": "Total amount",
				"currency": "Currency",
				"createTime": "Create time",
				"createLocalTime": "Create local time",
				"deviceId": "Device ID",
				"status": "Status",
				"subType": "Sub Type",
				"remark": "Remark",
				"payTrxId": "Pay transaction ID",
				"payChannel": "Payment channel",
				"customer": "Customer",
				"fee": "Customer service fee",
				"customerAmount": "Order amount",
				"settleTime": "Settlement time",
				"refundRecord": "Refund record",
				"refundStatus": "Refund status",
				"requestForRefund": "Request for refund",
				"refunded": "Refunded",
				"refundFailed": "Refunded failed",
				"appTime": "Application time",
				"completeTime": "Completed time",
				"refundAmount": "Refunded amount",
				"refund": "Refund",
				"refundAbleAmount": "Refundable amount",
				"finalAmount": "Final amount",
				"cRate": "Customer rate",
				"mRate": "Merchant rate",
				"discount": "Discount",
				"t1": "Basic Information",
				"posId": "POS ID",
				"cashier": "Cashier Username"
			},
			"tips": {
				"title": "Refund",
				"cnt": "This refund request cannot be cancelled. Are you sure to proceed?",
				"placeholder": "Refund password"
			},
			"transferNameList": "0 | Transfer Pending | Transfer Completed | Transfer Failed"
		},
		"Refund": {
			"table": {
				"rTime": "Refund time",
				"trxId": "Transaction ID",
				"rAmount": "Refunded amount",
				"rStatus": "Refund status",
				"customer": "Customer",
				"remark": "Remark",
				"store": "Store",
				"posId": "Pos ID"
			},
			"filter": {
				"trxId": "Transaction ID",
				"customer": "Customer"
			},
			"button": {
				"refund": "Pending refunds"
			},
			"mask": {
				"title": "Pending refunded amount",
				"name": "Agency name",
				"amount": "Amount",
				"cnt": "Your settlement has been suspended. Please transfer the above amount to the agency as soon as possible to resume the settlement."
			},
			"downloadFileName": "refunds"
		},
		"RefundDetail": {
			"form": {
				"trxId": "Transaction ID",
				"cTime": "Application time",
				"ptId": "Pay Transaction ID",
				"pType": "Payment type",
				"customer": "Customer",
				"fee": "Customer service fee",
				"rAmount": "RefundAmount",
				"settled": "To be settled",
				"sTime": "Settlement time",
				"rComplete": "Refund status",
				"completeTime": "Completed time",
				"failedTime": "Failed time"
			}
		},
		"Customers": {
			"checkbox": {
				"all": "All",
				"customerCategorization": "Customer Categorization",
				"activeCustomers": "Active customers | Inactive customers | Lost customers",
				"frequencyCustomers": "High frequency customers | Mid frequency customers | Low frequency customers",
				"contributionCustomers": "High contribution customers | Mid contribution customers | Low contribution customers"
			},
			"table": {
				"id": "ID",
				"name": "Name",
				"mobile": "Mobile number",
				"gender": "Gender",
				"joinDate": "Join date",
				"totalSpending": "Total spending",
				"lastVisitDate": "Last visit date",
				"averageSpending": "Average spending"
			}
		},
		"Coupons": {
			"CNC": "Create New Coupon",
			"AC": "Active Coupon",
			"IC": "Invaild Coupon",
			"redeem": "redeemed",
			"invalid": "Invalid",
			"none": "No data"
		},
		"CouponsTips": {
			"title": "In our system, you can easily publish your store coupon to all connected channels.",
			"tip1": "If you would like to enable this feature",
			"tip2": "please contact your MA"
		},
		"ChooseTemplate": {
			"productDiscount": "Product discount",
			"storeWideOff": "Store-wide % off",
			"freeGift": "Free gift",
			"cash": "Cash",
			"subtitle": "Coupon",
			"choose": "Choose this template"
		},
		"CouponAgreement": {
			"btn": "I agree",
			"title": "Agreement"
		},
		"ProductDiscount": {
			"subtitle": "Create product coupon",
			"form": {
				"title": "Coupon title | Product name | Product description | Original percentage | Usage instructions",
				"description": "After discount $ {discountValue}, customers save $ {saveValue}"
			}
		},
		"Conditions": {
			"payOnline": "Pay online",
			"payOnlineDescription": "Only for product discount coupon",
			"checkboxTitle": "Can be used for",
			"checkbox": "In store purchase | Delivery order"
		},
		"Settlement": {
			"table": {
				"tDate": "Transaction date",
				"sAmount": "Settlement amount",
				"sStatus": "Settlement status",
				"sTime": "Settlement time",
				"cTime": "Upload time"
			},
			"filter": {
				"status": "Please choose settlement status"
			},
			"transferOption": {
				"initial": "Initial",
				"pending": "Pending",
				"processing": "Processing",
				"successful": "Successful",
				"failed": "Failed",
				"refuse": "Refuse"
			},
			"downloadFileName": "statement | settlement"
		},
		"Review": {
			"title": "Coupon content info | Coupon condition info"
		},
		"Outlets": {
			"table": {
				"id": "ID",
				"name": "Store name",
				"country": "Country",
				"state": "State",
				"city": "City",
				"address": "Address",
				"contact": "Contact person",
				"phone": "Mobile number"
			}
		},
		"AddNewOutlet": {
			"form": {
				"name": "Name",
				"country": "Country",
				"state": "State",
				"city": "City",
				"place": "Set Postion",
				"address1": "Address line 1",
				"address2": "Address line 2",
				"contact": "Contact person",
				"phone": "Mobile Number",
				"activeTime": "Activity time",
				"lat": "Latitude",
				"lng": "Longitude"
			}
		},
		"ViewOutletDetail": {
			"table": {
				"name": "Store name",
				"address": "Address",
				"address1": "Address line 1",
				"address2": "Address line 2",
				"contact": "Contact person",
				"phone": "Mobile Number",
				"activeTime": "Activity time",
				"lat": "Latitude",
				"lng": "Longitude",
				"country": "Country",
				"city": "City",
				"state": "State",
				"pt": "Upload photos of store",
				"p1": "Shop inside photo",
				"p2": "Shop outside photo"
			}
		},
		"Reconciliation": {
			"table": {
				"date": "Date",
				"amount": "Amount",
				"type": "Type",
				"status": "Status",
				"outlet": "Store",
				"posID": "POS ID"
			}
		},
		"Devices": {
			"table": {
				"outlet": "Store",
				"posName": "POS name",
				"pay": "Alipay | Apple pay | Android pay | Samsung pay | Grab pay"
			}
		},
		"Accounts": {
			"table": {
				"username": "Username",
				"name": "Name",
				"mobile": "Mobile number",
				"email": "Email",
				"status": "Status",
				"lastTime": "Last login time",
				"createdAt": "Created at",
				"updatedAt": "Updated at",
				"admin": "Admin?"
			},
			"btn": {
				"add": "Create new account"
			}
		},
		"AddNewAccount": {
			"form": {
				"username": "Username",
				"name": "Name",
				"phone": "Mobile number",
				"email": "Email",
				"admin": "Admin?",
				"password": "Password",
				"status": "Status"
			}
		},
		"Password": {
			"title": "Modify Password",
			"old": "Old password",
			"new": "New password",
			"rNew": "Confirm new password",
			"err": "Not the same password",
			"confirm": "Confirm"
		},
		"RefundPassword": {
			"title": "Modify refund password",
			"old": "Current refund password",
			"new": "New refund password",
			"rNew": "Confirm refund password",
			"err": "Not the same password",
			"confirm": "Confirm"
		},
		"QrCode": {
			"title": "Merchant QR code",
			"storeTitle": "Store QR code",
			"download": "Download"
		},
		"PaymentChannel": {
			"channel": "Channel enable | Channel disable",
			"subTitle": "Customer service fee rate",
			"CBSF": "Customer Bear the Service Fee",
			"SFR": "Service fee rate",
			"MBSF": "Merchant Bear the service fee",
			"err": "Customer service fee cannot be set higher",
			"than": "than",
			"cancel": "Cancel",
			"save": "Save",
			"msg": "Customer service fee cannot be set higher than",
			"msg2": "Customer service fee cannot be lower than 0%"
		},
		"Analytics": {
			"Transaction": {
				"generalStatus": "General status",
				"byChannel": "By channel",
				"percentage": "Percentage"
			},
			"Customer": {
				"generalStatus": "General status",
				"customerCategories": "Customer categories",
				"ARPC": "Average revenue per customer (ARPC)",
				"t1h1": "Category",
				"t1h2": "Last puchase time (days ago)",
				"t1h3": "Number of customers",
				"t2h1": "Category",
				"t2h2": "Total purchase times",
				"t2h3": "Percentage of customers",
				"t3h1": "Category",
				"t3h2": "Average purchase amount ($)",
				"t3h3": "Percentage of customers"
			},
			"Store": {
				"trx": "Transactions",
				"percent": "Percentage"
			},
			"Customers": {
				"selectDescription": "<strong>New customer definition </strong>The payment on that day is the first payment within",
				"tableStatus": {
					"title": "Category | Last purchase times(days ago) | Number of customers",
					"midField": "last payment time"
				},
				"tableFrequency": {
					"title": "Category | Total purchase times | Percentage of customers",
					"midField": "purchase times"
				},
				"tableContribution": {
					"title": "Category | Average purchase amount($) | Percentage of customers",
					"midField": "average purchase amount"
				},
				"tableCategorisation": {
					"selector": "All | Active Customers | Inactive Customers | Lost Customers",
					"title": "Low Frequency Customers | Mid Frequency Customers | High Frequency Customers",
					"titleColumn": "Low contribution customers | Mid contribution customers | High contribution customers"
				}
			}
		},
		"PaymentChannels": {
			"table": {
				"channel": "Channel",
				"status": "Status"
			},
			"subtitle": "Activate more payment channels"
		},
		"ActivateChannels": {
			"form": "App ID | Private key | Business registration document",
			"formDescription": "Please upload your business registration document.",
			"agree": "I agree with the <a>terms and conditions</a>"
		},
		"ChooseCoupon": {
			"example": "Example",
			"title": "Which coupon do you want to create"
		},
		"AddCoupon": {
			"type": "Coupon type",
			"f1": "Discount",
			"f2": "Name",
			"f3": "Valid time",
			"month": "1 month | 3 months",
			"placeholder": "Choose coupon's name",
			"t1": "Storewide % off",
			"t1f1": "Storewide | Off",
			"t2f1": "Off with | Spend",
			"t3f1": "Off with | Spend",
			"r1": "1.",
			"r2": "2. Coupon valid time is ",
			"r3": "3. Total amount of coupon is 1000",
			"r4": "4. Each coupon can only be redeemed once",
			"r5": "5. The coupon must be presented at cashier before payment to enjoy this offer",
			"r6": "6. The management reserves the right to amend the offer without prior notice",
			"tip": "Are you sure to publish the coupon",
			"rules": "Rules",
			"msg1": "Please enter an integer for percentage discount.",
			"msg2": "Please enter an integer between 1 and 99.",
			"msg3": "Oops! Currently, we only support less than 10,000 for minimum spending setting.",
			"msg4": "Please enter an positive number for minimum spending.",
			"msg5": "Please enter an positive number for amount discount.",
			"msg6": "Please enter an integer for minimum spending.",
			"msg7": "Please enter an integer for amount discount.",
			"msg8": "Please make sure your discount amount is less than your minimum spending.",
			"msg9": "Please input coupon discount before publish.",
			"msg10": "Please complete the value."
		},
		"Agreement": {
			"title": "Settlement Period"
		},
		"Contract": {
			"agree": "I Agree",
			"contact": "Contact MA",
			"info": "Contract confirmation",
			"cnt": "I have read through the contract and agree with it",
			"tip": "Contact",
			"mail": "E-mail",
			"phone": "Phone"
		},
		"ResetPwd": {
			"t1": "Reset Password",
			"t2": "Reset Refund Password",
			"err": "Not the same password"
		},
		"ServiceFee": {
			"t": "Merchant service fee rate",
			"st": "Customer Bear the Service Fee",
			"r": "Service fee rate",
			"mf": "Merchant Bear the Service Fee",
			"sf": "Customer service fee cannot be set higher"
		},
		"Invoices": {
			"in": "Invoice number",
			"amount": "Amount",
			"gst": "GST",
			"tAmount": "Total amount",
			"month": "month",
			"placeholder": "Select month"
		}
	},
	"pageTitle": {
		"401": "401",
		"404": "404",
		"500": "500",
		"login": "Login",
		"dashboard": "Dashboard",
		"transactions": {
			"self": "Transactions",
			"view": "View transaction detail"
		},
		"customers": "Customers",
		"outlets": {
			"self": "Stores",
			"add": "Add new store",
			"view": "View store detail",
			"update": "Edit store"
		},
		"analytics": {
			"self": "Analytics",
			"trx": "Transactions",
			"customers": "Customers",
			"outlets": "Stores"
		},
		"reconciliation": "Reconciliation",
		"accounts": {
			"self": "Accounts",
			"add": "Add new account",
			"update": "Update account"
		},
		"refunds": {
			"self": "Refunds",
			"view": "Refund details"
		},
		"settings": {
			"self": "Settings",
			"payment": "Payment channel",
			"pwd": "Modify password",
			"refundPwd": "Modify refund password",
			"bank": "Bank",
			"qrcode": "QrCode"
		},
		"onBoarding": {
			"reset": "Reset password",
			"agreement": "Agreement",
			"contract": "Contract",
			"serviceFee": "Customer service fee setting"
		},
		"coupons": {
			"self": "Coupons",
			"choose": "Choose coupon",
			"add": "Add coupon",
			"edit": "Update coupon",
			"view": "View coupon detail",
			"agreement": "Agreement",
			"tips": "Tips"
		},
		"invoices": "Invoices",
		"settlements": "Settlements",
		"contract": "Contract"
	}
};

/***/ }),
/* 1185 */
/***/ (function(module, exports) {

module.exports = {
	"Notify": {
		"err": "ข้อผิดพลาด",
		"errorMsg": "Net error. Please try again later",
		"suc": "สำเร็จ"
	},
	"Navigator": {
		"profile": "ข้อมูลส่วนตัว",
		"signOut": "ออกจากระบบ",
		"signIn": "เข้าระบบ",
		"signOutTips": "คุณต้องการออกจากระบบใช่ไหม",
		"tip": "ข้อแนะนำ",
		"cancel": "ยกเลิก",
		"confirm": "ยืนยัน",
		"lang": "ภาษา",
		"changeLang": "Switching language",
		"appName": "AI Merchant"
	},
	"Functional": {
		"save": "บันทึก",
		"cancel": "ยกเลิก",
		"confirm": "ยืนยัน",
		"publish": "ออกจำหน่าย",
		"clear": "ลบทั้งหมด",
		"download": "ดาวน์โหลด",
		"upload": "อัปโหลดอุปกรณ์",
		"next": "ถัดไป",
		"back": "กลับ",
		"help": "ช่วยเหลือ",
		"on": "เปิด | เปิด",
		"off": "ปิด | ปิด",
		"create": "สร้าง",
		"delete": "ลบ",
		"all": "ทั้งหมด | ข้อมูลที่เก็บทั้งหมด | สถานะทั้งหมด | ทุกประเภท | เลือกทั้งหด",
		"comingSoon": "เร็วๆนี้",
		"controlPanel": "แผงควบคุม",
		"more": "เพิ่มเติม | ข้อมูลเพิ่มเติม",
		"yes": "ใช่ | ใช่",
		"no": "ไม่ใช่ | ไม่ใช่",
		"reload": "Reload"
	},
	"Date": {
		"dateRange": "7 วันล่าสุด | 30 วันล่าสุด | 12 เดือนล่าสุด",
		"today": "วันนี้",
		"openTime": "เวลาเปิดระบบ",
		"closeTime": "เวลาปิดระบบ",
		"placeholder": "กรุณาเลือกช่วงวันที่ต้องการ"
	},
	"Chart": {
		"numberOfCustomers": "จำนวนลูกค้า",
		"numberOfOrder": "จำนวนรายการที่สั่ง",
		"arpcByOutlet": "ARPC ของแต่ละร้านค้า",
		"revenue": "รายได้",
		"trxAmount": "แต่ละช่องทาง",
		"transactionByChannel": "จำนวนรายการแต่ละช่องทาง",
		"channelPercentage": "เปอร์เซ็นต์ของแต่ละช่องทาง",
		"outletPercentage": "เปอร์เซ็นต์ของแต่ละร้านค้า",
		"statusPercentage": "เปอร์เซ็นต์ของแต่ละสถานะ",
		"customerGrowthChart": "แผนภูมิการขยายตัวของลูกค้า",
		"newCustomers": "ลูกค้าใหม่",
		"retention": "การขยาย",
		"customerCategories": "ประเภทของลูกค้า",
		"customerStatus": "สถานะของลูกค้า",
		"customerFrequency": "ความถี่ของลูกค้า",
		"customerContribution": "การสนับสนุนของลูกค้า",
		"arpcByGender": "ARPC ของแต่ละเพศ",
		"arpcByProduct": "ARPC ของแต่ละผลิตภัณฑ์",
		"outletPerChannel": "รายช่องทาง",
		"transactionsByOutlet": "จำนวนรายการแต่ละร้านค้า",
		"RefundByOutlet": "การคืนเงินของแต่ละร้านค้า",
		"ReversalByOutlet": "การยกเลิกสินค้าของแต่ละร้านค้า"
	},
	"Tab": {
		"generalStatus": "สถานะทั่วไป",
		"byChannel": "รายช่องทาง",
		"percentage": "เปอร์เซ็นต์",
		"newCustomers": "ลูกค้าใหม่",
		"customerCategories": "ประเภทของลูกค้า",
		"arpc": "รายได้เฉลี่ยของแต่ละลูกค้า",
		"customerMap": "ทิศทางของลูกค้า",
		"transactions": "รายการ",
		"outletPercentage": "เปอร์เซ็นต์"
	},
	"Button": {
		"createNewCoupon": "สร้างคูปองใหม่",
		"addNewOutlet": "เพิ่มร้านค้าใหม่",
		"chooseCouponTemplate": "เลือกแบบของคูปอง",
		"backToTemplate": "กลับสู่การเลือกรูปแบบ",
		"saveCoupon": "บันทึกคูปอง",
		"save": "บันทึก",
		"cancel": "ยกเลิก",
		"delete": "ลบ",
		"refund": "คืนเงิน"
	},
	"Placeholder": {
		"TableSearch": "เลือกประเภทรหัสประจำตัว",
		"OutletSearch": "ชื่อร้านค้า,ที่อยู่,ชื่อผู้ติดต่อ,หมายเลขโทรศัพท์เคลื่อนที่",
		"AccountSearch": "ชื่อผู้ใช้,ชื่อ,โทรศัพท์เคลื่อนที่,อีเมล"
	},
	"Step": {
		"Coupons": "เลือกประเทศ | เลือกรูปแบบ | แก้ไขคูปอง | เลือกร้านค้า"
	},
	"Country": {
		"title": "ชื่อเรื่อง",
		"China": "จีน",
		"Australia": "ออสเตรเลีย",
		"Indonesia": "อินโดนีเซีย",
		"Malaysia": "มาเลเซีย",
		"Singapore": "สิงค์โปร์",
		"SouthKorea": "เกาหลีใต้",
		"Thailand": "ไทย"
	},
	"Week": {
		"sunday": "วันอาทิตย์",
		"monday": "วันจันทร์",
		"tuesday": "วันอังคาร",
		"wednesday": "วันพุธ",
		"thursday": "วันพฤหัสบดี",
		"friday": "วันศุกร์",
		"saturday": "วันเสาร์"
	},
	"Table": {
		"id": "รหัสประจำตัว",
		"actions": "กระทำ",
		"view": "มอง | มอง | มอง",
		"stop": "หยุด",
		"update": "ปรับปรุง",
		"publish": "จำหน่าย",
		"upgrade": "ยกระดับ",
		"edit": "แก้ไข",
		"resetPassword": "ตั้งรหัสผ่านใหม่",
		"permissions": "อนุญาต"
	},
	"Views": {
		"401": {
			"title": "401",
			"cnt1": "Sorry!",
			"cnt2": "You have no access rights",
			"btn1": "",
			"btn2": "Go to Dashboard"
		},
		"404": {
			"title": "404",
			"cnt1": "Sorry",
			"cnt2": "The page could not be found",
			"btn1": "Back to prev",
			"btn2": "Go to Dashboard"
		},
		"500": {
			"title": "500",
			"cnt1": "Sorry!",
			"cnt2": "The service is temporarily unresponsive",
			"btn1": "Refresh",
			"btn2": "Go to Dashboard"
		},
		"Login": {
			"msg": "ข้อความ",
			"login": "เข้าระบบ",
			"loading": "กำลังรับข้อมูล",
			"id": "รหัสประจำตัว",
			"pwd": "รหัสผ่าน",
			"captcha": "Captcha"
		},
		"Dashboard": {
			"welTitle": "Congratulations! You have successfully activate your account!",
			"welCnt": "You can download the QR code via merchant portal. Related marketing materials and QR code will be delivered to your store within 3-5 working days."
		},
		"Transactions": {
			"filter": {
				"id": "รหัสประจำตัว",
				"mid": "รหัสร้านค้า",
				"mname": "ชื่อร้านค้า"
			},
			"table": {
				"id": "รหัสประจำตัว",
				"date": "วันที่",
				"amount": "จำนวนเงิน",
				"realAmount": "จำนวนเงินจริง",
				"status": "สถานะ",
				"outlet": "ร้าน",
				"posID": "รหัสเครื่องชำระเงิน",
				"remark": "หมายเหตุ",
				"cAmount": "Order amount",
				"customer": "ลูกค้า",
				"posUsername": "POS Username"
			},
			"downloadFileName": "รายการ"
		},
		"TrxViewDeital": {
			"table": {
				"id": "รหัส",
				"outletId": "รหัสร้าน",
				"merchantId": "รหัสร้านค้า",
				"trxId": "หมายเลขรายการ",
				"settleAmount": "จำนวนเงินที่ปิดยอด",
				"realAmount": "จำนวนเงินจริง",
				"currency": "สกุลเงิน",
				"createTime": "เวลาที่สร้าง",
				"createLocalTime": "Create local time",
				"deviceId": "รหัสอุปกรณ์",
				"status": "สถานะ",
				"subType": "ประเภทย่อย",
				"remark": "หมายเหตุ",
				"payTrxId": "Pay transaction ID",
				"payChannel": "ช่องทางการชำระเงิน",
				"customer": "ลูกค้า",
				"fee": "ค่าธรรมเนียม",
				"customerAmount": "Order amount",
				"settleTime": "เวลาปิดยอด",
				"refundRecord": "จำนวนรายการที่คืนเงิน",
				"refundStatus": "สถานะการคืนเงิน",
				"requestForRefund": "การขอคืนเงิน",
				"refunded": "คืนเงิน",
				"refundFailed": "รายการคืนเงินไม่สำเร็จ",
				"appTime": "เวลาของระบบ",
				"completeTime": "เวลาที่ทำรายการสำเร็จ",
				"refundAmount": "ยอดคืนเงิน",
				"refund": "คืนเงิน",
				"refundAbleAmount": "จำนวนเงินที่สามารถคืนเงินได้",
				"finalAmount": "ยอดสุดท้าย",
				"cRate": "Customer rate",
				"mRate": "Merchant rate",
				"discount": "Discount",
				"t1": "Basic Information",
				"posId": "POS ID",
				"cashier": "Cashier Username"
			},
			"tips": {
				"title": "Refund",
				"cnt": "This refund request cannot be cancelled. Are you sure to proceed?",
				"placeholder": "Refund password"
			},
			"transferNameList": "0 | Transfer Pending | Transfer Completed | Transfer Failed"
		},
		"Refund": {
			"table": {
				"rTime": "Refund time",
				"trxId": "Transaction ID",
				"rAmount": "Refunded amount",
				"rStatus": "Refund status",
				"customer": "ลูกค้า",
				"remark": "หมายเหตุ",
				"store": "ร้านค้า",
				"posId": "Pos ID"
			},
			"filter": {
				"trxId": "Transaction ID",
				"customer": "ร้านค้า"
			},
			"button": {
				"refund": "คืนเงิน"
			},
			"mask": {
				"title": "Pending refunded amount",
				"name": "ชื่อ",
				"amount": "จำนวนเงิน",
				"cnt": "Your settlement has been suspended. Please transfer the above amount to the agency as soon as possible to resume the settlement."
			},
			"downloadFileName": "refunds"
		},
		"RefundDetail": {
			"form": {
				"trxId": "Transaction ID",
				"cTime": "Create time",
				"ptId": "Pay Transaction ID",
				"pType": "Payment type",
				"customer": "Customer",
				"fee": "ค่าธรรมเนียม",
				"rAmount": "RefundAmount",
				"settled": "To be settled",
				"sTime": "Settlement time",
				"rComplete": "Refund Completed",
				"completeTime": "Completed time"
			}
		},
		"Customers": {
			"checkbox": {
				"all": "ทั้งหมด",
				"customerCategorization": "ประเภทของลูกค้า",
				"activeCustomers": "Active customers | Inactive customers | Lost customers",
				"frequencyCustomers": "High frequency customers | Mid frequency customers | Low frequency customers",
				"contributionCustomers": "High contribution customers | Mid contribution customers | Low contribution customers"
			},
			"table": {
				"id": "รหัสประจำตัว",
				"name": "ชื่อ",
				"mobile": "โทรศัพท์เคลื่อนที่",
				"gender": "เพศ",
				"joinDate": "วันที่เข้าร่วม",
				"totalSpending": "ยอดรวมการทำรายการ",
				"lastVisitDate": "วันที่ล่าสุดที่เข้าระบบ",
				"averageSpending": "ยอดเฉลี่ยการทำรายการ"
			}
		},
		"Coupons": {
			"CNC": "Create New Coupon",
			"AC": "Active Coupon",
			"IC": "Invaild Coupon",
			"redeem": "redeemed",
			"invalid": "Invalid",
			"none": "No data"
		},
		"CouponsTips": {
			"title": "In our system, you can easily publish your store coupon to all connected channels.",
			"tip1": "If you would like to enable this feature",
			"tip2": "please contact your MA"
		},
		"ChooseTemplate": {
			"productDiscount": "ส่วนลดของผลิตภัณฑ์",
			"storeWideOff": "Store-wide % off",
			"freeGift": "ส่วนลดของผลิตภัณฑ์",
			"cash": "เงินสด",
			"subtitle": "หัวข้อย่อย",
			"choose": "เลือก"
		},
		"CouponAgreement": {
			"btn": "I agree",
			"title": "Agreement"
		},
		"ProductDiscount": {
			"subtitle": "หัวข้อย่อย",
			"form": {
				"title": "Coupon title | Product name | Product description | Original percentage | Usage instructions",
				"description": "After discount $ {discountValue}, customers save $ {saveValue}"
			}
		},
		"Conditions": {
			"payOnline": "ชำระเงินทางออนไลน์",
			"payOnlineDescription": "คำอธิบายเพิ่มเติมของการชำระเงินออนไลน์",
			"checkboxTitle": "Can be used for",
			"checkbox": "In store purchase | Delivery order"
		},
		"Settlement": {
			"table": {
				"tDate": "Transaction date",
				"sAmount": "Settlement amount",
				"sStatus": "Settlement status",
				"sTime": "Settlement time",
				"cTime": "Upload time"
			},
			"filter": {
				"status": "สถานะ"
			},
			"transferOption": {
				"initial": "เริ่มต้น",
				"pending": "อยู่ระหว่างการดำเนินการ",
				"processing": "อยู่ระหว่างประมวลผล",
				"successful": "สำเร็จ",
				"failed": "ล้มเหลว",
				"refuse": "ปฏิเสธ"
			},
			"downloadFileName": "statement | settlement"
		},
		"Review": {
			"title": "Coupon content info | Coupon condition info"
		},
		"Outlets": {
			"table": {
				"id": "รหัสประจำตัว",
				"name": "ชื่อ",
				"country": "ประเทศ",
				"state": "รัฐ",
				"city": "เมือง",
				"address": "ที่อยู่",
				"contact": "ผู้ติดต่อ",
				"phone": "หมายเลขโทรศัพท์"
			}
		},
		"AddNewOutlet": {
			"form": {
				"name": "ชื่อ",
				"country": "ประเทศ",
				"state": "รัฐ",
				"city": "เมือง",
				"place": "สถานที่",
				"address1": "ที่อยู่ 1",
				"address2": "ที่อยู่ 2",
				"contact": "ติดต่อ",
				"phone": "หมายเลขโทรศัพท์",
				"activeTime": "Activity time",
				"lat": "Latitude",
				"lng": "Longitude"
			}
		},
		"ViewOutletDetail": {
			"table": {
				"name": "Store name",
				"address": "Address",
				"address1": "Address line 1",
				"address2": "Address line 2",
				"contact": "Contact person",
				"phone": "Mobile Number",
				"activeTime": "Activity time",
				"lat": "Latitude",
				"lng": "Longitude",
				"country": "Country",
				"city": "City",
				"state": "State",
				"pt": "Upload photos of store",
				"p1": "Shop inside photo",
				"p2": "Shop outside photo"
			}
		},
		"Reconciliation": {
			"table": {
				"date": "Date",
				"amount": "Amount",
				"type": "Type",
				"status": "Status",
				"outlet": "Store",
				"posID": "POS ID"
			}
		},
		"Devices": {
			"table": {
				"outlet": "Store",
				"posName": "POS name",
				"pay": "Alipay | Apple pay | Android pay | Samsung pay | Grab pay"
			}
		},
		"Accounts": {
			"table": {
				"username": "Username",
				"name": "Name",
				"mobile": "Mobile number",
				"email": "Email",
				"status": "Status",
				"lastTime": "Last login time",
				"createdAt": "Created at",
				"updatedAt": "Updated at",
				"admin": "Admin?"
			},
			"btn": {
				"add": "Create new account"
			}
		},
		"AddNewAccount": {
			"form": {
				"username": "Username",
				"name": "Name",
				"phone": "Mobile number",
				"email": "Email",
				"admin": "Admin?",
				"password": "Password",
				"status": "Status"
			}
		},
		"Password": {
			"title": "Modify Password",
			"old": "Old password",
			"new": "New password",
			"rNew": "Confirm new password",
			"err": "Not the same password",
			"confirm": "Confirm"
		},
		"RefundPassword": {
			"title": "Modify refund password",
			"old": "Current refund password",
			"new": "New refund password",
			"rNew": "Confirm refund password",
			"err": "Not the same password",
			"confirm": "Confirm"
		},
		"QrCode": {
			"title": "Merchant QR code",
			"storeTitle": "Store QR code",
			"download": "Download"
		},
		"PaymentChannel": {
			"channel": "Channel enable | Channel disable",
			"subTitle": "Customer service fee rate",
			"CBSF": "Customer Bear the Service Fee",
			"SFR": "Merchant service fee rate",
			"MBSF": "Merchant Bear the service fee",
			"err": "Customer service fee cannot be set higher",
			"than": "than",
			"cancel": "Cancel",
			"save": "Save",
			"msg": "Customer service fee cannot be set higher than",
			"msg2": "Customer service fee cannot be lower than 0%"
		},
		"Analytics": {
			"Transaction": {
				"generalStatus": "General status",
				"byChannel": "By Channel",
				"percentage": "Percentage"
			},
			"Customer": {
				"generalStatus": "General status",
				"customerCategories": "Customer categories",
				"ARPC": "Average revenue per customer (ARPC)",
				"t1h1": "Category",
				"t1h2": "Last puchase time (days ago)",
				"t1h3": "Number of customers",
				"t2h1": "Category",
				"t2h2": "Total purchase times",
				"t2h3": "Percentage of customers",
				"t3h1": "Category",
				"t3h2": "Average purchase amount ($)",
				"t3h3": "Percentage of customers"
			},
			"Store": {
				"trx": "Transactions",
				"percent": "Percentage"
			},
			"Customers": {
				"selectDescription": "<strong>New customer definition </strong>The payment on that day is the first payment within",
				"tableStatus": {
					"title": "Category | Last purchase times(days ago) | Number of customers",
					"midField": "last payment time"
				},
				"tableFrequency": {
					"title": "Category | Total purchase times | Percentage of customers",
					"midField": "purchase times"
				},
				"tableContribution": {
					"title": "Category | Average purchase amount($) | Percentage of customers",
					"midField": "average purchase amount"
				},
				"tableCategorisation": {
					"selector": "All | Active Customers | Inactive Customers | Lost Customers",
					"title": "Low Frequency Customers | Mid Frequency Customers | High Frequency Customers",
					"titleColumn": "Low contribution customers | Mid contribution customers | High contribution customers"
				}
			}
		},
		"PaymentChannels": {
			"table": {
				"channel": "Channel",
				"status": "Status"
			},
			"subtitle": "Activate more payment channels"
		},
		"ActivateChannels": {
			"form": "App ID | Private key | Business registration document",
			"formDescription": "Please upload your business registration document.",
			"agree": "I agree with the <a>terms and conditions</a>"
		},
		"ChooseCoupon": {
			"example": "Example",
			"title": "Which coupon do you want to create"
		},
		"AddCoupon": {
			"type": "Coupon type",
			"f1": "Discount",
			"f2": "Name",
			"f3": "Valid time",
			"month": "1 month | 3 month",
			"placeholder": "Choose coupon's name",
			"t1": "Storewide % off",
			"t1f1": "Storewide | Off",
			"t2f1": "Off with | Spend",
			"t3f1": "Off with | Spend",
			"r1": "1.",
			"r2": "2. Coupon Valid time is",
			"r3": "3. Total Amount of Coupon is 1000",
			"r4": "4. Each Coupon can only be redeemed once",
			"r5": "5. The Coupon must be presented at cashier before payment to enjoy this offer",
			"r6": "6. The management reserves the right to amend the offer without prior notice",
			"tip": "Are you sure to publish the coupon",
			"rules": "Rules",
			"msg1": "Please enter an integer for percentage discount.",
			"msg2": "Please enter an integer between 1 and 99.",
			"msg3": "Oops! Currently, we only support less than 10,000 for minimum spending setting.",
			"msg4": "Please enter an positive number for minimum spending.",
			"msg5": "Please enter an positive number for amount discount.",
			"msg6": "Please enter an integer for minimum spending.",
			"msg7": "Please enter an integer for amount discount.",
			"msg8": "Please make sure your discount amount is less than your minimum spending.",
			"msg9": "Please input coupon discount before publish.",
			"msg10": "Please complete the value."
		},
		"Agreement": {
			"title": "Settlement Period"
		},
		"Contract": {
			"agree": "I Agree",
			"contact": "Contact MA",
			"info": "Contract confirmation",
			"cnt": "I have read through the contract and agree with it",
			"tip": "Contact",
			"mail": "E-mail",
			"phone": "Phone"
		},
		"ResetPwd": {
			"t1": "Reset Password",
			"t2": "Reset Refund Password",
			"err": "Not the same password"
		},
		"ServiceFee": {
			"t": "Service Fee Rate",
			"st": "Customer Bear the Service Fee",
			"r": "Service Fee Rate",
			"mf": "Merchant Bear the Service Fee",
			"sf": "Customer service fee cannot be set higher"
		},
		"Invoices": {
			"in": "Invoice number",
			"amount": "Amount",
			"gst": "GST",
			"tAmount": "Total amount",
			"month": "month",
			"placeholder": "Select month"
		}
	},
	"pageTitle": {
		"401": "401",
		"404": "404",
		"500": "500",
		"login": "Login",
		"dashboard": "Dashboard",
		"transactions": {
			"self": "Transactions",
			"view": "View transaction detail"
		},
		"customers": "Customers",
		"outlets": {
			"self": "Stores",
			"add": "Add new store",
			"view": "View store detail",
			"update": "Edit store"
		},
		"analytics": {
			"self": "Analytics",
			"trx": "Transactions",
			"customers": "Customers",
			"outlets": "Stores"
		},
		"reconciliation": "การกระทบยอด",
		"accounts": {
			"self": "ด้วยตัวเอง",
			"add": "เพิ่ม",
			"update": "ปรับปรุง"
		},
		"refunds": {
			"self": "ด้วยตัวเอง",
			"view": "ดู"
		},
		"settings": {
			"self": "ด้วยตัวเอง",
			"payment": "ชำระเงิน",
			"pwd": "Modify password",
			"refundPwd": "Modify refund password",
			"bank": "ธนาคาร",
			"qrcode": "QrCode"
		},
		"onBoarding": {
			"reset": "การตั้งใหม่",
			"agreement": "ข้อตกลง",
			"contract": "สัญญา",
			"serviceFee": "ค่าบริการ"
		},
		"coupons": {
			"self": "ด้วยตัวเอง",
			"choose": "เลือก",
			"add": "เพิ่ม",
			"edit": "แก้ไข",
			"view": "ดู",
			"agreement": "Agreement",
			"tips": "Tips"
		},
		"invoices": "ใบแจ้งหนี้",
		"settlements": "การสรุปยอดรายการ",
		"contract": "สัญญา"
	}
};

/***/ }),
/* 1186 */
/***/ (function(module, exports) {

module.exports = {
	"Notify": {
		"err": "Error",
		"suc": "Successful"
	},
	"Navigator": {
		"profile": "Profile",
		"signOut": "Sign Out",
		"signIn": "Sign In",
		"signOutTips": "Are you sure?",
		"tip": "Tips",
		"cancel": "Cancel",
		"confirm": "Confirm",
		"lang": "Language"
	},
	"Functional": {
		"save": "Save",
		"cancel": "Cancel",
		"confirm": "Confirm",
		"publish": "Publish",
		"clear": "Clear All",
		"download": "Download",
		"upload": "Upload Device",
		"next": "Next",
		"back": "Back",
		"help": "Help",
		"on": "On | ON",
		"off": "Off | OFF",
		"create": "Create",
		"delete": "Delete",
		"all": "All | All Stores | All Status | All Types | Select All",
		"comingSoon": "Coming Soon.",
		"controlPanel": "Control panel",
		"more": "More | More Info",
		"yes": "Yes | YES",
		"no": "No | NO"
	},
	"Date": {
		"dateRange": "近一周 | 近一月 | 近一年",
		"today": "今天",
		"openTime": "开业时间",
		"closeTime": "结业时间",
		"placeholder": "请选择时间"
	},
	"Chart": {
		"numberOfCustomers": "Number of customers",
		"numberOfOrder": "Number of orders",
		"arpcByOutlet": "ARPC by store",
		"revenue": "Revenue",
		"perChannel": "Per Channel",
		"transactionByChannel": "Transaction by channel",
		"channelPercentage": "Channel percentage",
		"outletPercentage": "Store percentage",
		"statusPercentage": "Status percentage",
		"customerGrowthChart": "Customers growth chart",
		"newCustomers": "New customers",
		"retention": "Retention",
		"customerCategories": "Customer categories",
		"customerStatus": "Customer Status",
		"customerFrequency": "Customer frequency",
		"customerContribution": "Customer contribution",
		"arpcByGender": "ARPC by Gender",
		"arpcByProduct": "ARPC by Product",
		"outletPerChannel": "Per channel",
		"transactionsByOutlet": "Transactions by store",
		"RefundByOutlet": "Refund by store",
		"ReversalByOutlet": "Reversal by store"
	},
	"Tab": {
		"generalStatus": "General status",
		"byChannel": "By Channel",
		"percentage": "Percentage",
		"newCustomers": "New customers",
		"customerCategories": "Customer categories",
		"arpc": "Average revenue per customer(ARPC)",
		"customerMap": "Customer map",
		"transactions": "Transactions",
		"outletPercentage": "Percentage"
	},
	"Button": {
		"createNewCoupon": "+ Create new coupon",
		"addNewOutlet": "Add New Store",
		"chooseCouponTemplate": "Choose Coupon Template",
		"backToTemplate": "Back to template selection",
		"saveCoupon": "Save coupon",
		"save": "Save",
		"cancel": "Cancel",
		"delete": "Delete",
		"refund": "Refund"
	},
	"Placeholder": {
		"TableSearch": "Please type id",
		"OutletSearch": "Store name , Address , Contact person , Mobile Number",
		"AccountSearch": "Username , Name , Mobile number , Email"
	},
	"Step": {
		"Coupons": "CHOOSE COUNTRIES | CHOOSE TEMPLATE | EDIT COUPONS | CHOOSE STORES"
	},
	"Country": {
		"title": "Choose coupons distribution countries",
		"China": "China",
		"Australia": "Australia",
		"Indonesia": "Indonesia",
		"Malaysia": "Malaysia",
		"Singapore": "Singapre",
		"SouthKorea": "South Korea",
		"Thailand": "Thailand"
	},
	"Week": {
		"sunday": "Sunday",
		"monday": "Monday",
		"tuesday": "Tuesday",
		"wednesday": "Wednesday",
		"thursday": "Thursday",
		"friday": "Friday",
		"saturday": "Saturday"
	},
	"Table": {
		"id": "ID",
		"actions": "Actions",
		"view": "View | Detail | Details",
		"stop": "Stop",
		"update": "Update",
		"publish": "Publish",
		"upgrade": "Upgrade",
		"edit": "Edit",
		"resetPassword": "Reset Password",
		"permissions": "Permissions"
	},
	"Views": {
		"Login": {
			"msg": "Please type your name and password again.",
			"login": "Login",
			"loading": "Loading",
			"id": "ID",
			"pwd": "Password",
			"captcha": "Captcha"
		},
		"Dashboard": {
			"welTitle": "Congratulations! You have successfully activate your account!",
			"welCnt": "You can download the QR code via merchant portal. Related marketing materials and QR code will be delivered to your store within 3-5 working days."
		},
		"Transactions": {
			"filter": {
				"id": "交易ID",
				"mid": "商铺ID",
				"mname": "商铺名称"
			},
			"table": {
				"id": "交易ID",
				"date": "交易时间",
				"amount": "结算金额",
				"realAmount": "交易金额",
				"status": "状态",
				"outlet": "门店",
				"posID": "设备ID",
				"remark": "备注",
				"cAmount": "用户输入金额",
				"customer": "客户名称"
			},
			"downloadFileName": "transaction"
		},
		"TrxViewDeital": {
			"table": {
				"id": "ID",
				"outletId": "Store ID",
				"merchantId": "Merchant ID",
				"trxId": "Transaction ID",
				"settleAmount": "Settlement amount",
				"realAmount": "Total amount",
				"currency": "Currency",
				"createTime": "Create time",
				"deviceId": "Device ID",
				"status": "Status",
				"subType": "Sub Type",
				"remark": "Remark",
				"payTrxId": "Pay transaction ID",
				"payChannel": "Payment channel",
				"customer": "Customer",
				"fee": "Service fee",
				"customerAmount": "Order amount",
				"settleTime": "Settlement time",
				"refundRecord": "Refund record",
				"refundStatus": "Refund status",
				"requestForRefund": "Request for refund",
				"refunded": "Refunded",
				"refundFailed": "Refunded failed",
				"appTime": "Application time",
				"completeTime": "Completed time",
				"refundAmount": "Refunded amount",
				"refund": "Refund",
				"refundAbleAmount": "Refundable amount",
				"finalAmount": "Final amount",
				"cRate": "Customer rate",
				"mRate": "Merchant rate"
			},
			"tips": {
				"title": "Refund",
				"cnt": "This refund request cannot be cancelled. Are you sure to proceed?",
				"placeholder": "Refund password"
			},
			"transferNameList": "0 | Transfer Pending | Transfer Completed | Transfer Failed"
		},
		"Refund": {
			"table": {
				"rTime": "Refund time",
				"trxId": "Transaction ID",
				"rAmount": "Refunded amount",
				"rStatus": "Refund status",
				"customer": "Customer",
				"remark": "Remark",
				"store": "Store",
				"posId": "Pos ID"
			},
			"filter": {
				"trxId": "Transaction ID",
				"customer": "Customer"
			},
			"button": {
				"refund": "Pending refunds"
			},
			"mask": {
				"title": "Pending refunded amount",
				"name": "Agency name",
				"amount": "Amount",
				"cnt": "Your settlement has been suspended. Please transfer the above amount to the agency as soon as possible to resume the settlement."
			},
			"downloadFileName": "refunds"
		},
		"RefundDetail": {
			"form": {
				"trxId": "Transaction ID",
				"cTime": "Create time",
				"ptId": "Pay Transaction ID",
				"pType": "Payment type",
				"customer": "Customer",
				"fee": "Service fee",
				"rAmount": "RefundAmount",
				"settled": "To be settled",
				"sTime": "Settlement time",
				"rComplete": "Refund Completed",
				"completeTime": "Completed time"
			}
		},
		"Customers": {
			"checkbox": {
				"all": "All",
				"customerCategorization": "Customer Categorization",
				"activeCustomers": "Active customers | Inactive customers | Lost customers",
				"frequencyCustomers": "High frequency customers | Mid frequency customers | Low frequency customers",
				"contributionCustomers": "High contribution customers | Mid contribution customers | Low contribution customers"
			},
			"table": {
				"id": "ID",
				"name": "Name",
				"mobile": "Mobile number",
				"gender": "Gender",
				"joinDate": "Join date",
				"totalSpending": "Total spending",
				"lastVisitDate": "Last visit date",
				"averageSpending": "Average spending"
			}
		},
		"Coupons": {
			"CNC": "Create New Coupon",
			"AC": "Active Coupon",
			"IC": "Invaild Coupon",
			"redeem": "redeemed",
			"invalid": "Invalid",
			"none": "No data"
		},
		"ChooseTemplate": {
			"productDiscount": "Product discount",
			"storeWideOff": "Store-wide % off",
			"freeGift": "Free gift",
			"cash": "Cash",
			"subtitle": "Coupon",
			"choose": "Choose this template"
		},
		"ProductDiscount": {
			"subtitle": "Create product coupon",
			"form": {
				"title": "Coupon title | Product name | Product description | Original percentage | Usage instructions",
				"description": "After discount $ {discountValue}, customers save $ {saveValue}"
			}
		},
		"Conditions": {
			"payOnline": "Pay online",
			"payOnlineDescription": "Only for product discount coupon",
			"checkboxTitle": "Can be used for",
			"checkbox": "In store purchase | Delivery order"
		},
		"Settlement": {
			"table": {
				"tDate": "Transaction date",
				"sAmount": "Settlement amount",
				"sStatus": "Settlement status",
				"sTime": "Settlement time"
			},
			"filter": {
				"status": "Please choose settlement status"
			},
			"transferOption": {
				"initial": "Initial",
				"pending": "Pending",
				"processing": "Processing",
				"successful": "Successful",
				"failed": "Failed",
				"refuse": "Refuse"
			},
			"downloadFileName": "statement | settlement"
		},
		"Review": {
			"title": "Coupon content info | Coupon condition info"
		},
		"Outlets": {
			"table": {
				"id": "ID",
				"name": "Store name",
				"country": "Country",
				"state": "State",
				"city": "City",
				"address": "Address",
				"contact": "Contact person",
				"phone": "Mobile number"
			}
		},
		"AddNewOutlet": {
			"form": {
				"name": "Name",
				"country": "Country",
				"state": "State",
				"city": "City",
				"place": "Set Postion",
				"address1": "Address line 1",
				"address2": "Address line 2",
				"contact": "Contact person",
				"phone": "Mobile Number",
				"activeTime": "Activity time",
				"lat": "Latitude",
				"lng": "Longitude"
			}
		},
		"ViewOutletDetail": {
			"table": {
				"name": "Store name",
				"address": "Address",
				"address1": "Address line 1",
				"address2": "Address line 2",
				"contact": "Contact person",
				"phone": "Mobile Number",
				"activeTime": "Activity time",
				"lat": "Latitude",
				"lng": "Longitude",
				"country": "Country",
				"city": "City",
				"state": "State",
				"pt": "Upload photos of store",
				"p1": "Shop inside photo",
				"p2": "Shop outside photo"
			}
		},
		"Reconciliation": {
			"table": {
				"date": "Date",
				"amount": "Amount",
				"type": "Type",
				"status": "Status",
				"outlet": "Store",
				"posID": "POS ID"
			}
		},
		"Devices": {
			"table": {
				"outlet": "Store",
				"posName": "POS name",
				"pay": "Alipay | Apple pay | Android pay | Samsung pay | Grab pay"
			}
		},
		"Accounts": {
			"table": {
				"username": "Username",
				"name": "Name",
				"mobile": "Mobile number",
				"email": "Email",
				"status": "Status",
				"lastTime": "Last login time",
				"createdAt": "Created at",
				"updatedAt": "Updated at",
				"admin": "Admin?"
			},
			"btn": {
				"add": "Create new account"
			}
		},
		"AddNewAccount": {
			"form": {
				"username": "Username",
				"name": "Name",
				"phone": "Mobile number",
				"email": "Email",
				"admin": "Admin?",
				"password": "Password",
				"status": "Status"
			}
		},
		"Password": {
			"title": "Modify Password",
			"old": "Old password",
			"new": "New password",
			"rNew": "Confirm new password",
			"err": "Not the same password",
			"confirm": "Confirm"
		},
		"RefundPassword": {
			"title": "Modify refund password",
			"old": "Current refund password",
			"new": "New refund password",
			"rNew": "Confirm refund password",
			"err": "Not the same password",
			"confirm": "Confirm"
		},
		"QrCode": {
			"title": "QR code",
			"download": "Download"
		},
		"PaymentChannel": {
			"channel": "Channel enable | Channel disable",
			"subTitle": "Service Fee Rate",
			"CBSF": "Customer Bear the Service Fee",
			"SFR": "Service Fee Rate",
			"MBSF": "Merchant Bear the Service Fee",
			"err": "Service fee cannot be set higher",
			"than": "than",
			"cancel": "Cancel",
			"save": "Save",
			"msg": "Service fee cannot be set higher than",
			"msg2": "Rate cannot be lower than 0%"
		},
		"Analytics": {
			"Transaction": {
				"generalStatus": "General status",
				"byChannel": "By Channel",
				"percentage": "Percentage"
			},
			"Customer": {
				"generalStatus": "General status",
				"customerCategories": "Customer categories",
				"ARPC": "Average revenue per customer (ARPC)",
				"t1h1": "Category",
				"t1h2": "Last puchase time (days ago)",
				"t1h3": "Number of customers",
				"t2h1": "Category",
				"t2h2": "Total purchase times",
				"t2h3": "Percentage of customers",
				"t3h1": "Category",
				"t3h2": "Average purchase amount ($)",
				"t3h3": "Percentage of customers"
			},
			"Store": {
				"trx": "Transactions",
				"percent": "Percentage"
			},
			"Customers": {
				"selectDescription": "<strong>New customer definition </strong>The payment on that day is the first payment within",
				"tableStatus": {
					"title": "Category | Last purchase times(days ago) | Number of customers",
					"midField": "last payment time"
				},
				"tableFrequency": {
					"title": "Category | Total purchase times | Percentage of customers",
					"midField": "purchase times"
				},
				"tableContribution": {
					"title": "Category | Average purchase amount($) | Percentage of customers",
					"midField": "average purchase amount"
				},
				"tableCategorisation": {
					"selector": "All | Active Customers | Inactive Customers | Lost Customers",
					"title": "Low Frequency Customers | Mid Frequency Customers | High Frequency Customers",
					"titleColumn": "Low contribution customers | Mid contribution customers | High contribution customers"
				}
			}
		},
		"PaymentChannels": {
			"table": {
				"channel": "Channel",
				"status": "Status"
			},
			"subtitle": "Activate more payment channels"
		},
		"ActivateChannels": {
			"form": "App ID | Private key | Business registration document",
			"formDescription": "Please upload your business registration document.",
			"agree": "I agree with the <a>terms and conditions</a>"
		},
		"ChooseCoupon": {
			"example": "Example",
			"title": "Which coupon do you want to create"
		},
		"AddCoupon": {
			"type": "Coupon type",
			"f1": "Discount",
			"f2": "Name",
			"f3": "Valid time",
			"month": "1 month | 3 month",
			"placeholder": "Choose coupon's name",
			"t1": "Storewide % off",
			"t1f1": "Storewide | Off",
			"t2f1": "Off with | Spend",
			"t3f1": "Off with | Spend",
			"r1": "1",
			"r2": "2 Coupon Valid time is",
			"r3": "3 Total Amount of Coupon is 1000.",
			"r4": "4 Each Coupon can only be redeemed once.",
			"r5": "5 The Coupon must be presented at cashier before payment to enjoy this offer.",
			"r6": "6 The management reserves the right to amend the offer without prior notice.",
			"tip": "Are you sure to publish the coupon?",
			"rules": "Rules"
		},
		"Agreement": {
			"title": "Settlement Period"
		},
		"Contract": {
			"agree": "I Agree",
			"contact": "Contact MA",
			"info": "Contract confirmation",
			"cnt": "I have read through the contract and agree with it",
			"tip": "Contact",
			"mail": "E-mail",
			"phone": "Phone"
		},
		"ResetPwd": {
			"t1": "Reset Password",
			"t2": "Reset Refund Password",
			"err": "Not the same password"
		},
		"ServiceFee": {
			"t": "Service Fee Rate",
			"st": "Customer Bear the Service Fee",
			"r": "Service Fee Rate",
			"mf": "Merchant Bear the Service Fee",
			"sf": "Service fee cannot be set higher"
		},
		"Invoices": {
			"in": "Invoice number",
			"amount": "Amount",
			"gst": "GST",
			"tAmount": "Total amount",
			"month": "month",
			"placeholder": "Select month"
		}
	},
	"pageTitle": {
		"401": "401",
		"404": "404",
		"login": "Login",
		"dashboard": "Dashboard",
		"transactions": {
			"self": "Transactions",
			"view": "View transaction detail"
		},
		"customers": "Customers",
		"outlets": {
			"self": "Stores",
			"add": "Add new store",
			"view": "View store detail",
			"update": "Edit store"
		},
		"analytics": {
			"self": "Analytics",
			"trx": "Transactions",
			"customers": "Customers",
			"outlets": "Stores"
		},
		"reconciliation": "Reconciliation",
		"accounts": {
			"self": "Accounts",
			"add": "Add new account",
			"update": "Update account"
		},
		"refunds": {
			"self": "Refunds",
			"view": "Refund details"
		},
		"settings": {
			"self": "Settings",
			"payment": "Payment channel",
			"pwd": "Modify password",
			"refundPwd": "Modify refund password",
			"bank": "Bank",
			"qrcode": "QrCode"
		},
		"onBoarding": {
			"reset": "Reset password",
			"agreement": "Agreement",
			"contract": "Contract",
			"serviceFee": "Service fee setting"
		},
		"coupons": {
			"self": "Coupons",
			"choose": "Choose coupon",
			"add": "Add coupon",
			"edit": "Update coupon",
			"view": "View coupon detail"
		},
		"invoices": "Invoices",
		"settlements": "Settlements",
		"contract": "Contract"
	}
};

/***/ }),
/* 1187 */
/***/ (function(module, exports) {

module.exports = {
	"color": [
		"#23abeb",
		"#22d9a4",
		"#516ccc",
		"#a0a7e6",
		"#c4ebad",
		"#96dee8"
	],
	"backgroundColor": "rgba(252,252,252,0)",
	"textStyle": {},
	"title": {
		"textStyle": {
			"color": "#666666"
		},
		"subtextStyle": {
			"color": "#999999"
		}
	},
	"line": {
		"itemStyle": {
			"normal": {
				"borderWidth": "4"
			}
		},
		"lineStyle": {
			"normal": {
				"width": "2"
			}
		},
		"symbolSize": "11",
		"symbol": "emptyCircle",
		"smooth": false
	},
	"radar": {
		"itemStyle": {
			"normal": {
				"borderWidth": "4"
			}
		},
		"lineStyle": {
			"normal": {
				"width": "2"
			}
		},
		"symbolSize": "11",
		"symbol": "emptyCircle",
		"smooth": false
	},
	"bar": {
		"itemStyle": {
			"normal": {
				"barBorderWidth": 0,
				"barBorderColor": "#ccc"
			},
			"emphasis": {
				"barBorderWidth": 0,
				"barBorderColor": "#ccc"
			}
		}
	},
	"pie": {
		"itemStyle": {
			"normal": {
				"borderWidth": 0,
				"borderColor": "#ccc"
			},
			"emphasis": {
				"borderWidth": 0,
				"borderColor": "#ccc"
			}
		}
	},
	"scatter": {
		"itemStyle": {
			"normal": {
				"borderWidth": 0,
				"borderColor": "#ccc"
			},
			"emphasis": {
				"borderWidth": 0,
				"borderColor": "#ccc"
			}
		}
	},
	"boxplot": {
		"itemStyle": {
			"normal": {
				"borderWidth": 0,
				"borderColor": "#ccc"
			},
			"emphasis": {
				"borderWidth": 0,
				"borderColor": "#ccc"
			}
		}
	},
	"parallel": {
		"itemStyle": {
			"normal": {
				"borderWidth": 0,
				"borderColor": "#ccc"
			},
			"emphasis": {
				"borderWidth": 0,
				"borderColor": "#ccc"
			}
		}
	},
	"sankey": {
		"itemStyle": {
			"normal": {
				"borderWidth": 0,
				"borderColor": "#ccc"
			},
			"emphasis": {
				"borderWidth": 0,
				"borderColor": "#ccc"
			}
		}
	},
	"funnel": {
		"itemStyle": {
			"normal": {
				"borderWidth": 0,
				"borderColor": "#ccc"
			},
			"emphasis": {
				"borderWidth": 0,
				"borderColor": "#ccc"
			}
		}
	},
	"gauge": {
		"itemStyle": {
			"normal": {
				"borderWidth": 0,
				"borderColor": "#ccc"
			},
			"emphasis": {
				"borderWidth": 0,
				"borderColor": "#ccc"
			}
		}
	},
	"candlestick": {
		"itemStyle": {
			"normal": {
				"color": "#e6a0d2",
				"color0": "transparent",
				"borderColor": "#e6a0d2",
				"borderColor0": "#3fb1e3",
				"borderWidth": "2"
			}
		}
	},
	"graph": {
		"itemStyle": {
			"normal": {
				"borderWidth": 0,
				"borderColor": "#ccc"
			}
		},
		"lineStyle": {
			"normal": {
				"width": "1",
				"color": "#cccccc"
			}
		},
		"symbolSize": "11",
		"symbol": "emptyCircle",
		"smooth": false,
		"color": [
			"#23abeb",
			"#22d9a4",
			"#516ccc",
			"#a0a7e6",
			"#c4ebad",
			"#96dee8"
		],
		"label": {
			"normal": {
				"textStyle": {
					"color": "#ffffff"
				}
			}
		}
	},
	"map": {
		"itemStyle": {
			"normal": {
				"areaColor": "#eeeeee",
				"borderColor": "#aaaaaa",
				"borderWidth": 0.5
			},
			"emphasis": {
				"areaColor": "rgba(63,177,227,0.25)",
				"borderColor": "#3fb1e3",
				"borderWidth": 1
			}
		},
		"label": {
			"normal": {
				"textStyle": {
					"color": "#ffffff"
				}
			},
			"emphasis": {
				"textStyle": {
					"color": "rgb(63,177,227)"
				}
			}
		}
	},
	"geo": {
		"itemStyle": {
			"normal": {
				"areaColor": "#eeeeee",
				"borderColor": "#aaaaaa",
				"borderWidth": 0.5
			},
			"emphasis": {
				"areaColor": "rgba(63,177,227,0.25)",
				"borderColor": "#3fb1e3",
				"borderWidth": 1
			}
		},
		"label": {
			"normal": {
				"textStyle": {
					"color": "#ffffff"
				}
			},
			"emphasis": {
				"textStyle": {
					"color": "rgb(63,177,227)"
				}
			}
		}
	},
	"categoryAxis": {
		"axisLine": {
			"show": true,
			"lineStyle": {
				"color": "#cccccc"
			}
		},
		"axisTick": {
			"show": false,
			"lineStyle": {
				"color": "#333"
			}
		},
		"axisLabel": {
			"show": true,
			"textStyle": {
				"color": "#999999"
			}
		},
		"splitLine": {
			"show": true,
			"lineStyle": {
				"color": [
					"#eeeeee"
				]
			}
		},
		"splitArea": {
			"show": false,
			"areaStyle": {
				"color": [
					"rgba(250,250,250,0.05)",
					"rgba(200,200,200,0.02)"
				]
			}
		}
	},
	"valueAxis": {
		"axisLine": {
			"show": true,
			"lineStyle": {
				"color": "#cccccc"
			}
		},
		"axisTick": {
			"show": false,
			"lineStyle": {
				"color": "#333"
			}
		},
		"axisLabel": {
			"show": true,
			"textStyle": {
				"color": "#999999"
			}
		},
		"splitLine": {
			"show": true,
			"lineStyle": {
				"color": [
					"#eeeeee"
				]
			}
		},
		"splitArea": {
			"show": false,
			"areaStyle": {
				"color": [
					"rgba(250,250,250,0.05)",
					"rgba(200,200,200,0.02)"
				]
			}
		}
	},
	"logAxis": {
		"axisLine": {
			"show": true,
			"lineStyle": {
				"color": "#cccccc"
			}
		},
		"axisTick": {
			"show": false,
			"lineStyle": {
				"color": "#333"
			}
		},
		"axisLabel": {
			"show": true,
			"textStyle": {
				"color": "#999999"
			}
		},
		"splitLine": {
			"show": true,
			"lineStyle": {
				"color": [
					"#eeeeee"
				]
			}
		},
		"splitArea": {
			"show": false,
			"areaStyle": {
				"color": [
					"rgba(250,250,250,0.05)",
					"rgba(200,200,200,0.02)"
				]
			}
		}
	},
	"timeAxis": {
		"axisLine": {
			"show": true,
			"lineStyle": {
				"color": "#cccccc"
			}
		},
		"axisTick": {
			"show": false,
			"lineStyle": {
				"color": "#333"
			}
		},
		"axisLabel": {
			"show": true,
			"textStyle": {
				"color": "#999999"
			}
		},
		"splitLine": {
			"show": true,
			"lineStyle": {
				"color": [
					"#eeeeee"
				]
			}
		},
		"splitArea": {
			"show": false,
			"areaStyle": {
				"color": [
					"rgba(250,250,250,0.05)",
					"rgba(200,200,200,0.02)"
				]
			}
		}
	},
	"toolbox": {
		"iconStyle": {
			"normal": {
				"borderColor": "#999999"
			},
			"emphasis": {
				"borderColor": "#666666"
			}
		}
	},
	"legend": {
		"textStyle": {
			"color": "#999999"
		}
	},
	"tooltip": {
		"axisPointer": {
			"lineStyle": {
				"color": "#cccccc",
				"width": 1
			},
			"crossStyle": {
				"color": "#cccccc",
				"width": 1
			}
		}
	},
	"timeline": {
		"lineStyle": {
			"color": "#626c91",
			"width": 1
		},
		"itemStyle": {
			"normal": {
				"color": "#626c91",
				"borderWidth": 1
			},
			"emphasis": {
				"color": "#626c91"
			}
		},
		"controlStyle": {
			"normal": {
				"color": "#626c91",
				"borderColor": "#626c91",
				"borderWidth": 0.5
			},
			"emphasis": {
				"color": "#626c91",
				"borderColor": "#626c91",
				"borderWidth": 0.5
			}
		},
		"checkpointStyle": {
			"color": "#3fb1e3",
			"borderColor": "rgba(63,177,227,0.15)"
		},
		"label": {
			"normal": {
				"textStyle": {
					"color": "#626c91"
				}
			},
			"emphasis": {
				"textStyle": {
					"color": "#626c91"
				}
			}
		}
	},
	"visualMap": {
		"color": [
			"#2a99c9",
			"#afe8ff"
		]
	},
	"dataZoom": {
		"backgroundColor": "rgba(255,255,255,0)",
		"dataBackgroundColor": "rgba(222,222,222,1)",
		"fillerColor": "rgba(114,230,212,0.25)",
		"handleColor": "#cccccc",
		"handleSize": "100%",
		"textStyle": {
			"color": "#999999"
		}
	},
	"markPoint": {
		"label": {
			"normal": {
				"textStyle": {
					"color": "#ffffff"
				}
			},
			"emphasis": {
				"textStyle": {
					"color": "#ffffff"
				}
			}
		}
	}
};

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
//! version : 0.4.1
//! author : Tim Wood
//! license : MIT
//! github.com/moment/moment-timezone
!function(a,b){"use strict"; true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (b),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=b(require("moment")):b(a.moment)}(this,function(a){"use strict";function b(a){return a>96?a-87:a>64?a-29:a-48}function c(a){var c,d=0,e=a.split("."),f=e[0],g=e[1]||"",h=1,i=0,j=1;for(45===a.charCodeAt(0)&&(d=1,j=-1),d;d<f.length;d++)c=b(f.charCodeAt(d)),i=60*i+c;for(d=0;d<g.length;d++)h/=60,c=b(g.charCodeAt(d)),i+=c*h;return i*j}function d(a){for(var b=0;b<a.length;b++)a[b]=c(a[b])}function e(a,b){for(var c=0;b>c;c++)a[c]=Math.round((a[c-1]||0)+6e4*a[c]);a[b-1]=1/0}function f(a,b){var c,d=[];for(c=0;c<b.length;c++)d[c]=a[b[c]];return d}function g(a){var b=a.split("|"),c=b[2].split(" "),g=b[3].split(""),h=b[4].split(" ");return d(c),d(g),d(h),e(h,g.length),{name:b[0],abbrs:f(b[1].split(" "),g),offsets:f(c,g),untils:h}}function h(a){a&&this._set(g(a))}function i(a){return(a||"").toLowerCase().replace(/\//g,"_")}function j(a){var b,c,d;for("string"==typeof a&&(a=[a]),b=0;b<a.length;b++)c=a[b].split("|")[0],d=i(c),v[d]=a[b],x[d]=c}function k(a,b){a=i(a);var c,d=v[a];return d instanceof h?d:"string"==typeof d?(d=new h(d),v[a]=d,d):w[a]&&b!==k&&(c=k(w[a],k))?(d=v[a]=new h,d._set(c),d.name=x[a],d):null}function l(){var a,b=[];for(a in x)x.hasOwnProperty(a)&&(v[a]||v[w[a]])&&x[a]&&b.push(x[a]);return b.sort()}function m(a){var b,c,d,e;for("string"==typeof a&&(a=[a]),b=0;b<a.length;b++)c=a[b].split("|"),d=i(c[0]),e=i(c[1]),w[d]=e,x[d]=c[0],w[e]=d,x[e]=c[1]}function n(a){j(a.zones),m(a.links),r.dataVersion=a.version}function o(a){return o.didShowError||(o.didShowError=!0,q("moment.tz.zoneExists('"+a+"') has been deprecated in favor of !moment.tz.zone('"+a+"')")),!!k(a)}function p(a){return!(!a._a||void 0!==a._tzm)}function q(a){"undefined"!=typeof console&&"function"==typeof console.error&&console.error(a)}function r(b){var c=Array.prototype.slice.call(arguments,0,-1),d=arguments[arguments.length-1],e=k(d),f=a.utc.apply(null,c);return e&&!a.isMoment(b)&&p(f)&&f.add(e.parse(f),"minutes"),f.tz(d),f}function s(a){return function(){return this._z?this._z.abbr(this):a.call(this)}}function t(a){return function(){return this._z=null,a.apply(this,arguments)}}if(void 0!==a.tz)return q("Moment Timezone "+a.tz.version+" was already loaded "+(a.tz.dataVersion?"with data from ":"without any data")+a.tz.dataVersion),a;var u="0.4.1",v={},w={},x={},y=a.version.split("."),z=+y[0],A=+y[1];(2>z||2===z&&6>A)&&q("Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js "+a.version+". See momentjs.com"),h.prototype={_set:function(a){this.name=a.name,this.abbrs=a.abbrs,this.untils=a.untils,this.offsets=a.offsets},_index:function(a){var b,c=+a,d=this.untils;for(b=0;b<d.length;b++)if(c<d[b])return b},parse:function(a){var b,c,d,e,f=+a,g=this.offsets,h=this.untils,i=h.length-1;for(e=0;i>e;e++)if(b=g[e],c=g[e+1],d=g[e?e-1:e],c>b&&r.moveAmbiguousForward?b=c:b>d&&r.moveInvalidForward&&(b=d),f<h[e]-6e4*b)return g[e];return g[i]},abbr:function(a){return this.abbrs[this._index(a)]},offset:function(a){return this.offsets[this._index(a)]}},r.version=u,r.dataVersion="",r._zones=v,r._links=w,r._names=x,r.add=j,r.link=m,r.load=n,r.zone=k,r.zoneExists=o,r.names=l,r.Zone=h,r.unpack=g,r.unpackBase60=c,r.needsOffset=p,r.moveInvalidForward=!0,r.moveAmbiguousForward=!1;var B=a.fn;a.tz=r,a.defaultZone=null,a.updateOffset=function(b,c){var d,e=a.defaultZone;void 0===b._z&&(e&&p(b)&&!b._isUTC&&(b._d=a.utc(b._a)._d,b.utc().add(e.parse(b),"minutes")),b._z=e),b._z&&(d=b._z.offset(b),Math.abs(d)<16&&(d/=60),void 0!==b.utcOffset?b.utcOffset(-d,c):b.zone(d,c))},B.tz=function(b){return b?(this._z=k(b),this._z?a.updateOffset(this):q("Moment Timezone has no data for "+b+". See http://momentjs.com/timezone/docs/#/data-loading/."),this):this._z?this._z.name:void 0},B.zoneName=s(B.zoneName),B.zoneAbbr=s(B.zoneAbbr),B.utc=t(B.utc),a.tz.setDefault=function(b){return(2>z||2===z&&9>A)&&q("Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js "+a.version+"."),a.defaultZone=b?k(b):null,a};var C=a.momentProperties;return"[object Array]"===Object.prototype.toString.call(C)?(C.push("_z"),C.push("_a")):C&&(C._z=null),n({version:"2015g",zones:["Africa/Abidjan|GMT|0|0|","Africa/Addis_Ababa|EAT|-30|0|","Africa/Algiers|CET|-10|0|","Africa/Bangui|WAT|-10|0|","Africa/Blantyre|CAT|-20|0|","Africa/Cairo|EET EEST|-20 -30|010101010|1Cby0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0","Africa/Casablanca|WET WEST|0 -10|01010101010101010101010101010101010101010|1Cco0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0","Africa/Ceuta|CET CEST|-10 -20|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Africa/Johannesburg|SAST|-20|0|","Africa/Tripoli|EET CET CEST|-20 -10 -20|0120|1IlA0 TA0 1o00","Africa/Windhoek|WAST WAT|-20 -10|01010101010101010101010|1C1c0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0","America/Adak|HST HDT|a0 90|01010101010101010101010|1BR00 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Anchorage|AKST AKDT|90 80|01010101010101010101010|1BQX0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Anguilla|AST|40|0|","America/Araguaina|BRT BRST|30 20|010|1IdD0 Lz0","America/Argentina/Buenos_Aires|ART|30|0|","America/Asuncion|PYST PYT|30 40|01010101010101010101010|1C430 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0","America/Atikokan|EST|50|0|","America/Bahia|BRT BRST|30 20|010|1FJf0 Rb0","America/Bahia_Banderas|MST CDT CST|70 50 60|01212121212121212121212|1C1l0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0","America/Belem|BRT|30|0|","America/Belize|CST|60|0|","America/Boa_Vista|AMT|40|0|","America/Bogota|COT|50|0|","America/Boise|MST MDT|70 60|01010101010101010101010|1BQV0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Campo_Grande|AMST AMT|30 40|01010101010101010101010|1BIr0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10","America/Cancun|CST CDT EST|60 50 50|010101010102|1C1k0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0","America/Caracas|VET|4u|0|","America/Cayenne|GFT|30|0|","America/Cayman|EST EDT|50 40|01010101010|1Qtj0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Chicago|CST CDT|60 50|01010101010101010101010|1BQU0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Chihuahua|MST MDT|70 60|01010101010101010101010|1C1l0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0","America/Creston|MST|70|0|","America/Dawson|PST PDT|80 70|01010101010101010101010|1BQW0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Detroit|EST EDT|50 40|01010101010101010101010|1BQT0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Eirunepe|AMT ACT|40 50|01|1KLE0","America/Fort_Nelson|PST PDT MST|80 70 70|010101010102|1BQW0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0","America/Glace_Bay|AST ADT|40 30|01010101010101010101010|1BQS0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Godthab|WGT WGST|30 20|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","America/Goose_Bay|AST ADT|40 30|01010101010101010101010|1BQQ1 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Grand_Turk|EST EDT AST|50 40 40|0101010101012|1BQT0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Guayaquil|ECT|50|0|","America/Guyana|GYT|40|0|","America/Havana|CST CDT|50 40|01010101010101010101010|1BQR0 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0","America/La_Paz|BOT|40|0|","America/Lima|PET|50|0|","America/Merida|CST CDT|60 50|01010101010101010101010|1C1k0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0","America/Metlakatla|PST|80|0|","America/Miquelon|PMST PMDT|30 20|01010101010101010101010|1BQR0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Montevideo|UYST UYT|20 30|010101010101|1BQQ0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0","America/Noronha|FNT|20|0|","America/North_Dakota/Beulah|MST MDT CST CDT|70 60 60 50|01232323232323232323232|1BQV0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Paramaribo|SRT|30|0|","America/Port-au-Prince|EST EDT|50 40|0101010101010101010|1GI70 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","America/Santa_Isabel|PST PDT|80 70|01010101010101010101010|1C1m0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0","America/Santiago|CLST CLT CLT|30 40 30|010101010102|1C1f0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 1wn0","America/Sao_Paulo|BRST BRT|20 30|01010101010101010101010|1BIq0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10","America/Scoresbysund|EGT EGST|10 0|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","America/St_Johns|NST NDT|3u 2u|01010101010101010101010|1BQPv 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0","Antarctica/Casey|CAST AWST|-b0 -80|0101|1BN30 40P0 KL0","Antarctica/Davis|DAVT DAVT|-50 -70|0101|1BPw0 3Wn0 KN0","Antarctica/DumontDUrville|DDUT|-a0|0|","Antarctica/Macquarie|AEDT MIST|-b0 -b0|01|1C140","Antarctica/Mawson|MAWT|-50|0|","Antarctica/McMurdo|NZDT NZST|-d0 -c0|01010101010101010101010|1C120 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00","Antarctica/Rothera|ROTT|30|0|","Antarctica/Syowa|SYOT|-30|0|","Antarctica/Troll|UTC CEST|0 -20|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Antarctica/Vostok|VOST|-60|0|","Asia/Aden|AST|-30|0|","Asia/Almaty|ALMT|-60|0|","Asia/Amman|EET EEST|-20 -30|010101010101010101010|1BVy0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0","Asia/Anadyr|ANAT ANAST ANAT|-c0 -c0 -b0|0120|1BWe0 1qN0 WM0","Asia/Aqtau|AQTT|-50|0|","Asia/Ashgabat|TMT|-50|0|","Asia/Baku|AZT AZST|-40 -50|01010101010101010101010|1BWo0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Asia/Bangkok|ICT|-70|0|","Asia/Beirut|EET EEST|-20 -30|01010101010101010101010|1BWm0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0","Asia/Bishkek|KGT|-60|0|","Asia/Brunei|BNT|-80|0|","Asia/Calcutta|IST|-5u|0|","Asia/Chita|YAKT YAKST YAKT IRKT|-90 -a0 -a0 -80|01023|1BWh0 1qM0 WM0 8Hz0","Asia/Choibalsan|CHOT CHOST|-80 -90|0101010101010|1O8G0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0","Asia/Chongqing|CST|-80|0|","Asia/Dacca|BDT|-60|0|","Asia/Damascus|EET EEST|-20 -30|01010101010101010101010|1C0m0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0","Asia/Dili|TLT|-90|0|","Asia/Dubai|GST|-40|0|","Asia/Dushanbe|TJT|-50|0|","Asia/Gaza|EET EEST|-20 -30|01010101010101010101010|1BVW1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1210 1nz0 14N0 1nz0 1210 1nz0 1210 1nz0 1210 1nz0","Asia/Hebron|EET EEST|-20 -30|0101010101010101010101010|1BVy0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1210 1nz0 14N0 1nz0 1210 1nz0 1210 1nz0 1210 1nz0","Asia/Hong_Kong|HKT|-80|0|","Asia/Hovd|HOVT HOVST|-70 -80|0101010101010|1O8H0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0","Asia/Irkutsk|IRKT IRKST IRKT|-80 -90 -90|01020|1BWi0 1qM0 WM0 8Hz0","Asia/Istanbul|EET EEST|-20 -30|01010101010101010101010|1BWp0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Asia/Jakarta|WIB|-70|0|","Asia/Jayapura|WIT|-90|0|","Asia/Jerusalem|IST IDT|-20 -30|01010101010101010101010|1BVA0 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0","Asia/Kabul|AFT|-4u|0|","Asia/Kamchatka|PETT PETST PETT|-c0 -c0 -b0|0120|1BWe0 1qN0 WM0","Asia/Karachi|PKT|-50|0|","Asia/Kashgar|XJT|-60|0|","Asia/Kathmandu|NPT|-5J|0|","Asia/Khandyga|VLAT VLAST VLAT YAKT YAKT|-a0 -b0 -b0 -a0 -90|010234|1BWg0 1qM0 WM0 17V0 7zD0","Asia/Krasnoyarsk|KRAT KRAST KRAT|-70 -80 -80|01020|1BWj0 1qM0 WM0 8Hz0","Asia/Kuala_Lumpur|MYT|-80|0|","Asia/Magadan|MAGT MAGST MAGT MAGT|-b0 -c0 -c0 -a0|01023|1BWf0 1qM0 WM0 8Hz0","Asia/Makassar|WITA|-80|0|","Asia/Manila|PHT|-80|0|","Asia/Nicosia|EET EEST|-20 -30|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Asia/Novokuznetsk|KRAT NOVST NOVT NOVT|-70 -70 -60 -70|01230|1BWj0 1qN0 WM0 8Hz0","Asia/Novosibirsk|NOVT NOVST NOVT|-60 -70 -70|01020|1BWk0 1qM0 WM0 8Hz0","Asia/Omsk|OMST OMSST OMST|-60 -70 -70|01020|1BWk0 1qM0 WM0 8Hz0","Asia/Oral|ORAT|-50|0|","Asia/Pyongyang|KST KST|-90 -8u|01|1P4D0","Asia/Qyzylorda|QYZT|-60|0|","Asia/Rangoon|MMT|-6u|0|","Asia/Sakhalin|SAKT SAKST SAKT|-a0 -b0 -b0|01020|1BWg0 1qM0 WM0 8Hz0","Asia/Samarkand|UZT|-50|0|","Asia/Seoul|KST|-90|0|","Asia/Singapore|SGT|-80|0|","Asia/Srednekolymsk|MAGT MAGST MAGT SRET|-b0 -c0 -c0 -b0|01023|1BWf0 1qM0 WM0 8Hz0","Asia/Tbilisi|GET|-40|0|","Asia/Tehran|IRST IRDT|-3u -4u|01010101010101010101010|1BTUu 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0","Asia/Thimbu|BTT|-60|0|","Asia/Tokyo|JST|-90|0|","Asia/Ulaanbaatar|ULAT ULAST|-80 -90|0101010101010|1O8G0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0","Asia/Ust-Nera|MAGT MAGST MAGT VLAT VLAT|-b0 -c0 -c0 -b0 -a0|010234|1BWf0 1qM0 WM0 17V0 7zD0","Asia/Vladivostok|VLAT VLAST VLAT|-a0 -b0 -b0|01020|1BWg0 1qM0 WM0 8Hz0","Asia/Yakutsk|YAKT YAKST YAKT|-90 -a0 -a0|01020|1BWh0 1qM0 WM0 8Hz0","Asia/Yekaterinburg|YEKT YEKST YEKT|-50 -60 -60|01020|1BWl0 1qM0 WM0 8Hz0","Asia/Yerevan|AMT AMST|-40 -50|01010|1BWm0 1qM0 WM0 1qM0","Atlantic/Azores|AZOT AZOST|10 0|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Atlantic/Canary|WET WEST|0 -10|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Atlantic/Cape_Verde|CVT|10|0|","Atlantic/South_Georgia|GST|20|0|","Atlantic/Stanley|FKST FKT|30 40|010|1C6R0 U10","Australia/ACT|AEDT AEST|-b0 -a0|01010101010101010101010|1C140 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0","Australia/Adelaide|ACDT ACST|-au -9u|01010101010101010101010|1C14u 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0","Australia/Brisbane|AEST|-a0|0|","Australia/Darwin|ACST|-9u|0|","Australia/Eucla|ACWST|-8J|0|","Australia/LHI|LHDT LHST|-b0 -au|01010101010101010101010|1C130 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu","Australia/Perth|AWST|-80|0|","Chile/EasterIsland|EASST EAST EAST|50 60 50|010101010102|1C1f0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 1wn0","Eire|GMT IST|0 -10|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Etc/GMT+1|GMT+1|10|0|","Etc/GMT+10|GMT+10|a0|0|","Etc/GMT+11|GMT+11|b0|0|","Etc/GMT+12|GMT+12|c0|0|","Etc/GMT+2|GMT+2|20|0|","Etc/GMT+3|GMT+3|30|0|","Etc/GMT+4|GMT+4|40|0|","Etc/GMT+5|GMT+5|50|0|","Etc/GMT+6|GMT+6|60|0|","Etc/GMT+7|GMT+7|70|0|","Etc/GMT+8|GMT+8|80|0|","Etc/GMT+9|GMT+9|90|0|","Etc/GMT-1|GMT-1|-10|0|","Etc/GMT-10|GMT-10|-a0|0|","Etc/GMT-11|GMT-11|-b0|0|","Etc/GMT-12|GMT-12|-c0|0|","Etc/GMT-13|GMT-13|-d0|0|","Etc/GMT-14|GMT-14|-e0|0|","Etc/GMT-2|GMT-2|-20|0|","Etc/GMT-3|GMT-3|-30|0|","Etc/GMT-4|GMT-4|-40|0|","Etc/GMT-5|GMT-5|-50|0|","Etc/GMT-6|GMT-6|-60|0|","Etc/GMT-7|GMT-7|-70|0|","Etc/GMT-8|GMT-8|-80|0|","Etc/GMT-9|GMT-9|-90|0|","Etc/UCT|UCT|0|0|","Etc/UTC|UTC|0|0|","Europe/Belfast|GMT BST|0 -10|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Chisinau|EET EEST|-20 -30|01010101010101010101010|1BWo0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","Europe/Kaliningrad|EET EEST FET|-20 -30 -30|01020|1BWo0 1qM0 WM0 8Hz0","Europe/Minsk|EET EEST FET MSK|-20 -30 -30 -30|01023|1BWo0 1qM0 WM0 8Hy0","Europe/Moscow|MSK MSD MSK|-30 -40 -40|01020|1BWn0 1qM0 WM0 8Hz0","Europe/Samara|SAMT SAMST SAMT|-40 -40 -30|0120|1BWm0 1qN0 WM0","Europe/Simferopol|EET EEST MSK MSK|-20 -30 -40 -30|01010101023|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0","HST|HST|a0|0|","Indian/Chagos|IOT|-60|0|","Indian/Christmas|CXT|-70|0|","Indian/Cocos|CCT|-6u|0|","Indian/Kerguelen|TFT|-50|0|","Indian/Mahe|SCT|-40|0|","Indian/Maldives|MVT|-50|0|","Indian/Mauritius|MUT|-40|0|","Indian/Reunion|RET|-40|0|","Kwajalein|MHT|-c0|0|","MET|MET MEST|-10 -20|01010101010101010101010|1BWp0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00","NZ-CHAT|CHADT CHAST|-dJ -cJ|01010101010101010101010|1C120 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00","Pacific/Apia|SST SDT WSDT WSST|b0 a0 -e0 -d0|01012323232323232323232|1Dbn0 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00","Pacific/Bougainville|PGT BST|-a0 -b0|01|1NwE0","Pacific/Chuuk|CHUT|-a0|0|","Pacific/Efate|VUT|-b0|0|","Pacific/Enderbury|PHOT|-d0|0|","Pacific/Fakaofo|TKT TKT|b0 -d0|01|1Gfn0","Pacific/Fiji|FJST FJT|-d0 -c0|01010101010101010101010|1BWe0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0","Pacific/Funafuti|TVT|-c0|0|","Pacific/Galapagos|GALT|60|0|","Pacific/Gambier|GAMT|90|0|","Pacific/Guadalcanal|SBT|-b0|0|","Pacific/Guam|ChST|-a0|0|","Pacific/Kiritimati|LINT|-e0|0|","Pacific/Kosrae|KOST|-b0|0|","Pacific/Marquesas|MART|9u|0|","Pacific/Midway|SST|b0|0|","Pacific/Nauru|NRT|-c0|0|","Pacific/Niue|NUT|b0|0|","Pacific/Norfolk|NFT NFT|-bu -b0|01|1PoCu","Pacific/Noumea|NCT|-b0|0|","Pacific/Palau|PWT|-90|0|","Pacific/Pohnpei|PONT|-b0|0|","Pacific/Port_Moresby|PGT|-a0|0|","Pacific/Rarotonga|CKT|a0|0|","Pacific/Tahiti|TAHT|a0|0|","Pacific/Tarawa|GILT|-c0|0|","Pacific/Tongatapu|TOT|-d0|0|","Pacific/Wake|WAKT|-c0|0|","Pacific/Wallis|WFT|-c0|0|"],links:["Africa/Abidjan|Africa/Accra","Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Bissau","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Monrovia","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Sao_Tome","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|America/Danmarkshavn","Africa/Abidjan|Atlantic/Reykjavik","Africa/Abidjan|Atlantic/St_Helena","Africa/Abidjan|Etc/GMT","Africa/Abidjan|Etc/GMT+0","Africa/Abidjan|Etc/GMT-0","Africa/Abidjan|Etc/GMT0","Africa/Abidjan|Etc/Greenwich","Africa/Abidjan|GMT","Africa/Abidjan|GMT+0","Africa/Abidjan|GMT-0","Africa/Abidjan|GMT0","Africa/Abidjan|Greenwich","Africa/Abidjan|Iceland","Africa/Addis_Ababa|Africa/Asmara","Africa/Addis_Ababa|Africa/Asmera","Africa/Addis_Ababa|Africa/Dar_es_Salaam","Africa/Addis_Ababa|Africa/Djibouti","Africa/Addis_Ababa|Africa/Juba","Africa/Addis_Ababa|Africa/Kampala","Africa/Addis_Ababa|Africa/Khartoum","Africa/Addis_Ababa|Africa/Mogadishu","Africa/Addis_Ababa|Africa/Nairobi","Africa/Addis_Ababa|Indian/Antananarivo","Africa/Addis_Ababa|Indian/Comoro","Africa/Addis_Ababa|Indian/Mayotte","Africa/Algiers|Africa/Tunis","Africa/Bangui|Africa/Brazzaville","Africa/Bangui|Africa/Douala","Africa/Bangui|Africa/Kinshasa","Africa/Bangui|Africa/Lagos","Africa/Bangui|Africa/Libreville","Africa/Bangui|Africa/Luanda","Africa/Bangui|Africa/Malabo","Africa/Bangui|Africa/Ndjamena","Africa/Bangui|Africa/Niamey","Africa/Bangui|Africa/Porto-Novo","Africa/Blantyre|Africa/Bujumbura","Africa/Blantyre|Africa/Gaborone","Africa/Blantyre|Africa/Harare","Africa/Blantyre|Africa/Kigali","Africa/Blantyre|Africa/Lubumbashi","Africa/Blantyre|Africa/Lusaka","Africa/Blantyre|Africa/Maputo","Africa/Cairo|Egypt","Africa/Casablanca|Africa/El_Aaiun","Africa/Ceuta|Arctic/Longyearbyen","Africa/Ceuta|Atlantic/Jan_Mayen","Africa/Ceuta|CET","Africa/Ceuta|Europe/Amsterdam","Africa/Ceuta|Europe/Andorra","Africa/Ceuta|Europe/Belgrade","Africa/Ceuta|Europe/Berlin","Africa/Ceuta|Europe/Bratislava","Africa/Ceuta|Europe/Brussels","Africa/Ceuta|Europe/Budapest","Africa/Ceuta|Europe/Busingen","Africa/Ceuta|Europe/Copenhagen","Africa/Ceuta|Europe/Gibraltar","Africa/Ceuta|Europe/Ljubljana","Africa/Ceuta|Europe/Luxembourg","Africa/Ceuta|Europe/Madrid","Africa/Ceuta|Europe/Malta","Africa/Ceuta|Europe/Monaco","Africa/Ceuta|Europe/Oslo","Africa/Ceuta|Europe/Paris","Africa/Ceuta|Europe/Podgorica","Africa/Ceuta|Europe/Prague","Africa/Ceuta|Europe/Rome","Africa/Ceuta|Europe/San_Marino","Africa/Ceuta|Europe/Sarajevo","Africa/Ceuta|Europe/Skopje","Africa/Ceuta|Europe/Stockholm","Africa/Ceuta|Europe/Tirane","Africa/Ceuta|Europe/Vaduz","Africa/Ceuta|Europe/Vatican","Africa/Ceuta|Europe/Vienna","Africa/Ceuta|Europe/Warsaw","Africa/Ceuta|Europe/Zagreb","Africa/Ceuta|Europe/Zurich","Africa/Ceuta|Poland","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|America/Juneau","America/Anchorage|America/Nome","America/Anchorage|America/Sitka","America/Anchorage|America/Yakutat","America/Anchorage|US/Alaska","America/Anguilla|America/Antigua","America/Anguilla|America/Aruba","America/Anguilla|America/Barbados","America/Anguilla|America/Blanc-Sablon","America/Anguilla|America/Curacao","America/Anguilla|America/Dominica","America/Anguilla|America/Grenada","America/Anguilla|America/Guadeloupe","America/Anguilla|America/Kralendijk","America/Anguilla|America/Lower_Princes","America/Anguilla|America/Marigot","America/Anguilla|America/Martinique","America/Anguilla|America/Montserrat","America/Anguilla|America/Port_of_Spain","America/Anguilla|America/Puerto_Rico","America/Anguilla|America/Santo_Domingo","America/Anguilla|America/St_Barthelemy","America/Anguilla|America/St_Kitts","America/Anguilla|America/St_Lucia","America/Anguilla|America/St_Thomas","America/Anguilla|America/St_Vincent","America/Anguilla|America/Tortola","America/Anguilla|America/Virgin","America/Argentina/Buenos_Aires|America/Argentina/Catamarca","America/Argentina/Buenos_Aires|America/Argentina/ComodRivadavia","America/Argentina/Buenos_Aires|America/Argentina/Cordoba","America/Argentina/Buenos_Aires|America/Argentina/Jujuy","America/Argentina/Buenos_Aires|America/Argentina/La_Rioja","America/Argentina/Buenos_Aires|America/Argentina/Mendoza","America/Argentina/Buenos_Aires|America/Argentina/Rio_Gallegos","America/Argentina/Buenos_Aires|America/Argentina/Salta","America/Argentina/Buenos_Aires|America/Argentina/San_Juan","America/Argentina/Buenos_Aires|America/Argentina/San_Luis","America/Argentina/Buenos_Aires|America/Argentina/Tucuman","America/Argentina/Buenos_Aires|America/Argentina/Ushuaia","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Buenos_Aires|America/Catamarca","America/Argentina/Buenos_Aires|America/Cordoba","America/Argentina/Buenos_Aires|America/Jujuy","America/Argentina/Buenos_Aires|America/Mendoza","America/Argentina/Buenos_Aires|America/Rosario","America/Atikokan|America/Coral_Harbour","America/Atikokan|America/Jamaica","America/Atikokan|America/Panama","America/Atikokan|EST","America/Atikokan|Jamaica","America/Belem|America/Fortaleza","America/Belem|America/Maceio","America/Belem|America/Recife","America/Belem|America/Santarem","America/Belize|America/Costa_Rica","America/Belize|America/El_Salvador","America/Belize|America/Guatemala","America/Belize|America/Managua","America/Belize|America/Regina","America/Belize|America/Swift_Current","America/Belize|America/Tegucigalpa","America/Belize|Canada/East-Saskatchewan","America/Belize|Canada/Saskatchewan","America/Boa_Vista|America/Manaus","America/Boa_Vista|America/Porto_Velho","America/Boa_Vista|Brazil/West","America/Boise|America/Cambridge_Bay","America/Boise|America/Denver","America/Boise|America/Edmonton","America/Boise|America/Inuvik","America/Boise|America/Ojinaga","America/Boise|America/Shiprock","America/Boise|America/Yellowknife","America/Boise|Canada/Mountain","America/Boise|MST7MDT","America/Boise|Navajo","America/Boise|US/Mountain","America/Campo_Grande|America/Cuiaba","America/Chicago|America/Indiana/Knox","America/Chicago|America/Indiana/Tell_City","America/Chicago|America/Knox_IN","America/Chicago|America/Matamoros","America/Chicago|America/Menominee","America/Chicago|America/North_Dakota/Center","America/Chicago|America/North_Dakota/New_Salem","America/Chicago|America/Rainy_River","America/Chicago|America/Rankin_Inlet","America/Chicago|America/Resolute","America/Chicago|America/Winnipeg","America/Chicago|CST6CDT","America/Chicago|Canada/Central","America/Chicago|US/Central","America/Chicago|US/Indiana-Starke","America/Chihuahua|America/Mazatlan","America/Chihuahua|Mexico/BajaSur","America/Creston|America/Dawson_Creek","America/Creston|America/Hermosillo","America/Creston|America/Phoenix","America/Creston|MST","America/Creston|US/Arizona","America/Dawson|America/Ensenada","America/Dawson|America/Los_Angeles","America/Dawson|America/Tijuana","America/Dawson|America/Vancouver","America/Dawson|America/Whitehorse","America/Dawson|Canada/Pacific","America/Dawson|Canada/Yukon","America/Dawson|Mexico/BajaNorte","America/Dawson|PST8PDT","America/Dawson|US/Pacific","America/Dawson|US/Pacific-New","America/Detroit|America/Fort_Wayne","America/Detroit|America/Indiana/Indianapolis","America/Detroit|America/Indiana/Marengo","America/Detroit|America/Indiana/Petersburg","America/Detroit|America/Indiana/Vevay","America/Detroit|America/Indiana/Vincennes","America/Detroit|America/Indiana/Winamac","America/Detroit|America/Indianapolis","America/Detroit|America/Iqaluit","America/Detroit|America/Kentucky/Louisville","America/Detroit|America/Kentucky/Monticello","America/Detroit|America/Louisville","America/Detroit|America/Montreal","America/Detroit|America/Nassau","America/Detroit|America/New_York","America/Detroit|America/Nipigon","America/Detroit|America/Pangnirtung","America/Detroit|America/Thunder_Bay","America/Detroit|America/Toronto","America/Detroit|Canada/Eastern","America/Detroit|EST5EDT","America/Detroit|US/East-Indiana","America/Detroit|US/Eastern","America/Detroit|US/Michigan","America/Eirunepe|America/Porto_Acre","America/Eirunepe|America/Rio_Branco","America/Eirunepe|Brazil/Acre","America/Glace_Bay|America/Halifax","America/Glace_Bay|America/Moncton","America/Glace_Bay|America/Thule","America/Glace_Bay|Atlantic/Bermuda","America/Glace_Bay|Canada/Atlantic","America/Havana|Cuba","America/Merida|America/Mexico_City","America/Merida|America/Monterrey","America/Merida|Mexico/General","America/Metlakatla|Pacific/Pitcairn","America/Noronha|Brazil/DeNoronha","America/Santiago|Antarctica/Palmer","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","Antarctica/McMurdo|Antarctica/South_Pole","Antarctica/McMurdo|NZ","Antarctica/McMurdo|Pacific/Auckland","Asia/Aden|Asia/Baghdad","Asia/Aden|Asia/Bahrain","Asia/Aden|Asia/Kuwait","Asia/Aden|Asia/Qatar","Asia/Aden|Asia/Riyadh","Asia/Aqtau|Asia/Aqtobe","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Ho_Chi_Minh","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Saigon","Asia/Bangkok|Asia/Vientiane","Asia/Calcutta|Asia/Colombo","Asia/Calcutta|Asia/Kolkata","Asia/Chongqing|Asia/Chungking","Asia/Chongqing|Asia/Harbin","Asia/Chongqing|Asia/Macao","Asia/Chongqing|Asia/Macau","Asia/Chongqing|Asia/Shanghai","Asia/Chongqing|Asia/Taipei","Asia/Chongqing|PRC","Asia/Chongqing|ROC","Asia/Dacca|Asia/Dhaka","Asia/Dubai|Asia/Muscat","Asia/Hong_Kong|Hongkong","Asia/Istanbul|Europe/Istanbul","Asia/Istanbul|Turkey","Asia/Jakarta|Asia/Pontianak","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kashgar|Asia/Urumqi","Asia/Kathmandu|Asia/Katmandu","Asia/Kuala_Lumpur|Asia/Kuching","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|EET","Asia/Nicosia|Europe/Athens","Asia/Nicosia|Europe/Bucharest","Asia/Nicosia|Europe/Helsinki","Asia/Nicosia|Europe/Kiev","Asia/Nicosia|Europe/Mariehamn","Asia/Nicosia|Europe/Nicosia","Asia/Nicosia|Europe/Riga","Asia/Nicosia|Europe/Sofia","Asia/Nicosia|Europe/Tallinn","Asia/Nicosia|Europe/Uzhgorod","Asia/Nicosia|Europe/Vilnius","Asia/Nicosia|Europe/Zaporozhye","Asia/Samarkand|Asia/Tashkent","Asia/Seoul|ROK","Asia/Singapore|Singapore","Asia/Tehran|Iran","Asia/Thimbu|Asia/Thimphu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Atlantic/Canary|Atlantic/Faeroe","Atlantic/Canary|Atlantic/Faroe","Atlantic/Canary|Atlantic/Madeira","Atlantic/Canary|Europe/Lisbon","Atlantic/Canary|Portugal","Atlantic/Canary|WET","Australia/ACT|Australia/Canberra","Australia/ACT|Australia/Currie","Australia/ACT|Australia/Hobart","Australia/ACT|Australia/Melbourne","Australia/ACT|Australia/NSW","Australia/ACT|Australia/Sydney","Australia/ACT|Australia/Tasmania","Australia/ACT|Australia/Victoria","Australia/Adelaide|Australia/Broken_Hill","Australia/Adelaide|Australia/South","Australia/Adelaide|Australia/Yancowinna","Australia/Brisbane|Australia/Lindeman","Australia/Brisbane|Australia/Queensland","Australia/Darwin|Australia/North","Australia/LHI|Australia/Lord_Howe","Australia/Perth|Australia/West","Chile/EasterIsland|Pacific/Easter","Eire|Europe/Dublin","Etc/UCT|UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belfast|Europe/Guernsey","Europe/Belfast|Europe/Isle_of_Man","Europe/Belfast|Europe/Jersey","Europe/Belfast|Europe/London","Europe/Belfast|GB","Europe/Belfast|GB-Eire","Europe/Chisinau|Europe/Tiraspol","Europe/Moscow|Europe/Volgograd","Europe/Moscow|W-SU","HST|Pacific/Honolulu","HST|Pacific/Johnston","HST|US/Hawaii","Kwajalein|Pacific/Kwajalein","Kwajalein|Pacific/Majuro","NZ-CHAT|Pacific/Chatham","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Guam|Pacific/Saipan","Pacific/Midway|Pacific/Pago_Pago","Pacific/Midway|Pacific/Samoa","Pacific/Midway|US/Samoa","Pacific/Pohnpei|Pacific/Ponape"]}),a});

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(446);
module.exports = __webpack_require__(445);


/***/ })
],[1189]);


// WEBPACK FOOTER //
// static/js/app.07576cab2ad417cc0a40.js